export default {
    bioDataTable:{
        showing:"Showing",
        to:"to",
        of:"of",
        entries:"Entries",
        search: "Search",
        operate:"Operate",
        noData:"No data",
        add:"Create",
        addItem:"Add Record",
        export:"Export",
        searchInfo:"Please enter the query information",
        uploadFile:"Load Attachment",
        downloadFile:"Download file",
        viewReport:"View report",

    },
    login:{
        login: 'Login',
        forget_password:"Forget password",
        reset_password:"Reset password",
        bio:"Bio-LIMS",
        bio_serve:"Serving the global precision medicine and innovative bio-pharmaceutical industry",
        bio_scheme:"Full digital solution",
        bio_number:"Digital empowerment · drive change",
        bio_copyright:"The copyright of this system belongs to Beijing Bio-LIMS Software Technology Co., Ltd",
        bio_system:"Bio-LIMS smart laboratory management system",
        in_userName:"Enter one user name",
        in_password:"Please input a password",
        in_oldPassword:"Please enter the original password",
        in_newPassword:"Please enter a new password",
        in_oldPassword2:"Please enter the original password",
        confirmPassword:"Confirm new password",
        confirm:"Confirm",
        cancel:"cancel",
        in_email:"Please enter email",
        in_verificationCode:"Please enter the verification code",
        verificationCode:"Get verification code",
        userName_null:"Account number cannot be empty",
        password_null:"Password cannot be empty",
        password_format:"Incorrect password format",
        email_null:"Mailbox does not exist",
        verificationCode_expire:"The verification code has expired",
        password_success:"Password modified successfully",
        again:"Seconds resend ",
        verificationCode_success:"Verification code sent successfully",
        password_same:"Password is consistent",
        password_noSame:"Password is inconsistent",
        error:"The user name or password is incorrect. Please re-enter",

        success:"Login successful",
        oldPasswordError:"The original password is incorrect",
        verificationCodeNull:"Verification code cannot be empty",
    },
    //主页
    dashboard: {
        bioChat:"AI Intelligent Assistant",
        //流程执行待办
        processExecutionToDoList: {
            title: "Process experiment to be done",
            orderNumber: "Order number",
            stepName: "Step name",
            traceabilityCode: "Traceability code",
            operator: "Operator",
            stepNumberumber: "Step number",
            operate: "operate",
        }
    },
    crmCustomer:{
        cName:"Customer Information",
    },
    crmCustomerList:{
        homepage:"home",
        num: "from {first} to {last}, total {totalRecords} ",
        num1:"Show No ",
        num2:" Items to ",
        num3:" Data for, all total ",
        num4:" Data",
        newlyBuild:"newly build",
        derive:"export",
        information:"Please enter the query information",
        id:"Customer ID",
        name:"Customer Name",
        district:"District",
        type:"Type",
        street:"Street",
        postcode:"Post Code",
        email:"Email",
        researchField:"Research Field",
        dutyMan:"Person In Charge",
        phone:"Contact Number",
        state:"State",
        createUser:"Creator",
        createDate:"Create Time",
    },
    // crmCustomerEdit:{
    //     id:"ID",
    //     name:"Name",
    //     district:"District",
    //     type:"Type",
    //     street:"Street",
    //     postcode:"Post code",
    //     email:"Email",
    //     researchField:"Research Field",
    //     dutyMan:"Person In Charge",
    //     phone:"Contact Number",
    //     state:"State",
    //     createUser:"Creator",
    //     createDate:"Create Date",
    //     choose:"Please select a record !",
    // },

    crmCustomerEdit: {
        cName: "医院管理",
        id: "编号",
        name: "名称",
        district: "地区",
        type: "分类",
        street: "地址",
        postcode: "邮编",
        email: "邮箱",
        researchField: "研究领域",
        dutyMan: "负责人",
        phone: "电话",
        state: "状态",
        createUser: "创建人",
        createDate: "创建时间",
        choose: "请选择分类",
        saveSuccess: "保存成功",
        updateSuccess: "修改成功",
        file: "附件",
        upload: "上传附件",
        view: "查看附件",
        addSuccess: "添加成功",
        uploadSuccess: "上传成功",
        download: "下载",
        delete: "删除",
        tips: "请选择一条数据",
        batchAdd: "批量添加",
        nameRequired: "名称不能为空",
        dutyManRequired: "负责人不能为空",
        stateRequired: "状态不能为空",

        downloadTemplate: "下载模板",
        batchImport: "批量导入",

        department: "科室",
        depName: "科室名称",

        pleaseSelect: "请选择数据",
        ifDelete: "是否确认删除？",
        cancel: "您已取消！",
        deleteSuccess: "删除成功",

        searchInfo: "请输入查询的信息",

        fileName: "文件名",
        uploadTime: "上传时间",
        uploadUser: "上传人",

        postCodeError: "请输入正确的邮编",
        emailError: "请输入正确的邮箱",
        phoneError: "请输入正确的电话",

        saveFirst:"请先保存数据",
    },

    crmCustomerPublic:{
        dictionary:"dictionary",
        operation:"Operate",
    },
    crmCustomerDic:{
        chooseAddr:"please Select address",
        chooseType:"please Select type",
        chooseState:"please Select state",
        chooseUser:"please Select user",
        id:"id",
        name:"name",
        cycle:"cycle",
        post:"post",
    },

    customerDoctorEdit: {
        cName: "医生管理",
        id: "编号",
        name: "姓名",
        crmCustomer: "所属医院/机构",
        crmCustomerDepartment: "所属科室",
        phone: "联系电话",
        email: "邮箱",
        lookType: "就诊特点",
        goodAt: "擅长疾病/科研领域",
        doctorDesc: "医生简介",
        state: "状态",

        customerName: "医院名称",
        district: "地区",
        address: "地址",
        researchField: "研究领域",

        departmentName: "科室名称",

        saveSuccess: "保存成功",
        updateSuccess: "修改成功",
        choose: "请选择一条数据！",
        choose2: "请选择所属科室",
        phoneError: "请输入正确的联系电话",
        emailError:"请输入正确的邮箱",
        nameRequired: "姓名不能为空",
        crmCustomerRequired: "所属医院或机构不能为空",
        stateRequired: "状态不能为空",
    },

    //培训计划
    trainingPlan:{
        topic:"Training Plan",

    },
    trainingPlanList:{
        deleteInfo:"Deleted Succeed",
        submitInfo:"submit success",
        successInfo:"complete success",
    },
    trainingPlanEdit:{
        name:"name",
        name1:"name",
        username:"username",
        FileCoding:"FileCoding",
        FileName:"FileName",
        uploader:"uploader",
        uploadTime:"uploadTime",
        note:"note",
        participant:"group number",
        groupname:"group name",
        dateId:"dateId",
        dateDetails:"dateDetails",
        dateName:"dateName",
        type:"type",
    },
    //培训记录
    trainingRecord:{
        topic:"TrainingRecord",
    } ,

    trainingRecordList:{
        id:"id",
        description:"description",
        trainTyte:"trainTyte",
        applicant:"applicant",
        stateName:"State",
        createDate:"createDate",
    },
    //培训记录基本信息
    trainingRecordEdit:{
        id:"id",
        trainingId:"trainingId",
        trainingName:"description",
        trainingType:"trainingType",
        trainingModus:"trainingModus",
        trainingEffectiveness:"training prescription",
        trainingRemind:"trainingRemind (day)",
        trainingDuration:"trainingDuration(hour)",
        createUser:"create user",
        createDate:"create date",
        confirmUser:"applyEdit",
        chooseConfirmUser:"please Select user",
        chooseTrainingGroup:"please Select training group",
        chooseTrainer:"please Select Trainer",
        chooseFileType:"please Select file type",
        confirmDate:"Confirm date",
        trainingTeacher:"training teacher",
        note:"note",
        stateName:"State",
        startTrain:"start train",
        startTrainYes:"start train",
        KnowledgeCenter:"Knowledge Center",
        File:"File",
        attachment:"attachment",
        trainingGroup:"training group",
        trainingDate:"training date",
        trainingEndDate:"training end date",
        assess:"assess",
        assessResult:"assess result",
        department:"department",
        trainingMaterials:"training materials",
        chooseData:"please Select Data",
        chooseFile:"please Select File",
    },
    //培训明细
    trainingRecordDetail:{
        fileId:"fileId",
        fileDetail:"fileDetail",
        participant:"participant",
        createDate:"training date",
        trainingEndDate:"training end date",
        assess:"assess",
        assessResult:"assess result",
        department:"department",
        delDetails:"delete details",
        dataBinding:"data binding",
        viewDate:"view data",
        trainingRecordDetail:"training record detail",
    },
    //考题
    trainingRecordQuestion:{
        questionCode:"question code",
        questionData:"question data",
        fileId:"fileId",
        fileName:"file name",
        options:"options",
        questionType:"question type",
        trainingEffectiveness:"standard answer",
        questionContent:"question content",
        answerOptions:"answer options",
        addOption:"Create options",
        trainingRecordQuestion:"training record question",
        viewQuestion:"view question",
    },
    //考核
    trainingRecordAnswer:{
        trainingRecordAnswer:"training record answer",
        questionCode:"question code",
        fileId:"fileId",
        // fileName:"file name",
        questionContent:"question content",
        subQuestionContent:"submit question content",
        questionType:"question type",
        options:"options",
        participant:"participant",
        assessmentAnswer:"assessment answer",
        achievement:"achievement",
        answer:"answer",
    },

    order:{
        selectProduct:"Select products",
        selectedProduct:"Selected product"
    },
    appBreadcrumb:{
        welcome2:"Welcome",
    },
    documentation:{
        workbench:"workbench",
        homepage:"homepage",
    },
    BarCodeData: {
        name1: "条码模块",
        homepage: "主页",
        num: "展示第 {first} 条到第 {last} 条的数据 ，共 {totalRecords} 条数据 ",
        num1: "展示第",
        num2: "条到第",
        num3: "条的数据 ，共",
        num4: "条数据",
        newlyBuild: "新建",
        derive: "导出",
        information: "请输入查询的信息",
        id: "编码",
        name: "描述",
        code: "打印指令",
        ip: "IP地址",
        state: "状态",
        operation: "操作",
        effective: "有效",
        invalid: "无效",
        del: "删除选中",
        add: "添加明细",
        roleConfiguration: "权限配置",
        worktableConfiguration: "工作台配置",
        // code:"编码",
        yes: "有效",
        no: "无效",
        updateInfo: "更新成功",
        updateInfo1: "更新失败",
        saveInfo: "保存成功",
        saveInfo1: "保存失败",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    SampleCenterAbnormalItemList:{
        sampleCode:"Sample Code",
        code:"Code",
        patientName:"Patient Name",
        dicSampleType:"Dic SampleType",
        orderId:"OrderId",
        productName:"Product Name",
        sourceTable:"Source Table",
        method:"Method",
        note:"Note",
        state:"State",
        createUser:"Create User",
        createDate:"Create Date",
        handleUser:"Handle User",
        handleDate:"Handle Date",
        newlyBuild:"Newly Build",
        derive:"Export",
        SaveAndExecute:"Save And Execute",
        information:"Please enter the query information",
        CommunicationResult: "Communication Result",
        ContinueTheExperiment: "continue the experiment",
        AbortTheExperiment: "Abort the experiment"
    },
    SampleCenterAbnormalItemPublic:{
        AbnormalSampleManagement:"Abnormal Sample Management",
    },
    SampleCenterSampleAbnormalList:{
        id:"Id",
        patientName:"Patient Name",
        dicSampleType:"Dic SampleType",
        itemId:"Item Id",
        productId:"Product Id",
        nextFlow:"Next flow direction",
        method:"Method",
        state:"State",
        note:"Note",
        createUser:"Create User",
        createDate:"Create Date",
        handleUser:"Handle User",
        handleDate:"Handle Date",
        operation:"Operate",
        save:"Save",
        derive:"Export",
        SaveAndExecute:"Save And Execute",
        NextFlowDirection:"Next Flow Direction",
        information:"Please enter the query information",
        SampleCode: "Original Sample Code",
        Code: "Sample Code",
        OrderId: "Order Id",
        CommunicationResult: "Communication Result",
        ContinueTheExperiment: "The project team has processed (continue the experiment)",
        AbortTheExperiment: "The project team has processed (continue the experiment)"
    },
    SampleCenterSampleAbnormalPublic:{
        ReceiveSampleManagement:"Receive Sample Management",
    },
    SampleCenterSampleStatePublic:{
        SampleProgress:"Sample Progress",
    },
    SampleCenterSampleMasterDataPublic:{
        SampleMasterData:"Sample Master Data",
    },
    SampleCenterSampleMasterDataList:{
        derive:"Export",
        information:"Please enter the query information",
        operation:"Operate",
        code:"Sample Number",
        sampleType2:"Sample Type",
        stateName:"State Name",
        sampleOrder:"Sample Order",
        idCard:"Id Card",
        patientName:"Patient Name",
        productName:"Product Name",
        sequenceFun:"Sequence Fun",
        hospital:"Hospital",
        crmDoctor:"Crm Doctor",
        sellPerson:"Sell Person",
        dicType:"Dic Type",
        patientId:"Patient Id",
        samplingDate:"Sampling Date",
        unit:"Unit",
        sendReportDate:"Send ReportDate",
        receiveDate:"Receive Date",
        createDate:"Create Date",
        createUser:"Create User",
        noData:"No Data",
        Dataing:"Loading Data",
        sampleNum:"Sample Num",
        productId:"Testing Items",
        reportDate:"DueReport Time",
        note:"Notes",
        SampleSituation:"Sample Situation",
        InventoryInformation:"Inventory Information",
        SampleTracking:"Sample Tracking",
    },
    SampleCenterSampleMasterListRight:{
        id:"Sample Number",
        code:"Original SampleNumber",
        sampleCode:"Order Number",
        productName:"Testing Items",
        startDate:"Time On",
        endDate:"End Time",
        stageName:"Phase Name",
        acceptUser:"Operator",
        taskMethod:"Execution ProcessingMethod",
        taskResult:"ResultsOf Execution",
        taskId:"Execution OrderID",
        note:"Notes",

        code2:"Sample Number",
        sampleType2:"Original SampleNumber",
        stateName:"Sample Type",
        productId:"Scheduled Receipt",
        sampleOrder:"Sample Location",
        idCard:"Notes",
    },
    SampleCenterClinicalReceiveList:{
        add:"Newly Create",
        derive:"Export",
        information:"Please enter the query information",
        operation:"Operate",
        id:"Receipt Number",
        acceptDate:"Reception Time",
        itemCodes:"Sample Number",
        name:"Describe",
        stateName:"Status Name",
        itemBarCodes:"Bar Code",
        createDate:"Creation Time",
        createUser:"Founder",
        List: "Clinical Sample Receive List"
    },
    SampleCenterResearchReceiveList:{
        add:"Newly Create",
        derive:"Export",
        information:"Please enter the query information",
        operation:"Operate",
        id:"Receipt Number",
        acceptDate:"Reception Time",
        itemCodes:"Sample Number",
        name:"Describe",
        stateName:"Status Name",
        itemBarCodes:"Bar Code",
        createDate:"Creation Time",
        createUser:"Founder",
        List: "Research Sample Receive List",
        ProjectId: "Project ID",
        ProjectName: "Project Name",
    },
    SampleCenterClinicalReceivePublic:{
        ClinicalSampleReception:"Clinical SampleReception",
        ClinicalSampleReceiveTemplate: "Clinical Sample Receive Sheet Template"
    },
    SampleCenterResearchReceivePublic: {
        ResearchSampleReception: "Research SampleReception",
        ResearchSampleReceiveTemplate: "Research Sample Receive Sheet Template",
    },
    SampleCenterClinicalReceiveEdit:{
        saveOrUpdate:"Save",
        back:"Tabulation",
        state:"State",

        id:"Receipt Number",
        acceptUser:"Recipient",
        name:"Describe",
        expressNum:"Tracking Number",
        expressCompany:"Express Company",
        taTraffic:"Express DeliveryMethod",
        acceptDate:"Reception Time",
        selectedConfirmUser:"Reviewed By",
        choose:"Upload Attachments",
        dowlod:"Check Attachment",
        saoma:"Scan Code",
        uolod:"Upload Files",
        txm:"Bar Code",
        editSample:"Edit SampleInformation",
        deleteSample:"Remove Selected",
        operation:"Operate",
        noData:"No data",
        Dataing:"Loading Data",
        qingxuanze:"Please select a record !",

        type:"Please select a Category",
        queren:"Confirm",
        yanzheng:"Test and Verify",
        username:"UserName",
        password:"PassWord",
        reason:"Reason",

        kdgx:"Name",
        phone:"TelePhone",
        address:"Address",
        note:"Notes",
        printPath:"Print Path",

        user:"Full Name",

        sampleCode:"Sample Number",
        orderCode:"Order Number",
        barCode:"Bar Code",
        tagNum:"Tag Num",
        productName:"Testing items",
        gender:"Gender",
        patientName:"Full Name",
        dicSampleType:"Sample Type",
        source:"Data Sources",
        samplingDate:"Sample Time",
        periodOfValidity:"Validity Period (days)",
        expirationDate:"Expiration Time",
        species:"Sampling Position",
        sampleNum:"Sampling Amount",
        unit:"Unit",
        emrid:"ElectronicMedical RecordNumber",
        familyId:"Family Number",
        isGood:"Whether it takes effect",
        method:"Result",
        nextFlow:"Next Flow Direction",
        dataTraffic:"DataFlux(GB)",
        posId:"Sample Location",
        counts:"Version Number",
        createUser:"Founder",
        createDate:"Creation Time",

        yblx:"Sample Type",
        bmbj:"Encoding Markers",
        cyl:"Sampling Amount",
        cydw:"Sampling Unit",

        dzid:"ElectronicMedical RecordNumber",
        xb:"Gender",
        csrq:"Date Of Birth",
        nl:"Age",
        customer:"Hospital For Examination",
        ksName:"Department",
        customerDoctor:"Doctor Name",
        race:"Nation",
        telphoneNumber1:"Telephone",
        familyHistoryOfCancertext:"Family Number",
        email:"Mailbox",
        placeOfBirth:"Native Place",
        idCard:"ID",
        jxid:"Family TypeID",
        hospitalName:"Hospital",

        ysfs:"Mode Of Transport",

        dzbl:"Electronic MedicalRecord",
        ChooseProducts: "Choose Products",
        ChooseSampleType: "Choose Sample Type",
        ChooseUnit: "Choose Unit",
        ChooseNextFlow: "Choose Next Flow",
        ChooseTransportType: "Choose Transport Type",
    },
    SampleCenterResearchReceiveEdit:{
        saveOrUpdate:"Save",
        back:"Tabulation",
        state:"State",

        id:"Receipt Number",
        acceptUser:"Recipient",
        name:"Describe",
        expressNum:"Tracking Number",
        expressCompany:"Express Company",
        taTraffic:"Express DeliveryMethod",
        acceptDate:"Reception Time",
        selectedConfirmUser:"Reviewed By",
        choose:"Upload Attachments",
        dowlod:"Check Attachment",
        saoma:"Scan Code",
        uolod:"Upload Files",
        txm:"Bar Code",
        editSample:"Edit SampleInformation",
        deleteSample:"Remove Selected",
        operation:"Operate",
        noData:"No data",
        Dataing:"Loading Data",
        qingxuanze:"Please select a record !",

        type:"Please select a Category",
        queren:"Confirm",
        yanzheng:"Test and Verify",
        username:"UserName",
        password:"PassWord",
        reason:"Reason",

        kdgx:"Name",
        phone:"TelePhone",
        address:"Address",
        note:"Notes",
        printPath:"Print Path",

        user:"Full Name",

        sampleCode:"Sample Number",
        orderCode:"Order Number",
        barCode:"Bar Code",
        tagNum:"Tag Num",
        productName:"Testing items",
        gender:"Gender",
        patientName:"Full Name",
        dicSampleType:"Sample Type",
        source:"Data Sources",
        samplingDate:"Sample Time",
        periodOfValidity:"Validity Period (days)",
        expirationDate:"Expiration Time",
        species:"Sampling Position",
        sampleNum:"Sampling Amount",
        unit:"Unit",
        emrid:"ElectronicMedical RecordNumber",
        familyId:"Family Number",
        isGood:"Isit Normal",
        method:"Result",
        nextFlow:"Next Flow Direction",
        dataTraffic:"DataFlux(GB)",
        posId:"Sample Location",
        counts:"Version Number",
        createUser:"Founder",
        createDate:"Creation Time",

        yblx:"Sample Type",
        bmbj:"Encoding Markers",
        cyl:"Sampling Amount",
        cydw:"Sampling Unit",

        dzid:"ElectronicMedical RecordNumber",
        xb:"Gender",
        csrq:"Date Of Birth",
        nl:"Age",
        customer:"Hospital For Examination",
        ksName:"Department",
        customerDoctor:"Doctor Name",
        race:"Nation",
        telphoneNumber1:"Telephone",
        familyHistoryOfCancertext:"Family Number",
        email:"Mailbox",
        placeOfBirth:"Native Place",
        idCard:"ID",
        jxid:"Family TypeID",
        hospitalName:"Hospital",

        ysfs:"Mode Of Transport",

        dzbl:"Electronic MedicalRecord",
        ChooseProducts: "Choose Products",
        ChooseSampleType: "Choose Sample Type",
        ChooseUnit: "Choose Unit",
        ChooseNextFlow: "Choose Next Flow",
        ChooseProject: "Choose Project",
        ChooseProjectOrder: "Choose Project Order",
        ChooseTransportType: "Choose Transport Type",
        BatchFillData: "Batch Fill Data"
    },
    SampleCenterSampleStateList:{
        SampleNumber:"Sample Number",
        SampleReception:"Sample Reception",
        SampleProcessing:"Sample Processing",
        PathologicalExperiments:"Pathological Experiments",
        AccountingExtraction:"Accounting Extraction",
        PlatformInCharge:"PlatformIn Charge",
        libraryConstruction:"library Construction",
        enrichment:"Enrichment",
        LibraryMixing:"Library Mixing",
        SuperiorSequencing:"Superior Sequencing",
        StreamingPreTreatment:"Streaming PreTreatment",
        FlowOnMachineDetection:"FlowOnMachine Detection",
        MassSpectrometryExperiment:"MassSpectrometry Experiment",
        OfflineQualityControl:"Offline QualityControl",
        SangerExperiment:"Sanger Experiment",
        QPCR:"QPCR",
        COVNucleicAcidAmplification:"COVNucleicAcid Amplification",
        report:"Report",
        COVReport:"COV Report",
    },
    universalButton:{
        save:"preservation",
        back:"List",
        items:"Navigation",
        submit:"Submit",
        state:"State",
        saveAnd:"Save and execute",
        orderInfo:"Order Information",
        List:"List",
        Cancel:"Cancel",
        Modify:"Modify",
        //附件
        upload:"Upload Attachment",
        view:"Check Attachment",
        handle:"Handle",
        release:"Release",
        // 选择历史版本
        chooseHistoryVersion:"Choose History Version",
    },
    UserData: {
        user: "用户管理",
        homepage: "主页",
        num: "展示第 {first} 条到第 {last} 条的数据 ，共 {totalRecords} 条数据 ",
        num1: "展示第",
        num2: "条到第",
        num3: "条的数据 ，共",
        num4: "条数据",
        newlyBuild: "新建",
        derive: "导出",
        information: "请输入查询的信息",
        username: "用户名",
        name1: "姓名",
        gender: "性别",
        birth: "出生日期",
        phone: "联系电话",
        inDate: "入职日期",
        departmentId: "部门ID",
        departmentId1: "所属部门ID",
        departmentName: "所属部门",
        area: "所属片区",
        city: "所属城市",
        scope: "成本中心",
        state: "状态",
        operation: "操作",
        createTime: "创建日期",
        onJob: "在职",
        lock: "锁定",
        invalid: "无效",
        depart: "离职",
        id1: "组织机构编号",
        levelId: "上级组织机构编号",
        upDepartment: "上级组织机构",
        chooseDept: "请选择数据！",
        briefName: "组织机构简称",
        name: "组织机构名称",
        valid: "有效",
        address: "地址",
        note: "备注",
        password: "密码",
        operatingPassword: "操作密码",
        maturityDate: "失效日期",
        contactMethod: "联系电话",
        email: "电子邮箱",
        cardNo: "身份证号",
        scopeName: "成本中心",
        xgmmDateTime: "记录密码强制修改时间",
        role: "用户权限",
        choose: "选择",
        group: "人员组",
        type: "请选择类别",
        man: "男",
        girl: "女",
        state1: "在职",
        state2: "锁定",
        state3: "无效",
        state4: "离职",
        shanghai: "上海",
        beijing: "北京",
        roleId: "角色编号",
        roleName: "角色名称",
        description: "说明",
        groupId: "人员组编号",
        groupNmae: "人员组名称",
        description2: "描述",
        educationlevel: "教育程度",
        graduationInstitution: "毕业院校",
        emergencyContact: "紧急联系人",
        emergencyContactInformation: "紧急联系方式",
        certificationExperience: "认证经历",
        vaccination: "疫苗接种",
        uploadAttachments: "上传附件",
        viewAttachments: "查看附件",
        trainingExperience: "培训经历",
        addDetail: "添加明细",
        unknown: "未知",
        tip1:"请选择一条数据在查看",
        tip2:"请选择一条数据在上传",
        tip3:"上传成功",
        tip4:"上传失败",
        tip5:"请勿添加重复数据",
        tip6:"请选择一条数据",
        tip7:"请先保存基本信息",
        tip8:"保存成功",
        tip9:"保存失败",
        tip10:"请输入用户名",
        tip11:"请输入姓名",
        tip12:"请输入密码",
        tip13:"请输入性别",
        tip14:"请输入失效日期",
        tip15:"请输入状态",
        tip16:"用户名请输入字母数字组合",
        tip17:"邮箱格式错误",
        tip18:"联系电话格式错误",
        tip19:"紧急联系方式格式错误",
        tip20:"请填写出生日期",
        tip21:"请选择部门",
        incumbency: "在职",
        dimission: "离职",
        userNumber: "用户编号:",
        recordPassword: "上次密码修改时间",
        experimentTemplate: "实验模版授权",
        equipment: "设备授权",
        instrumentName: "仪器名称",
        instrumentTypeName: "仪器类型名称",
        creator: "创建人",
        creationTime: "创建时间",
        templateNumber: "模版编号",
        templateName: "模版名称",
        experimentType: "实验类型",
        experimentGroup: "实验组",
        experimentTemplateNumber: "实验模版编号",
        experimentTemplateName: "实验模版名称",
        experimentType1: "实验类型",
        creator1: "创建人",
        creationTime1: "创建时间",
        templateNumber1: "模版编号",
        templateName1: "模版名称",
        experimentType2: "实验类型",
        experimentGroup1: "实验组",
        experimentTemplateNumber1: "实验模版编号",
        experimentTemplateName1: "实验模版名称",
        experimentType3: "实验类型",
        creator2: "创建人",
        creationTime2: "创建时间",
        experiment: "实验模版授权",
        addDetails: "添加明细",
        device: "设备授权",
        selectExperiment: "请选择数据！",
        selectInstrument: "请选择数据！",
        instrumentName1: "设备类型",
        instrumentTypeName1: "设备类型",
        creator3: "创建人",
        creationTime3: "创建时间",
        templateNumber2: "模版编号",
        templateName2: "模版名称",
        experimentType4: "实验类型",
        experimentGroup2: "实验组",
        experimentTemplateNumber2: "实验模版编号",
        experimentTemplateName2: "实验模版名称",
        experimentType5: "实验类型",
        creator4: "创建人",
        creationTime4: "创建时间",
        templateNumber3: "实验模版编号",
        templateName3: "实验模版名称",
        experimentType6: "实验模版类型",
        experimentGroup3: "实验组",
        experimentTemplateNumber3: "实验模版编号",
        experimentTemplateName3: "实验模版名称",
        experimentType7: "实验类型",
        creator5: "创建人",
        creationTime5: "创建时间",
        userManagement: "用户管理权限更改",
        userManagement1: "用户管理",
        pleaseFill: "请填写必填信息:名字",
        addUser: "新增用户",
        createUserName:"创建人用户名",
        typeId:"设备类型ID",
        certificate:"证书名称",
        certificateNo:"证书编号",
        licenceIssuingAuthority:"发证机关",
        dateOfIssuance:"发证时间",
        periodOfValidity:"有效期",
        vaccineName:"疫苗名称",
        vaccineDate:"接种日期",
        describe:"描述",
        trainingName:"培训名称",
        content:"培训内容",
        trainingStartDate:"培训开始日期",
        trainingEndDate:"培训结束日期",
        fileName: "文件名",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        userExist: "用户已存在",
    },
    universal:{
        noData:"no data",
        Dataing:"Loading data",
        saveSuccess:"Successfully saved",
    },
    RoleData: {
        role: "角色管理",
        name1: "角色名称",
        note: "说明",
        state: "状态",
        effective: "有效",
        invalid: "无效",
        del: "删除选中",
        add: "批量添加",
        roleConfiguration: "权限配置",
        worktableConfiguration: "工作台配置",
        chooseUser: "请选择数据！",
        username: "用户名",
        name: "姓名",
        email: "电子邮箱",
        address: "地址",
        department: "部门",
        // name:"姓名",
        //配置信息
        configurationInformation: "配置信息",
        addDetail: "添加明细",
        tip1: "该用户已添加，请勿重复添加！",
        tip2: "请选择一条数据",
        tip3: "存在用户已添加，请勿重复添加！",
        tip4: "请先输入角色编号后保存",
        tip5: "角色编号不能为空",
        tip6: "角色名称不能为空",
        tip7: "状态不能为空",
        tip8: "角色编号重复",
        save1: "保存成功",
        save2: "保存失败",
        add1: "选择模块",
        user: "用户",
        roleId: "角色编号",
        roleName: "角色名称",
        description: "说明",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    UserGroupData: {
        group: "人员组管理",
        effective: "有效",
        invalid: "无效",
        code: "编码",
        modular: "模块",
        modular1: "请选择数据！",
        chooseModular: "请选择模块",
        choosedModular: "已选择模块",
        determine: "确定",
        confirmState: "是否为审核人",
        createUser: "创建人",
        createDate: "创建时间",
        name: "名称",
        note: "说明",
        user: "用户",
        addDetail: "添加明细",
        workflow: "模块名",
        field: "字段",
        tip1: "请填写编码",
        tip2: "请填写人员组名称",
        tip3: "请填写状态",
        tip4: "编码重复",
        tip5: "请先保存",
        tip6: "请勿添加重复数据",
        tip7: "请选择一条数据",
        tip8: "请选择用户",
        save1: "保存成功",
        save2: "保存失败",
        groupName: "人员组名称",
        description: "说明",
        state: "状态",
        add1: "选择模块",
        add: "批量添加",
        username: "用户名",
        name1: "姓名",
        department: "部门",
        email: "电子邮箱",
        address: "地址",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    UnitDictionaryData: {
        dictionary: "单位字典管理",
        seqencing: "排序号",
        pxhbnwk: "排序号必须是正整数",
        save1: "保存成功",
        save2: "保存失败",
        save: "保存",
        name: "名称",
        createUser: "创建人",
        createDate: "创建时间",
    },
    UnitGroupData: {
        unitGroup: "单位组",
        code: "编号",
        description: "描述",
        coefficient: "转换系数",
        mainUnit: "主单位",
        deputyUnit: "副单位",
        subUnit: "子单位",
        state: "状态",
        effective:"有效",
        invalid:"无效",
        tip1:"转换系数不能为空",
        tip2:"转换系数必须为正整数",
        tip3:"主单位不能为空",
        tip4:"副单位不能为空",
        save1:"保存成功",
        save2:"保存失败",
        tip5:"描述不能为空",
        tip6:"状态不能为空",
        chooseUnit: "请选择数据！",
        id: "编号",
        name: "描述",
        cycle: "转换系数",
        post: "岗位",
        supplier: "供应商",
        name1: "名称",
        note: "说明",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    OrganizationData: {
        organization: "组织机构管理",
        id: "组织机构编号",
        briefName: "组织机构简称",
        name: "组织机构名称",
        upDepartment: "上级组织机构",
        state: "状态",
        address: "地址",
        note: "备注",
        choose: "请选择数据！",
        post: "岗位",
        abbreviation: "请填写部门名称简称",
        organizationName: "请填写组织机构名称",
        chooseState: "请选择部门状态",
        chooseId: "请填写组织机构编号",
        user: "用户",
        tip:"组织机构编号重复",
        save1:"保存成功",
        save2:"保存失败",
        pleaseChoose:"请选择数据！",
        batchAdd:"批量添加",
        addUser:"添加用户",
        tip1:"请先保存组织机构信息",
        newlyBuild: "新建",
        ID: "组织机构编号",
        levelId: "上级组织机构编号",
        operation: "操作",
        valid: "有效",
        invalid: "无效",
        username: "用户名",
        name1: "姓名",
        department: "部门",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    ConfigurationData: {
        configuration: "系统配置",
        functionCode: "配置内容",
        sort: "排序号",
        name: "名称",
        note: "说明",
        state: "状态",
        createUser: "创建人",
        createUserId: "创建人编号",
        createDate: "创建时间",
        save: "保存",
        effective: "有效",
        invalid: "无效",
        successfullySaved: "保存成功",
        saveFailed: "保存失败",
        functionCode1: "功能码",
    },
    DictionaryList: {
        dictionary: "字典管理",
        sort: "排序号",
        tip1:"排序号必须是正整数",
        tip2:"修改成功",
        tip3:"修改失败",
        tip4:"添加成功",
        tip5:"添加失败",
        tip6:"确定要删除该数据吗？",
        tip7:"删除成功",
        tip8:"删除失败",
        search:"请输入查询的名称信息",
        tip9:"功能码不能为空",
        tip10:"名称不能为空",
        tip11:"状态不能为空",
        functionCode1: "功能码",
        name: "名称",
        description: "说明",
        seqencing: "排序号",
        state: "状态",
        valid: "有效",
        invalid: "无效",
        createUser: "创建人",
        createDate: "创建时间",
        operation: "操作",
        confirm: "确定",
        pleaseSelect: "请选择！",
    },
    MasterdataSampletype:{
        sampleType:"Sample type",


        createUser:"Create User",
        createDate:"Creation time",
        orderNumber:"Sort No",

        note:"note",
        effective:"Effective",
        information: "Please enter the name information for the query",

        id:"Sample code",
        name:"Sample name",
        state:"State",
        first:"type",
        picCode:"Icon",
        sampleNum:"Sampling quantity",
        unit:"Sampling unit",
        dataVolume:"Data volume",
        choose:"Please select a record !",
        batchUnit:"Batch unit",
        upload:"Upload Attachment",
        view:"Check Attachment",
        description: "description",
        code: "sample label",
        seqencing: "sort number",
        save: "save",
        back: "list",

        nail: "nails",
        bloodCell: "blood cell",
        sperm: "sperm spots",
        immunohistochemical: "immunohistochemical film",
        oralSwab: "oral swab",
        semen: "semen",
        dna:"DNA",
        heart: "heart",
        bloodPrecipitation: "blood precipitation",
        hePathological: "HE pathological section",
        urine: "urine",
        rna:"RNA",
        paraffin: "paraffin",
        formalinSoaked: "formalin-soaked tissue",
        boneMarrow: "bone marrow",
        saliva: "saliva",
        pleuralEffusion: "pleural",
        edtaAnticoagulant: "EDTA anticoagulant",
        ffpeWhite: "FFPE White",
        ffpeRoll: "FFPE Roll",
        externalPlasma: "external plasma",
        internalSeparation: "internal separation of plasma",
        separationLeukocyte: "isolation of white blood cells",
        ascites: "ascites",
        cerebrospinalFluid: "cerebral medullary fluid",
        blood: "blood",
        freshTissue: "Fresh Tissue",
        valid: "valid",
        invalid: "invalid",
        name1: "name",
        saveInfo: "Save successfully",
        saveInfo1: "Save failed",
        updateInfo: "Update successful",

        pleaseSelectData: "Please select data!",
        //类型名称不能为空
        nameNotNull: "The type name cannot be empty!",
        //状态不能为空
        stateNotNull: "Status cannot be empty!",
        //样本标签不能为空
        codeNotNull: "Sample label cannot be empty!",
        codeLetter: "Sample label must be a letter!",

        // 排序号必须是正整数
        seqencingNotNull: "Sort number must be a positive integer!",
        //判断采样量是否是正数
        sampleNumNotNull: "Sampling quantity must be a positive number!",
        pageChangeSave: "The page content has changed. Do you need to save it?",
        prompt: "prompt",
},experimentTemplatePublic:{
        experimentTemplate:"Experimental template",

    }
    ,experimentTemplateList:{
        testType:"Type of experiment",
        stateName:"Workflow Status",
        state:"State",

    }
    ,experimentTemplateEdit:{
        code: "编码",
        createDate: "创建时间",
        createUser: "创建人",
        description: "描述",
        information:"essential information",
        stateName:"Workflow Status",
        storageContainer:"Container type",
        name:"name",
        days:"Experiment days",
        beforeDays:"Experiment early warning days",
        group:"experimental group",
        isBlend:"Mixed sample",
        state:"State",
        isSeparate:"Whether to sample by site",
        versionNum:"Version number",
        confirmUser:"Reviewed by",
        step:"Step details",
        templateFieldsOption:"Select experiment details",
        experimentResultsOption:"Select experimental results",
        selecedSex:"Generate new sample number",
        selectedDicSeqencingTypeNameArray:"Product type",
        chooseReagent:"Select reagent",
        reagent:"reagent",
        templateStepsNum:"Individual consumption",
        instrument:"instrument",
        choosenIstrument:"Select instrument type",
        instrumentType:"Instrument type:",
        addSteps:"Create steps",
        del:"Remove",
        step1:"Step I",
        table:"Table name",
        col:"Column name",
        columnComment:"Column description",
        fieldType:"Field type",
        dataLength:"Database length",
        modeltype:"Entity name",
        controltype:"Keycontrol type",
        isreadonly:"Read Only",
        colsort:"sort",
        modeltypeclass:"Function name",
        container:"container",
        rownum:"Number of rows",
        colnum:"Number of columns",
        formulaConditions:"Formula conditions",
        templateFieldsResult:"Result field",
        templateFieldsItem:"Result table fields",
        judge:"Judging condition",
        threshold:"threshold",
        logoColor:"Combination specification",
        spec:"Specifications",
        note:"remarks",
        experimentalModule:"Process node",
        tip1:"The account number or password is incorrect",
        itemResultTable:"Relevant detailed result table",
        saveFirst:"Please save the data first",
        productName:"Business type",

    },experimentConfigPublic:{
        experimentConfig:"A list of lab process configurations",
        experimentConfigTwo: "Experiment process configuration"
    },experimentConfigEdit:{
        productName:"Related products",
        start:"start",
        stepName:"Step name",
        judge:"judge",
        end:"end",

    },productMasterList:{
        projectPricing:"Project pricing",

    },ProductMasterData:{
        productMaster:"Product master data",
        productMaster2: "产品主数据订单内容",
        productMaster3: "产品主数据子产品",
        effectiveBtn: "EffectiveBtn",
        invalidBtn: "InvalidBtn",
        information: "Please enter the information for your inquiry",

        briefName: "abbreviated",
        //描述
        description: "描述",


        choose:"Please select a hide area",
        productId:"Product ID",
        productName:"Product name",
        price:"Original price",
        discount:"Discount",
        discountPrice:"Discounted price",
        editItem:"Edit details",
        chooseProduct:"Add product",
        chooseModular:"Select agent quantity module",
        inspectionCycle:"Inspection cycle",
        earlyWarning:"Early warning period",
        day:"Day",
        identificationCode:"Identification code",
        consumption:"Consumption",
        combinationOptions:"Whether to combine options",
        orderContent:"Order content",
        hiddenArea:"Hide area",
        hideFields:"Hide Fields",
        assert:"Take effect",
        repeal:"Void",
        subproduct:"Sub-products",
        popupAdd:"Popup Create",
        popupEditing:"Popup Editing",
        experimentalConfiguration:"Experimental configuration",
        selectModule:"Select module",
        selectTemplate:"Select Template",
        yes:"Yes",
        no:"No",
        hideConfiguration:"Custom hide configuration",
        templateConfiguration:"Template configuration",
        voidTime:"Void time",
        experimentalTemplate:"Experimental template",
        templateName:"Template name",

        viewFlowChart: "View flowchart",
        selectExperiment: "Select Experiment",
        selectFlowConfiguration: "Select Process Configuration",
        flowName: "Process Name",
        name: "Name",
        effective: "Effective",
        invalid: "Invalid",
        subProduct: "Subproduct",
        experimentConfiguration: "Experimental configuration",
        prompt: "Prompt",
        pleaseSelectAData: "Please select a piece of data",
        tips1:"The data that has already taken effect cannot take effect again",
        tips2:"Invalid data exists and cannot take effect again",
        tips3:"If the data is not saved, save it first",
        tips4:"Take effect successfully",
        tips5:"Validation failure",
        tips6:"Data in the invalid state exists and cannot be invalid",
        tips7:"Please take effect first",
        tips8:"Successful cancellation",
        tips9:"Fail to cancel",
        tips10:"Please fill in the basic information and save it",
        tips11: "Save successfully",
        tips12: "Save failed",
        state: "State",
        createUser: "Creator",
        createDate: "Creation time",
        save: "Save",
        back:"Back",
        items: "Items",
        selectProducts: "Select products",
        selectTemplates: "Select templates",
        basicInformation: "Basic information",
        code: "Code",
        shortName: "Abbreviation",
        experimentalProcess: "Experimental process",
        productionProcessConfiguration: "Production process configuration",
        finishedProduct: "Finished product",
        yourBrowserDoesNotSupportTheCanvasElement: "This text is displayed if your browser does not support canvas HTML elements." ,
        tableName: "Tablename",
        columnName: "Column name",
        columnDescription: "Column description",
        projectPricing: "Project Pricing",
        pleaseEnterAPositiveNumber: "Please enter a positive number",
        takeEffect: "Take effect",
        invalid1: "Void",
        identificationCodeCanOnlyBeLetters: "Identifiers can only be letters",
        //请选择数据！
        pleaseSelectData: "Please select data!",
        productNameCannotBeEmpty: "Product name cannot be empty",
        productStatusCannotBeEmpty: "Product status cannot be empty",
        workOrderCannotBeEmpty: "Work order cannot be empty",
        cooperationProjectCannotBeEmpty: "Cooperation project cannot be empty",
        warningCycleMustBeAPositiveInteger: "Warning cycle must be a positive integer",
        checkCycleMustBeAPositiveInteger: "Check cycle must be a positive integer",
        pageChangeSave: "The current page has been modified, please save it first",
        //请先选择隐藏字段
        pleaseSelectHiddenFields: "Please select hidden fields first",

    },InstrumentData: {
        //校验有效期至
        validDate: "校验有效期至",
        //请输入有效的数字！
        pleaseEnterAValidNumber1: "价格请输入正数数字！",
        //请输入正数！
        pleaseEnterAValidNumber2: "序列号请输入正数数字！",
        //请输入有效的数字！
        pleaseEnterAValidNumber3: "固定资产号请输入正数数字！",
        //安装日期
        installationDate: "安装日期",
        instrument: "仪器数据",
        instrumentNo: "仪器编号",
        instrumentName: "仪器名称",
        type: "类型",
        capitalCode: "型号",
        serialNumber: "序列号",
        supplierNote: "生产商名称",
        supplier: "生产商",
        breed: "类型",
        state1: "状态",
        userCreateUserId: "创建人",
        createDate: "创建时间",
        note: "备注",
        reason: "故障原因",
        effectiveDate: "安装日期",
        pleaseFill: "请输入查询的信息",
        faultReason: "报修原因",
        available: "可用",
        unavailable: "不可用",
        scrap: "报废",
        downloadTemplate: "下载模板",
        batchAdd:"批量导入",
        addSuccess: "添加成功",
        instrumentType: "请选择数据！",
        currency: "币种",
        choose: "请选择数据！",
        accuracy: "级别",
        invoicenumber: "规格型号",
        price: "价格",
        fixedAsset: "固定资产号",
        operationTime: "投用时间",
        manufacturer: "生产商",
        dataVolume: "数据量",
        upload: "上传附件",
        view: "查看附件",
        rmb: "人民币",
        jpy: "日元",
        supplierCode: "供应商编码",
        industry: "行业",
        file: "查看附件",
        fileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        download: "下载",
        previewPicture: "预览(图片)",
        delete: "删除",
        tips: "请选择一条数据",
        dollar: "美元",
        images: "查看图片",
        uploadImages: "上传图片",
        viewImages: "查看图片",
        yytuqsczsc: "已有图片，请先删除后再上传",
        uploadSuccess: "上传成功",
        saveSuccess: "保存成功",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        tip1:"价格必须为数字",
        tip2:"仪器名称不能为空",
        tip3:"类型不能为空",
        tip4:"状态不能为空",
        tip5:"部门不能为空",
        tip6:"判断投用时间应大于安装时间",
        state:"状态",
        check:"查看附件",
        organizations:"组织机构编号",
        briefName: "组织机构简称",
        name: "组织机构名称",
        address: "地址",
        operation: "操作",
        departmentName: "部门",
        name1: "名称",
        invalid: "无效",
        valid: "有效",
    },reagentPublic:{
        reagent:"Reagent master data",

    } ,reagentList:{
        category:"category",
        kit:"test kit",
        remind:"Expiration reminder",
        amount:"Inventory quantity",
        unit:"unit",

    }
    ,reagentEdit:{
        engName:"English name",
        inventory:"Inventory information",
        inventoryUnit:"Inventory unit",
        unitGroup:"Unit group",
        storageConditions:"Storage conditions",
        reminder:"Reminder lead time",
        quantity:"Safety stock quantity",
        durabilityDays:"Durability days",
        deliveryPrice:"Delivery price",
        batch:"Batch",
        ul:"Bottle-ul",
        batchNo:"Batch No",
        expirationPeriod:"Expiration period",
        reminderTime:"Reminder time",
        warehousingTime:"Warehousing time",
        stock:"Stock in this batch",
        qc:"Qc status",
        storageLocation:"Storage location",

    }
    ,storageInPublic:{
        warehousing:"Warehousing management",
    }
    ,storageInList:{
        information:"Warehousing information",
        personnel:"Warehousing personnel",
        personnel2:"Warehouse-in person",
    }
    ,storageInEdit:{
        masterData :"Inventory master data",
        warehousingDetails :"Warehousing details",
        selectStorage :"Select storage location",
        chooseSupplier :"Select supplier",
        printLabel :"Print Label",
        supplier :"supplier",
        expirationTime :"Expiration time",
        supplierInformation :"Supplier information",
        verification :"verification",
        reason :"reason",
        ReceiptQuantity :"Receipt quantity",
        number:"Number of sub-units",
        saveLocation:"Save location",
        pleaseChoose:"Please select a piece of data first!",
    },
    storageOut:{
        outbound:"Outbound management",
        chooseConfirmPerson:"Please select the reviewer",
    },
    storageOutList:{
        orderNo:"Delivery order No",
        person:"Warehouse-out person",
        time:"Delivery time",
        batch:"Batch",
        deliveryDetails:"Delivery details",
        choosePerson:"Please select stock-out person",
        batchID:"Batch ID",
        Inventory:"Inventory",
        batchStock:"Stock in this batch",
        deliveryQuantity:"Delivery quantity *",
        reagentNo:"Reagent No",
        batchnum:"Batch No",
        position:"position",

    },
    sampleAbmormalPublic:{
        title:"Abnormal sample management",

    }
    ,sampleAbmormalList:{
        chooseNext:"Please select the next flow direction",
        next:"Next step direction",
        originalNumber:"Original sample number",
        name:"Name",
        sampleType:"Sample type",
        itemId:"Task order ID",
        testItems:"Test items",
        result:"result",
        qualified:"qualified",
        unqualified:"unqualified",
        processed:"Processed",
        untreated:"Not processed",
        feedback: "Feedback",
        processor:"Processor",
        processingTime:"processing time",
        processedByProjectTeam: "Processed by project team",
    }
    ,orderList:{
        order:"order",
        orderNo:"Order No",
        age:"Age",
        nation:"nation",
        zipCode:"Zip code",
        commissioner:"sale",
        nativePlace:"Native place",
        medicalNumber:"EMR No",
        familyCode:"Family number",
        family:"Family contact",
        familyPhone:"Contact information and telephone number of family members",
        familySite:"Family contact address",
        crmCustomer:"medical institution",
        barcode:"bar code",
        hospitalPatientID:"Admission No",
        modifyDate:"Modification time",
        idCard:"ID number",
        progress:"Order progress",

    },
    orderListEdit:{
        chooseProduct: "Please select product",
        orderInfo: "Order information",
        baseInfo: "Basic information",
        id: "Order No",
        createUser: "Creator",
        createDate: "Creation time",
        stateName: "State",
        name: "Name",
        gender: "Gender",
        age: "Age",
        birthDate: "Birth date",
        nation: "Nation",
        nativePlace: "Native place",
        medicalNumber: "Medical record No",
        idCard: "ID number",
        bedNo: "Bed No",
        hospitalPatientID: "Patient ID/Hospital No",
        oldId: "Old Order ID",
        templateTestType: "Family number",
        email: "Email",
        phone: "Phone",
        note: "Note",
        commissioner: "Commissioner",
        confirmUser: "Confirm person",
        confirmDate: "Confirmation time",
        productName: "Product name",
        diagnosis: "Clinical Diagnosis",
        medicalHistory: "Health Condition",
        yongYao: "Current drug use",
        fspl: "Pharmacy Frequency",
        guomin: "Allergy",
        samplingLocation: "Sampling location",
        disease: "Disease",
        familyInfo: "Family information",
        family: "Family contact",
        familyPhone: "Family contact phone",
        familySite: "Family contact address",
        zipCode: "Zip code",
        hospitalInfo: "Hospital information",
        crmCustomer: "Medical Institutions",
        inspectionDepartment: "Inspection department",
        attendingDoctor: "Attending doctor",
        attendingDoctorPhone: "Attending doctor phone",
        confirmMoney: "Confirm money",
        addItem: "Add Record",
        chooseFinanceUser: "Choose financial personnel",
        sampleInfo: "Sample information",
        chooseSampleType: "Choose sample type",
        deleteChoose: "Remove selected",
        choose: "Please select a record !",
        chooseState: "Choose state",
        confirm: "Confirm",
        yanzheng: "Verify",
        userName: "User name",
        passward: "Password",
        reason: "Reason",
        isFee: "Is fee",
        fee: "Fee",
        consumptionDate: "Consumption time",
        feeWay: "Fee way",
        monthFee: "Monthly fee",
        feeNote: "Fee note",
        receipNumber: "Receipt No",
        posNumber: "POS No",
        backFeeDate: "Back fee time",
        invoiceCode: "Invoice code",
        invoiceNumber: "Invoice No",
        invoiceDate: "Invoice time",
        alipayNumber: "Alipay No",
        state: "State",
        financeUser: "Financial personnel",
        testName: "Test name",
        commissionerName: "Commissioner",
        indexa: "Index",
        sampleCode: "Sample code",
        outSampleCode: "Out Sample code",
        slideCode: "Slide code",
        sampleType: "Sample Type Name",
        samplingDate: "Sampling time",
        receiveUserName: "Receiver Name",
        receiveDate: "Receive time",
        sampleState: "Sample State",
        dateOfBirth: "Date of birth",
        customerName: "Customer Hospital",
        doctorDept: "Department",
        customerDoctor: "Doctor Name",
        race: "race",
        telphoneNumber1: "Telephone No",
        placeOfBirth: "Place of birth",
        sampleTypeName: "Sample type",
        code: "Code",
        sampleNumber: "Sample number",
        unit: "Sample unit",
        familyCode: "Family number",
        patientName: "Name",
        hospitalName: "Hospital",
        dutyManId: "Duty person",
        designation: "Designation",
        chooseOneData:"Please Select One Data",
        deleteSuccess:"Remove Success",
        mustName:"Please Input Name",
        updateSuccess:"Update Success",
        saveSuccess:"Save Success",
        saveFailed:"Save Failed",
        apply:"Apply",
        delete:"Confirm Remove Item?",
        confirmation:"Confirmation",
        cancelOperation:"Cancel Operate",
        SampleReceiveItem: {
            status0: "Cancel",
            status1: "NEW",
            status2: "Wait to Receive",
            status3: "Received",
        }
    },

    AuditTrailPublic: {
        auditTrail: "审计追踪",
        auditTrailDetail: "审计追踪明细",

        //程序名称
        className: "程序名称",
        //记录编号
        fileId: "记录编号",
        //操作人
        userId: "操作人",
        //操作人编号
        userCode: "操作人编号",
        //操作时间
        logDate: "操作时间",
        //记录修改情况
        modifyContent: "记录修改情况",
        //状态
        stateName: "状态",
        //查看明细
        viewDetail: "查看明细",

        codeName: "标识",
        fieldName: "字段名",
        oldData: "旧数据",
        newData: "新数据",
    },

    auditTrailEdit:{
        className:"Program Name",
        fileId:"Record ID",
        userId:"Operator",
        logDate:"Operate time",
        modifyContent:"Record modification status",
        stateName:"State",
        codeName:"Identifying",
        fieldName:"FieldName",
        oldData:"Old Data",
        newData:"New Data",
    }
    ,search:{
        query:"Search",
        reset:"Reset",
    },
    ReservationData: {
        reservation1: "仪器预约",
        instrumentNo: "仪器编号",
        instrumentName: "仪器名称",
        type: "类型",
        state1: "状态",
        reservation: "预约",
        available: "可用",
        unavailable: "不可用",
        scrap: "报废",
        instrumentData: "已预约时间列表",
        id: "编码",
        startDate: "开始时间",
        endDate: "结束时间",
        createUserId: "预约人ID",
        createUser: "预约人",
        state: "预约状态",
        reservationOperation: "操作",
        cancelReservation: "取消预约",
        reservationSuccessful: "已预约",
        canceled: "已取消",
        bcsbyyyysjct: "保存失败！原因：预约时间冲突！",
        successfullySaved: "保存成功",
        reservationCancellationSucceed: "取消预约成功!",
        reservationCancellationFailed: "取消预约失败!",
        today: "今天",
        month: "月",
        week: "周",
        day: "天",
        timeCannotBeEmpty: "时间不能为空！",
        language: "en",
        tips: "您没有权限取消该用户的预约信息",
        tips1: "开始时间应小于结束时间",
        tips2: "开始时间应大于当前时间",
        tips3: "结束时间应大于当前时间",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        pleaseFill: "请输入查询的信息",
        tip4: "请选择一条数据",
    },applyPublic:{
        purchase:"Purchase Application",
    },applyList:{
        id:"id",
        applicant:"applicant",
        applicantId:"applicantId",
        note:"note",
        applyDate:"applyDate",
        expectDate:"expectDate",
        state:"State",
        stateName:"State",
    },applyEdit:{
        masterData :"masterData",
        pleaseChoose :"please Select a item",
        selectSupplier :"please Select a Supplier",
        procureDetails :"procureDetails",
        id:"id",
        applicant:"applicant",
        applicantId:"applicantId",
        note:"note",
        applyDate:"applyDate",
        num:"num",
        expectDate:"expectDate",
        state:"State",
        stateName:"stateName",
        confirmUser:"Reviewer List",
        name :"name",
        supplier :"supplier",
        supplierId :"supplierId",
        unit :"unit",
        type :"type",
        createUser :"createUser",
        createDate :"createDate",
        chooseState:"chooseState",
        saveInfo:"Save success",
        updateInfo:"update success",
        submitInfo:"submit success",
        firm:"firm",
        accountInfo:"accountInfo",
        verification:"verification",
        reason:"reason",
    },
    MasterdataStorageContainer:{
        storageContainer:"Container Management",
        id:"id",
        name:"Container Name",
        colNum:"Column Number",
        rowNum:"Row Number",
        location:"location",
        effect:"effect",
        createUser:"Creator",
        createDate:"Creation Time",
        effectUser:"Effect User",
        effectDate:"Effect Time",
        editData: "Edit Data",
        confirm: "confirm",
        save: "save",
        lineEdit: "Line editing",
        isEffect: "whether it takes effect",
        isEffect2: "takes effect",
        oneLevel: "Level one",
        twoLevel: "Level two",
        threeLevel: "Level three",
        fourLevel: "Level four",
        subContainer: "subcontainer",
        mainContainer: "main container",
        yes: "Yes",
        no: "No",
        chooseOneData: "Please select a piece of data",
        effectSuccess: "effective successfully",
        effectFail: "Failed to take effect",
        saveSuccess: "Save successfully",
        saveFail: "Save failed",
        //提示
        tips: "Tips",
        nameNotNull: "Container name cannot be empty",
        colNumNotNull: "Column number cannot be empty",
        colNumPositiveInteger: "Column number must be a positive integer",
        rowNumNotNull: "Row number cannot be empty",
        rowNumPositiveInteger: "Row number must be a positive integer",
        locationNotNull: "Location cannot be empty",
        //请先保存
        saveFirst: "Please save first",
        //已生效数据，无法生效
        effectFail1: "已生效数据，无法生效",
        //修改成功
        updataSuccess: "修改成功",
    },
    storageContainerEdit:{
        editData :"Edit Data",
    },
    agentPublic: {
        agent: "Agent Master Data",
    },
    agentList: {
        id: "ID",
        name: "Name",
        address: "Address",
        principal: "Primary Principal ID",
        phone: "Phone Number",
        marketer_id: "Sales Administrator ID",
        marketer: "Sales Administrator",
        money: "Balance",
        rate_id: "Rank ID",
        rate: "Rank",
        state_id: "State ID",
        state: "State",
        create_user_id: "Creator ID",
        create_user: "Creator",
        create_date: "Create Time",
        saveInfo: "Save Success",
        updateInfo: "Update Success",
        submitInfo: "Submit Success",
        agentId:"Agent ID",
    }, agentEdit: {
        chooseUser: "Please Choose User",
        chooseDic: "Please Choose Dic",
        chooseState: "Please Choose State",
        id: "ID",
        name: "Description",
        address: "Address",
        principal: "Person in Charge",
        phone: "Tel",
        marketer: "Sales Administrator",
        money: "Prepaid Balance",
        rate_id: "Rank ID",
        rate: "Rank",
        state_id: "State ID",
        state: "State",
        create_user_id: "Creator ID",
        create_user: "Creator",
        create_date: "Create Date",
    },
    supplierPublic:{
        supplier:"Supplier",
        SupplierList: "Supplier List",
    },
    supplierList:{
        id:"Supplier ID",
        name:"Name",
        address:"Address",
        linkMan:"Linkman",
        phone:"Telephone",
        email: "Email",
        postCode:"Postcode",
        stateId:"State",
        state:"State",
        capitalNum:"Registered Capital",
        orgCode:"Organization Code",
        industry:"InputVocation",
        aptitide1:"Aptitide1",
        aptitide2:"Aptitide2",
        aptitide3:"Aptitide3",
        accountBank:"Bank Account",
        accountBankAddress:"Bank Account Address",
        account:"Account",
        accountName:"Account Name",
        bankCode:"Bank Code",
        bic:"Swift Code(BIC)",
        arn:"ABA Routing Number",
        iban:"IBAN",
        classification: "Category",
        status: "Status",
        manufacturer: "Manufacturer",
        supplier: "Supplier",
    },
    supplierEdit:{
        chooseState:"Choose State",
        saveInfo:"Save Success",
        updateInfo:"Update Success",
        firm:"Enterprise Qualification",
        accountInfo:"Account Information",
    },
    InstrumentFaultData: {
        instrumentFault: "仪器报修",
        id: "编号",
        confirmDate: "确认时间",
        cost: "费用",
        createDate: "创建时间",
        handleDate: "报修时间",
        note: "备注",
        state: "状态",
        stateName: "工作流状态",
        confirmUser: "确认人",
        createUser: "创建人",
        handleUser: "报修人",
        type: "类型",
        instrumentId: "仪器编号",
        instrumentName: "仪器名称",
        NEW: "新建",
        Complete: "完成",
        instrument: "仪器",
        instrumentFaultDetail: "报修明细",
        editPop: "弹窗编辑",
        editData: "编辑数据",
        saveInfo: "保存成功",
        available1: "可用",
        available2: "报废",
        unavailable1: "不可用",
        qxxzytsj: "请先选择一条数据!",
        addedSuccessfully: "添加成功",
        faultReason: "报修原因",
        zttjcc: "状态提交成功",
        zttjsh: "状态提交失败",
        pleaseSave: "请先保存",
        pleaseSelectDate: "请先选择一条数据!",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        bntjdyqb: "存在仪器在其他未完成的仪器调整单据中，不能添加到明细表",
        bntjdyqb1: "该仪器在其他未完成的仪器调整单据中，不能添加到明细表",
        tip1: "账号或密码错误",
        tip2: "页面内容存在改动，是否需要保存后退出？",
        tip3: "请选择",
        tip4: "当前需调整仪器状态与调整状态一致，请重新选择",
        tip5: "页面数据存在改动，需要保存后提交！",
        add: "批量添加",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type1: "请选择类别",
        capitalCode: "型号",
        serialNumber: "序列号",
        supplier: "生产商",
        breed: "类型",
    },
    InstrumentRepairData: {
        instrumentRepair: "仪器维修",
        id: "编号",
        note: "备注",
        factEndDate: "实际结束时间",
        name: "描述",
        createDate: "创建时间",
        createUser: "创建人",
        verify: "维修单位",
        stateName: "工作流状态",
        instrumentId: "仪器编号",
        instrumentName: "仪器名称",
        new: "NEW",
        complete: "完成",
        instrumentRepairTask: "维修明细",
        editData: "编辑数据",
        available: "可用",
        unavailable: "不可用",
        zttjcc: "状态提交成功",
        zttjsh: "状态提交失败",
        pleaseSave: "请先保存",
        pleaseSelectState: "请选择状态",
        pleaseSelectDate: "请先选择一条数据!",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        czsbjzqtwxdz: "存在设备已在其他维修单中，请重新选择或刷新页面",
        czsbjzqtwxdz1: "该设备已在其他维修单中，请重新选择或刷新页面",
        state:"状态",
        state2:"维修状态",
        instrument: "仪器",
        add: "批量添加",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type: "请选择类别",
        capitalCode: "型号",
        serialNumber: "序列号",
        supplier: "生产商",
        state1: "状态",
        userCreateUserId: "创建人",
        faultReason: "报修原因",
        reason1: "故障原因",
        effectiveDate: "安装日期",
        valid: "有效",
        invalid: "无效",
        available1: "可用",
        available2: "报废",
        unavailable1: "不可用",
        tip1: "账号或密码错误",
        saveInfo: "保存成功",
        qxxzytsj: "请先选择一条数据!",
        addedSuccessfully: "添加成功",
        //实际结束时间不可小于仪器报修时间
        tip2: "实际结束时间不可小于仪器报修时间",
    },
    StorageInApplyPublic:{
        storageInApply:"Storage Application",
        storageInApply2: "生物资源库入库申请",
    },StorageInApplyList:{
        id:"id",
        name:"name",
        createUser :"createUser",
        createDate :"createDate",
        state:"State",
        stateName:"stateName"
        },StorageInApplyEdit:{
        id:"id",
        code:"code",
        procureDetails:"procureDetails",
        productName:"productName",
        chooseProductName:"please Select productName",
        sampleType:"sampleType",
        chooseSampleType:"please Select sampleType",
        sampleFrom:"sampleFrom",
        sampleDeteyionName:"sampleDeteyionName",
        chooseSampleDeteyionName:"please Select sampleDeteyionName",
        cellName:"cellName",
        note:"note",
        sampleBatch:"sampleBatch",
        pronoun:"pronoun",
        concentration:"concentration",
        volume:"volume",
        name:"name",
        spec:"spec",
        sxDate:"sxDate",
        state:"State",
        stateName:"stateName",
        confirmUser:"confirmUser",
        createUser :"createUser",
        createDate :"createDate",
        chooseState:"chooseState",
        saveInfo:"Save success",
        updateInfo:"update success",
        confirm:"Confirm",
        reason:"reason",
    },
    DetectionsPublic:{
        detections:"detections",
    },DetectionsList:{
        id:"id",
        name:"name",
        createUser :"createUser",
        createDate :"createDate",
        state:"State",
        stateName:"stateName",
        new: "NEW",
        complete: "COMPLETE",
    },

    DetectionsEdit:{
        detectionsDetails:"detectionsDetails",
        transportType:"transportType",
        id:"id",
        name:"name",
        cellName:"cellName",
        nextFlow:"Quality inspection type",
        testingCriteria:"testingCriteria",
        unit:"unit",
        yesOrNo:"yesOrNo",
        yesOrNo2:"yesOrNo2",
        reservedSample:"reservedSample",
        deteyionName:"deteyionName",
        type:"type",
        template:"template",
        confirmUser:"Reviewer List",
        state:"State",
        stateName:"stateName",
        chooseState:"please Select state",
        saveInfo:"Save success",
        saveFail: "Save Failed",
        updateInfo:"update success",
        confirm:"Confirm",
        verification:"verification",
        reason:"reason",

        experimentType: "实验类型",
        testStyleNo: "实验类型编号",
        testStyleName: "实验类型名称",
        experimentTypeSuffix: "数据库表后缀",

        createUser: "创建人",
        createDate: "创建时间",

        inValid: "无效",
        valid: "有效",
        save: "保存",

        choose: "Please select a record !",

        nameNotNull: "检测项名称不能为空",
        deteyionNameNotNull: "检测项目代码不能为空",
        stateNotNull: "状态不能为空",
        experimentTypeNotNull: "实验类型不能为空",
    },

    //模板流程
    TemplateProcessEdit:{
        title: "模板流程",

        processView: "流程图",
        desc: "描述",
        experimentType: "实验类型",
        createUserNickName: "创建人",
        createDate: "创建时间",
        state: "状态",
        valid: "有效",
        invalid: "无效",
        selectData: "请选择数据!",

        validSuccess: "修改状态成功!",
        validFail: "修改状态失败!",
    },

    //研发样本接收
    SampleCenterRDReceiveEdit: {
        title: "研发样本接收",
        rdSampleReceiveTemplate: "研发样本接收模板",
        downloadTemplate: "下载模板",
        batchUpload: "批量上传",

        receiveId: "接收编号",
        receiveDate: "接收时间",
        sampleId: "样本编号",
        desc: "描述",
        state: "状态",
        projectId: "项目编号",
        projectName: "项目名称",
        createTime: "创建时间",
        createUser: "创建人",
        expressNo: "快递单号",
        expressCompany: "快递公司",
        transportType: "运输方式",
        confirmUser: "审核人",

        save: "保存",
        back: "列表",
        submit: "提交",
        handle: "办理",
        verify: "验证",
        submitSuccess: "提交成功",
        submitFailed: "提交失败",
        exSampleCodeCantRepeat: "外部样本编号不能重复！",
        expressNumError: "快递单号格式错误！",
        sampleNumMustBePositiveInteger: "采样量必须为正整数！",
        periodOfValidityNotLessThanZero: "有效期不能为小于0",

        sampleReceiveDetail: "样本接收明细",
        externalSampleCode: "外部样本编号",
        sampleCode: "样本编号",
        name: "姓名",
        gender: "性别",
        gender0: "女",
        gender1: "男",
        gender2: "未知",
        sampleType: "样本类型",
        samplingDate: "采样时间",
        validity: "有效期（天）",
        expireDate: "到期时间",
        site: "采样部位",
        sampleNum: "采样量",
        unit: "单位",
        result: "结果",
        result1: "合格",
        result2: "不合格",
        nextFlow: "下一步流向",
        plateNo: "板号",
        position: "位置",
        note: "备注",

        saveFirst: "请先保存!",
        saveSuccess: "保存成功!",
        updateSuccess: "修改成功!",
        receiveDateNotFilled: "接收时间不能为空",
        confirmUserNotFilled: "审核人不能为空",
        pleaseSelect: "请选择数据",
        phone: "联系电话",
        address: "地址",
        valid: "有效",
        invalid: "无效",

        uploadFile: "上传附件",
        viewFile: "查看附件",
        uploadSuccess: "上传成功",
        uploadFail: "上传失败",
        fileName: "文件名称",
        editSample: "编辑样本信息",
        mustBePositiveInteger: "必须为正整数!",
        required: "不允许为空!",

        cancel: "取消",
        confirm: "确认",
        analysisSuccess: "解析成功!",
        analysisFail: "解析失败!",

        selectType: "请选择",
        username: "用户名",
        password: "密码",
        reason: "原因",
        inputUserNameAndPassword: "请输入用户名与密码",
        userNameOrPasswordError: "用户名或密码错误",
        operateSuccess: "操作成功",
        operateFail: "操作失败",
    },

    MasterdataFlowPathConfig:{
        FlowPath:"FlowPath",
        FlowPathName:"FlowPathName",
        add:'Create',
        module:'module',
        FlowPathNames:'FlowPathNames',
        addWuliao:'Create Material',
        wuliaoId:'Material ID',
        wuliaoName:'Material Name',
        wuliaoPici:'Material Batch',
        operation:"Operate",
        addShebei:'Create Equipment',
        shebeiId:'Equipment ID',
        shebeiType:'Equipment Type',
        shebeiName:'Equipment Name',
        addZhiling:'Create Instruction',
        zhilingContent:'Instruction Content',
        zhilingJieguo:'Instruction Result',
        yes:'Yes',
        no:'No',
        upload:'Upload',
        view:'View',
        imgTitle:'Image Title',
        date:'Date',
        dateTime:'Date Time',
        peizhi:'Configuration',
        name:'Name',
        isDuhang:'Is Duhang',
        morentishi:'Default Prompt',
        type:'Type',
        zhengtidaxiao:'Maximum Size',
        zuizhongshenpiren:'Final Approver',
        guize:'Rule',
        zidingyibiaotou:'Custom Header',
        delete:'Remove',
        addGuize:'Create Rule',
        deleteZujian:'Remove Component',
        //清空规则
        clearGuize: '清空规则',
        //选择字段
        chooseZiduan: '选择字段',
        //自定义值
        zidingyizhi: '自定义值',
        //数字个数
        shuzigeshu: '数字个数',
        //字母个数
        zimugeshu: '字母个数',
        //样本条码号只能选择一次
        ybtmh: '样本条码号只能选择一次',
        //个数字
        geshu: '个数字',
        //个字母
        geshu2: '个字母',
    },
    AdjustmentStateType:{
        name:"Describe",
        note:"Note",
        userName:"Name",
    },
    AdjustmentDetail:{
        scopeName:"Instrument Name",
        invoicenumber:"Model",
        state1:"Instrument Status",
        note:"Note",
        createUser:"Founder",
        createDate:"CreateTime",
    },
    InstrumentRepairPlanData: {
        instrumentRepairPlan: "仪器周期检定计划",
        id: "编号",
        tsTime: "预警天数",
        period: "周期",
        unit: "单位",
        unitName: "周期单位",
        note: "描述",
        typeId: "类型",
        typeName: "维护类型",
        createUser: "创建人",
        createDate: "创建时间",
        state: "状态",
        stateName: "状态",
        nextDate: "下次维护日期",
        tsDate: "维护提醒日期",
        prevDate: "上次维护日期",
        instrumentId: "仪器编号",
        instrumentName: "仪器名称",
        maintainer: "维护人",
        new: "新建",
        complete: "完成",
        chooseType: "请选择数据！",
        saveInfo: "保存成功",
        instrument: "仪器",
        instrumentRepairPlanTask: "明细",
        editData: "编辑数据",
        effectiveDate: "安装日期",
        delete: "确认删除明细吗?",
        deleteInfo: "删除成功",
        addInfo: "添加成功",
        cancelOperation: "取消操作",
        confirmation: "确认",
        chooseMaintainer: "请选择数据！",
        batchAdd: "批量添加",
        days: "天",
        weeks: "周",
        month: "月",
        available: "可用",
        unavailable: "不可用",
        tip1: "请选择一条数据",
        tip2: "请输入正整数",
        tip3: "预警天数不能为空",
        tip4: "周期不能为空",
        tip5: "请选择周期单位",
        tip6: "请选择维护类型",
        tip7: "预警天数请输入正整数",
        tip8: "周期请输入正整数",
        tip9: "预警天数不能大于周期天数",
        batchAddMaintainer: "维护人",
        add: "批量添加",
        name: "名称",
        instrumentNo: "仪器编号",
        capitalCode: "型号",
        serialNumber: "序列号",
        supplier: "生产商",
        breed: "类型",
        state1: "状态",
        userCreateUserId: "创建人",
        note1: "备注",
        valid: "有效",
        invalid: "无效",
        chooseOneData: "请选择一条数据",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    InstrumentMaintainData: {
        //维护日期应大于或等于当前日期！
        TheMaintenancEdateShouldBeGreaterThanOrEqualToTheCurrentDate: "维护日期应大于或等于当前日期！",
        instrumentMaintain: "仪器维护",
        id: "编号",
        name: "描述",
        note: "备注",
        typeId: "类型",
        typeName: "维护类型",
        createUser: "创建人",
        createDate: "创建时间",
        state: "状态",
        stateName: "状态",
        confirmUser: "确认人",
        confirmDate: "确认时间",
        instrumentId: "仪器编号",
        instrumentName: "仪器名称",
        new: "新建",
        complete: "完成",
        saveInfo:"保存成功",
        saveInfo1:"保存失败",
        planInstrument:"待维护仪器",
        instrumentMaintainItem:"明细",
        useDate:"维护日期",
        nextDate:"下次维护日期",
        tsDate:"维护提醒日期",
        period:"维护周期",
        unitName:"周期单位",
        deleteInfo:"删除成功",
        addInfo:"添加成功",
        completeInfo:"状态提交成功",
        delete:"确认删除明细吗?",
        confirmation:"确认",
        cancelOperation:"取消操作",
        content:"维护检定内容",
        tip1:"账号或密码错误",
        tip2:"维护类型不能为空",
        chooseType: "请选择数据！",
        add: "批量添加",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type: "请选择类别",
        name1:"名称",
        instrumentNo: "仪器编号",
        period1: "周期",
        valid: "有效",
        invalid: "无效",
        pleaseSave: "请先保存",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        chooseOneData: "请选择一条数据",
    },
    orderChangePublic:{
        orderChange:"Order Change",
    },
    orderChangeList:{
        id:"ID",
        acceptDate:"Approval Date",
        changeType:"Type",
        createDate:"Create Date",
        name:"Name",
        note:"Note",
        state:"State",
        stateName:"State",
        acceptUser:"Approver",
        createUser:"Creator",
        orderId:"Order ID",
        List: "List",
    },
    orderChangeEdit:{
        saveInfo:"Save Success",
        changeType:"Add Application Pype",
        choose:"Please select a record !",
        cancel:"Cancel",
        modify:"Modify",
        append:"Append",
        chooseAcceptUser:"Choose Approver",
        chooserOrder:"Choose Order",
        gender:"Gender",
        age:"Age",
        medicalNumber:"EMR ID",
        orderChangeItem:"addition/Modifidy Details",
        noteState:"State",
        sampleOrder:"Order ID",
        nation:"Ethnic",
        zipCode:"Post Code",
        commissioner:"salesman",
        nativePlace:"Native Place",
        familyCode:"Family Number",
        family:"Family Contact",
        familyPhone:"Family Contact Phone Number",
        familySite:"Family Contact Address",
        crmCustomer:"Medical Institution",
        hospitalPatientId:"Hospital Patient ID",
        birthDate:"Date of Birth",
        idCard:"ID Card",
        productName:"Product Name",
        confirmAccept:"Please Confirm the reviewer",
        completeInfo:"Complete Success",
        ChangeRecordType:"Change Record Type",
        ChangeRecordTypeZero:"Old",
        ChangeRecordTypeOne:"NEW",
    },
    MasterdataQualityProduct:{
        save: "Save",
        back: "Back",
        qualityProduct:"QualityProduct",
        id:"id",
        name:"name",
        batch:"Batch",
        experimentType:"experimentType",
        chooseExperimentType:"please Select experimentType",
        expectedValue:"expectedValue",
        createUser:"createUser",
        createDate:"createDate",
        state:"State",
        productName:"productName",
        chooseProductName: "please Select productName",
        productDate:"productDate",
        identification:"identification",
        saveInfo:"Save Success",
        updateInfo:"update success",
        pleaseSelectData: "please Select Data!",
        nameInfo: "name can not be empty",
        identificationInFo: "identification can not be empty",
        productDateInFo: "productDate can not be empty",
        stateInFo: "state can not be empty",
        experimentTypeInFo: "experimentType can not be empty",
        productNameInFo: "productName can not be empty",
        valid: "valid",
        invalid: "invalid",
        productDateInfo: "productDate can not be empty",
        pageChangeSave: "The page content has changed, do you need to save it?",
        prompt: "prompt",
    },

    MasterdataQualityRule:{
        qualityRule:"QualityRule",
        id:"id",
        name:"Name",
        rule:"Rule",
        createUser:"CreateUser",
        createDate:"CreateDate",
        editData: "Edit Data",
        lineEditing: "Line Editing",
        confirm: "Confirm",
        save: "Save",
        holePlateFormat: "Orifice Plate Format",
        rackFormat: "Shelf Format",
        pleaseChoose: "Please select a piece of data",
        updateInfo: "Update successful",
        saveInfo: "Save successfully",
    },
    QualityRuleEdit:{
        editData:"EditData",
    },
    MasterdataQualityRuleCombination:{
        qualityRuleCombination:"QualityRuleCombination",
        id:"id",
        name:"Name",
        rule:"Rule",
        chooseRule:"Please Select Rule",
        ruleClass:"RuleClass",
        projectName:"projectName",
        chooseProjectName:"Please Select ProjectName",
        state:"State",
        createUser:"CreateUser",
        createDate:"CreateDate",
        confirm:"Confirm",
        pleaseChoose: "Please select a piece of data!",
        editData: "Edit Data",
        save: "Save",
        lineEditing: "Line Editing",
        QualityRuleCombinationInfo: "Quality Control Rule Combination Information",
        valid: "Valid",
        invalid: "Invalid",
        rule1: "Rule",
        holePlateFormat: "Orifice Plate Format",
        rackFormat: "Shelf Format",
        updateInfo: "Update Successful",
        saveInfo: "Save Successfully",
        ruleInFo: "Rule Cannot Be Empty",
        ruleClassInFo: "RuleClass Cannot Be Empty",
        projectNameInFo: "ProjectName Cannot Be Empty",
        stateInFo: "State Cannot Be Empty",
        pleaseSelectData: "Please Select Data!",
    },
    QualityRuleCombinationEdit:{
        editData:"EditData",
    },
    DocumentEffect: {
        confirm: "您确定要继续吗？",
        fileType: "文件类型",
        fileId: "文件编号",
        fileName: "文件名称",
        issuingDepartmentName: "所属部门",
        createUser: "作者",
        documentPreparRevision: "上级文件",
        stateEffect: "状态",
        effectUser: "生效确认人",
        effectiveDate: "生效日期",
        stateOnlineEffect: "是否已线上分发",
        note: "备注",
        documentEffect: "文档生效",
        documentInvalid: "文档失效",
        fileName2: "文件名称",
        ownerModel: "所属模块",
        uploadUser: "上传人",
        uploadTime: "上传时间",
        tips: "请选择一条数据",
        success: "文件生效成功",
        error: "文件生效失败",
        success1: "文件失效成功",
        error1: "文件失效失败",
        tips1: "已生效文件请勿重复操作",
        tips2: "已失效文件请勿重复操作",
        delete: "删除成功",
        delete1: "删除",
        images: "查看图片",
        viewDocument: "查看文档",
        onlineView: "在线查看文档",
        effect1: "已生效",
        effect2: "未生效",
        yes: "是",
        no: "否",
        attachment: "附件",
        download: "下载",
        images1: "预览图片",
        effect: "生效",
        noEffect: "未生效",
        viewAttachments: "查看附件",
    },
    documentMasterDataPublic:{
        documentMasterData:"Document Master Data",
    },
    documentMasterDataList:{
        fileType:"File Type",
        fileId:"File Number",
        fileName:"File Name",
        issuingDepartmentName:"Department",
        createUser:"Author",
        documentPreparRevision:"Superior Files",
        stateEffect:"State",
        effectUser:"Effect Confirm User",
        effectiveDate:"Effect Date",
        onlineView:"Open Online",
        download: "Download Controlled copy",
        dataNum:"Master Data Number",
    },
    DocumentBorrowingApply:{
        borrowingApplication: "文档借阅申请",
        new: "新建",
        complete: "完成",
        newlyBuild: "新建",
        handle: "办理",
        id: "编码",
        name: "描述",
        createUser: "申请人",
        createDate: "申请时间",
        confirmUser: "审核人",
        confirmDate: "完成时间",
        stateName: "状态名称",
        username: "审核人",
        fileName: "文档",
        versionNo: "版本号",
        startDate: "借阅开始时间",
        endDate: "借阅结束时间",
        note: "备注",
        applyCreateUser: "创建人",
        applyCreateDate: "创建时间",
        fileName1: "文件名称",
        select: "选择借阅文档",
        delete: "删除选中",
        selectDocument: "请选择数据！",
        fileName2: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",
        success: "上传成功",
        warn: "请选择一条数据",
        deleteSuccess: "删除成功",
        deleteError: "删除失败",
        save1: "请先保存",
        saveSuccess: "保存成功",
        saveError: "保存失败",
        stateSubmitError: "状态提交失败",
        addSuccess: "添加成功",
        addError: "添加失败",
        tips: "请选择要删除的数据",
        warning: "请选择审核人",
        file: "查看附件",
        upload: "上传附件",
        view: "查看附件",
        download: "下载",
        delete1: "删除",
        startDateError: "借阅开始时间必须晚于当前时间",
        endDateError: "借阅开始时间必须早于借阅结束时间",
        endDateError1: "借阅结束时间必须晚于借阅开始时间",
        repeat: "不能重复借阅",
        borrowSuccess: "借阅成功",
        verification: "验证",
        username1: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type: "请选择类别",
        viewDocument: "查看文档",
        viewImages: "查看图片",
        onlinePdf: "查看pdf",
        endDateError2: "不在借阅时间内无法查看文档",
        fileTypeError: "当前只支持查看pdf、图片、word",
        documentBorrowingApplyDetail: "文件借阅申请明细",
        save: "保存",
        back: "列表",
        submit: "提交",
        state: "状态",
        pleaseSelectOneData: "请选择一条数据",
        startDateNotNull: "借阅开始时间不能为空",
        endDateNotNull: "借阅结束时间不能为空",
        documentIs: "文档为：",
        versionNoIs: "版本号为：",
        documentInBorrowingTime: "的文档还在借阅时间内",
        cannotAddSameDepartmentDocument: "不能添加相同部门的文档",
        cannotRepeatBorrowDocument: "不能重复借阅该文档",
        //提交成功
        submitSuccess: "提交成功",
        //提交失败
        submitError: "提交失败",
    },chargePlatformEdit:{
        groupNum:"Group Number",
        sampleInfoIdCard:"Sample Information",
        barCode:"Bar Code",
        chargePlatform:"Take charge of the platform",
        splitSample:"Split the sample",
        splitProduct:"Split the product",
        sumTotal:"Total",
        unit:"unit",
        next:"Next step flow",
        save:"Save",
        submitSample:"Submit a sample",
        chargeManagement:"In charge of management",
        BeforeSplitSampleManagement:"Sample management before splitting",
        AfterSplitSampleManagement:"Sample management after splitting",
        saveSuccess:"Save successfully",
        saveFail:"Save failed",
        name1:"Name",
        note1:"Note",
        splitCode:"Numbered after splitting",
        code:"Number before splitting",
        sampleCode:"Original sample number",
        orderCode:"Order number",
        productName:"Detect items",
        OriginalSampleType:"Original sample type",
        dicSampleType:"Product type",
        contraction:"Concentration (ng/ul)",
        volume:"Volume (μL)",
        qbContraction:"Qubit concentration (ng/ul)",
        od280:"od260/280",
        od260:"od260/230",
        nextFlow:"Next flow direction",
        isSplitProduct:"Whether the product has been removed",
        state:"State",
        createUser:"Created by",
        createDate:"Creation time",
        labCode:"Laboratory sample number",
        sampleType:"Sample type",
        sequencePlatform:"Sequencing platform",
        id:"Order ID",
        name:"Name",
        productId:"Detection item ID",
        productName1:"Testing items",
        gender:"Gender",
        age:"Age",
        medicalNumber:"Medical record number",
        state1:"State",
    },

    //房间管理
    RoomManagement: {
        RoomManagement: "房间管理",
        usedRecord: "实验占用记录",
        cleanRecord: "清洁记录",

        Inquire: "查询",
        Add: "新建",
        Edit: "编辑",
        View: "查看",

        id: "房间编号",
        name: "房间名称",
        note: "备注",
        roomState: "房间状态",
        isUsed: "占用状态",
        cleanState: "清洁状态",
        roomDesc: "房间描述",
        area: "区域",
        centiare: "房间面积㎡",
        stere: "房间体积m³",
        createUser: "创建人",
        createDate: "创建时间",
        stateName: "状态",

        canUse: "可以使用",
        canNotUse: "不可以使用",
        yes: "已占用",
        no: "未占用",
        noClean: "未清洁",
        clean: "已清洁",

        fileName: "文件名称",
        belongModule: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "文件上传人",
        notNull: "不允许为空",
        chooseData: "请选择数据",

        batch: "批次号",
        usedExperimentStep: "占用实验阶段",
        usedExperimentName: "占用实验阶段名称",
        acceptUser: "操作人",
        startDate: "开始时间",
        endDate: "结束时间",

        cleanType: "清洁类型",
        cleanId: "房间清洁编号",
        disinfectStartTime: "消毒开始日期",
        disinfectValidityTime: "消毒有效期至",
        cleanUser: "清洁人员",
        cleanDate: "清洁日期",
        checkUser: "复核人员",
        checkDate: "复核日期",

        saveSuccess: "保存成功",
        saveFail: "保存失败",
        roomIdRepeat: "房间编号重复",
        mustBePositiveInteger: "无效，请检查后重新输入！",
        roomIdFormat: "房间编号格式不正确",
    },

    materialIn:{
        materialIn:"Item packing",

        id:"id",
        name:"name",
        createUser:"Created by",
        state:"State",
        createDate:"Creation time",
        note:"note",
        confirmUser:"Approver",
        type:"Please select the inventory master data",
        confirmUserName:"confirmUserName",

        batch:"Batch List",

        chooseConfirmUser:"Reviewer List",


    },
    material:{
        id:"Package code",
        name:"The package name",
        batch:"Batch",
        materialNum:"Material Num",
        spec:"spec",
    },
    materialInItem:{
        id:"Material code",
        materialName:"Material name",
        spec:"spec",
        batch:"Batch",
        num:"num",
        note:"note",
        unit:"unit",
        createUser:"Inbound personnel",
        createDate:"Inbound time",

        name:"name",

        saveSuccess: "Save successfully",
        list:"List",
        state: "State",
        validate: "validate",
        username: "username",
        password: "password",
        reason: "reason",
        confirm: "Confirm",
        chooseType: "Please select a category",
        confirm1: "Confirm",
        selectInventory: "Select inventory master data",
        material:"material",
        selectMaterial: "Select Item Batch",
        name5: "Name",
        insufficient: "The batch of materials is out of stock",
        insufficient1: "insufficient material inventory",
        saveError: "Save successfully",
        editError: "Save failed",
        deleteError: "Remove failed",
        stateFinish:"Status completed",
    },
    materialInList:{
        id:"Inbound information",
        createUser:"Inbound personnel",
        createDate:"Creation time",
        note:"note",
        confirmDate:"Inbound time",
        stateName:"Status",
    },
    dptPharmacyPublic:{
        DptPharmacy:"DTP Pharmacy",
    },
    dptPharmacyList:{
        id:"ID",
        name:"Name",
        district:"District",
        type:"Type",
        street:"Street",
        postcode:"Postcode",
        email:"Email",
        researchField:"Research Field",
        dutyMan:"Duty Man",
        phone:"Phone",
        state:"State",
        createUser:"Creator",
        createDate:"Create Date",
        // 有效
        effective: "有效",
        // 无效
        invalid: "无效",
    },
    dptPharmacyEdit:{
        chooseType:"Please Choose Type",
        chooseDistrict:"Please Choose District",
        chooseDutyMan:"Please Choose Duty Man",
        chooseState:"Please Choose State",
        saveInfo:"Save Success",
        updateInfo:"Update Success",
        saveFailedInfo:"Save Failed",
    },
    DocumentDraftingPublic:{
        DocumentDrafting:"Drafting/Revision",
    },
    DocumentDraftingList:{
        numbers:"Odd numbers",
        fileType:"File type",
        documentNumber:"Document number",
        fileName:"File Name",
        state:"State",
        issuingDepartmentName:"Department",
        author:"Author",
        createTime: "Creation ",
    },
    DocumentDraftingEdit:{
        //单号
        numbers:"Odd numbers",
        Version :"Historical Version",
        Upload:"Upload Approved",
        Viewing:"Check Document",
        ViewOnline:"Open Online",
        Generate:"Generate Document",
        author:"Author",
        content:"Document content",
        definition:"Definition",
        duty:"Duty",
        text:"Text",
        reference:"Reference resources",
        enclosure:"Enclosure",
        RevisionHistory:"Revision History",
        SelectFileType:"Select File Type",
        SelectProductionType:"Select production type",
        ChooseLocation:"Choose a location",
        SelectIssuingDepartment:"Select Issuing Department",
        SelectReviewer:"Select Reviewer",
        SelectApprover:"Select approver",
        SelectSuperiorFile:"Select superior file",
        SelectHistoryFile:"Select History File",
        category:"Please select a category",
        verification:"Verification",
        userName:"User Name",
        password:"Password",
        reason:"Reason",
        confirm:"Confirm",

        DocumentName:"Document Name",
        ParentFile:"Parent File",
        uploadOffline:"Whether to upload offline",
        FileType:"File Type",
        FileNumber:"File Number",
        ProductionType:"Production Type",
        DepartmentName:"Department Name",
        Location:"Location",
        IssuingDepartment:"Issuing Department",
        Approval:"Approval Person",
        ratify:"Ratify",
        AuditCycle:"Audit cycle",
        ApprovalLeadTime:"Approval lead time",
        BodyEditingStyle:"Body Editing Style",
        DocumentBodyEditingStyle:"Document Body Editing Style",
        Purpose:"Purpose",
        Scope:"Scope",
        word:"Word pop-up editor",
        yes:"Yes",
        no:"No",
        upload:"Load Attachment",
        view:"Check Attachment",
        add:"Create",
        delete:"Remove",
    },
    DocumentDraftingColum: {
        encoding: "File encoding",
        FileName: "File Name",
        UserName: "User name",
        Name: "Name",
        Parameter: "Parameter",
        SerialNumber: "Serial number",
        DepartmentPosition: "Department position",
        Responsibilities: "Responsibilities",
        SerialNumber1: "Serial number",
        TA: "Terminology/Abbreviations",
        Definition: "Definition",
        SerialNumber2: "Serial Number",
        DocumentNumber: "Document number",
        FileName1: "File Name",
        VersionNumber: "Version number",
        Author: "Author",
        EffectiveDate: "Effective Date",
        OrderNumber: "Order number",
        FileType: "File Type",
        DocumentNumber1: "Document number",
        FileName2: "File Name",
        Department: "Department",
        author: "Author",
        CreationTime: "Creation time",
        save:"Successfully saved",
        info:"Please Save the data first",
    },

    //文档模板
    DocumentTemplateList: {
        DocumentTemplate: "文档模板",

        desc: "描述",
        formatType: "格式类型",
        fileType: "文件类型",
        ifValid: "是否有效",
        createUser: "创建人",
        createTime: "创建时间",
        valid: "有效",
        invalid: "无效",
        S: "竖版",
        H: "横版",
        ZW: "正文",
        file: "附件",
        tips: "请选择一条数据",
        tipsNew: "请选择数据！",
        uploadSuccess: "上传成功",

        selectFileType: "选择文件类型",
        upload: "上传附件",
        view: "查看附件",
        editOL: "在线编辑",

        saveFirst: "请先保存!",

        fileName: "文件名称",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        save: "Save",
    },

    //电子病历
    crmPatient:{
        caseHistory:"Electronic medical record",
    },

    documentEffectTips:{
        message:"Confirm",
        confirm:"Are you sure you want to continue？",
        cancel:"You have cancelled！",
    },

    projectManagementPublic:{
        projectManagement:"Project Management",
        logMsg1: "User: * 1 on number",
        logMsg2: "An attachment has been uploaded to the data, named:",
    },
    projectManagementList:{
        name:"Project Name",
        mainProject:"Main Project",
        crmDoctor:"Crm Doctor",
        type:"Type",
        dutyUserName:"Duty User",
        templateUpgrade:"Project Description",
        dqjz:"Dqjz",
        planStartDate:"Plan Start Date",
        planEndDate:"Plan End Date",
        factEndDate:"Fact End Date",
        sampleCodeNum:"Sample Code Num",
        createDate:"Create Date",
        createUser:"Create User",
    },
    projectManagementEdit:{
        upload:"Load Attachment",
        check:"Check Attachment",
        project:"Project",
        id:"ID",
        name:"Project Name",
        type:"Type",
        dutyUserName:"Duty User",
        planStartDate:"Plan Start Date",
        planEndDate:"Plan End Date",
        factEndDate:"Fact End Date",
        sumScale:"Sum Scale",
        state:"State",
        person:"Person",
        money:"Money",
        patientId:"Patient Id",
        note:"Note",
        projectOrder:"Project Order",
        projectOrderName:"Project Order Name",
        productId:"Product Id",
        productName:"Product Name",
        sampleNum:"Sample Num",
        contactUser:"Contact User",
        price:"Price",
        total:"Total",
        inspection:"Inspection",
        saveInfo:"Save Success",
        updateInfo:"Update Success",

    },instrumentDataEdit:{
        instrumentData:"Instrument use",
        stageName:"Stage name (experiment name)",
        operator:"Operator",
        executionId:"Execute a single ID",
        template:"Experiment template",
        startTime:"Start time",
        endTime:"End time",
    },file:{
        upload: "Load Attachment",
        check: "Check Attachment",
        enclosure: "attachment",
        checkPicture: "View Picture",
        preview: "View Online image",
        download: "Download",
    },
    coiOrder:{
        coiOrder: "COI订单",

        orderNumber:"Order number",
        productInfo:"Product Information",
        applicationInfo:"Request form",
        applicationNumber:"Ticket number",
        screeningNumber:"Filter number",
        samplingTimes:"Number of samples",
        traceabilityCode:"Traceability code",
        informedDate:"Date of knowledge",
        estimatedCollectionTime:"Estimated acquisition time",
        estimatedReturnDate:"Estimated fallback date",
        hepatitisB:"Hepatitis B HBV",
        hepatitisC:"Hepatitis C HCV",
        aids:"AIDS HIV",
        syphilis:"Syphilis TPHA",
        tumorType:"Tumor type",
        tumorStage:"Tumor stage",
        hospital:"hospital",
        department:"Department",
        craContact:"CRA Contact",
        ebv:"EBV Result",
        cmv:"CMV Result",
        transportationTemperatureConditions:"Shipping temperature conditions",
        sampler:"Sampler",
        phoneNumber:"Mobile phone number",
        sparePhoneNumber:"Alternate mobile phone number",
        samplingAddress:"Sampling address",
        remarks:"remark",
        createUser:"Created by",
        createTime:"Creation time",
        state:"State",
        sampleInfo:"Sample information",
        flowState:"Process State",

        sampleNumber:"encode",
        productName:"Product name",
        barCode:"Bar code",
        gtin:"GTIN number",
        sampleName:"Sample name",
        samplingTime:"Sample time",
        receiverName:"Recipient name",
        receiveTime:"Received time  ",
        type: "Units type",
        units: "Units",
    },

    ProductionPlan:{
        ProductionPlan:"Production planning",


        save:"Save",
        tomorrow:"Check out for production tomorrow",
        pause:"Pause the step",
        insert:"Step insertion",
        print:"Print Label",
        recheck:"Review the printed barcode",
        select:"Select the template type",
        cancel:"Cancel",
        confirm:"Confirm",
        selectProcess:"Select process type (required)",
        processName:"The name of the flow sheet",
        createUser:"Created by",
        process:"Process",
        noName:"No name",
        pleaseSelect:"Please select an operator",
        pleaseSelectStep:"Please select a step",
        pleaseSelectOperator:"Please select the operator",
        noData:"There is no data",
        loading:"Load the data",
        operation:"Operate",
        deviation:"Deviation effects",

        productBatch:"Product lot number",
        operationDate:"Date of Operate",
        process1:"Process",
        stepName:"Step name",
        operator:"Operator",
        room:"room",
        processConfiguration:"Process configuration",
        finishedGoodsReceipt:"Receipt of finished goods",
        transportationPlan:"Transportation plan",
        transportation:"transport",
        other:"other",
        sourceSampleTransportation:"Source sample shipping",
        sampleReception:"Sample reception",
        pleaseSelectOneData:"Please select a piece of data",
        cannotSelectProcessOne:"You cannot select a step with a single process for re-inspection！",
        saveSuccess:"Save successfully",



        describe:"description",
        product:"products",
        remark:"remark",
        number:"numbering",
        deviationDescribe:"Description of deviation",
        code:"encode",
        name:"name",
        version:"Process number",
        userName:"name",
        distributionNumber:"Number of allocations",
        roomNumber:"Room number",
        roomName:"Room name",
        area:"Region",
        todayArrangementNumber:"Number of schedules for today",
        occupancyStatus:"Occupancy status",
        expirationDate:"Distance period",
    },
    ProcessExecution:{
        edit:"Edit",
        describe:"description",
        processConfiguration:"Process configuration",
        pleaseSelect:"Please select",
        traceabilityCode:"Traceability code",
        process:"Process",
        noName:"nameless",
        finished:"Completed",
        unfinished:"to be continued",
        addRow:"Add rows",
        materialNumber:"Item number",
        materialName:"Item name",
        materialBatch:"Item Batch",
        operation:"Operate",
        warehousing:"Storage",
        addFinishedProduct:"Add finished products",
        outbound:"Outbound",
        number:"numbering",
        name:"name",
        batch: "Batch",
        state: "State",
        notWarehousing: "Not in storage",
        warehousing1: "put into storage",
        notOutbound:"Not out of stock",
        waitOutbound:"To be shipped out",
        outbound1: "out of warehouse",
        addRow1: "Add row",
        equipmentNumber: "Device Number",
        equipmentName: "Device Name",
        equipmentType: "device type",
        operation1: "Operate",
        instructionContent: "Instruction content",
        instructionResult: "Instruction Result",
        yes: "Yes",
        no: "no",
        time:"time:",
        upload: "Load",
        check: "Check Attachment",
        pictureDescribe: "Image description",
        upload1: "Load",
        check1: "View",
        addRow2: "Add row",
        selectTime: "Select Time Date",
        selectDate: "Select Date",
        pleaseSelect1: "Please select",
        confirmCompletion: "Confirm completion of the process",
        expectedArrivalDate: "expected arrival date",
        expectedReturnDate: "expected returnDate",
        transportationTemperatureConditions: "Transportation Temperature Conditions",
        returnApplicationConfirmation: "Return application confirmation",
        remark: "Note",
        state1: "State",
        returnRemark: "Return Remark",
        logisticsNumber: "Logistics tracking number",
        logisticsPersonnel: "logistics personnel",
        estimatedArrivalTime: "estimated time of arrival",
        transportationDate: "shipping date",
        transportationMode: "mode of transportation",
        confirm: "Confirm",
        confirm1: "Confirm",
        confirm2: "Confirm",
        name1: "name",
        uploadTime: "upload time",
        uploadPerson: "uploader",
        operation2: "Operate",
        cancel: "cancel",
        confirm3: "OK",
        name2: "name",
        cancel1: "cancel",
        confirm4: "OK",
        selectBatchNumber:"Select Batch Number",
        selectMaterial:"Select Material",
        name3: "name",
        materialBatch1: "Material Batch",
        selectMaterial1: "Select Material",
        number1: "number",
        expirationDate: "expiration time",
        finishedProductNumber:"finished product number",
        productionDate: "Date of manufacture",
        account: "account",
        password: "password",
        cancel2: "cancel",
        confirm5: "OK",
        estimatedSamplingTime: "estimated sampling time",
        logisticsTime: "logistics time",
        logistics: "logistician",
        shippingNumber: "Shipping tracking number",
        transportationMode1: "mode of transportation",
        logisticsCompany: "logistics company",
        thermometerNumber: "thermometer number",
        thermometerStartTime: "thermometer on time",
        incubatorNumber: "incubator number",
        startTemperature: "start temperature",
        new: "new",
        save: "Save",
        list:"List",
        confirmed: "confirmed",
        noConfirmed: "no confirmed",
        returned: "returned",
        new1: "New",
        toBeConfirmed: "To be confirmed",
        pleaseCompleteThePreviousStepFirst: "Please complete the previous step first",
        prompt: "prompt",
        success: "success",
        barcodeNumberDoesNotExist: "Barcode number does not exist",
        noSample: "No such sample",
        dataCannotBeEditedAfterConfirmation: "Data cannot be edited after confirmation",
        confirmCompletionOfCurrentProcess: "Confirm completion of the current process",
        sumIs: "sum as",
        averageValueIs: "average value",
        maximumValueIs: "Maximum value is",
        minimumValueIs: "minimum value is",
        success1: "success",
        wrongPassword: "The password is wrong",
        noSuchUser: "There is no such user",
        approverVerification: "Approver verification",
        selectBatchNumber1: "Select Batch Number",
        selectMaterial2: "Select Material",
        selectEquipment: "Equipment List",
        selectMaterial3: "Select Material",
        selectBatchNumber2: "Select Batch Number",
        selectEquipmentType: "Select Device Type",
        selectMaterial4: "Select Material",
        selectFinishedProduct:"Select finished product",
        uploadSuccess: "Upload successful",
        saveSuccess: "Save successfully",


        ProcessExecution: "Process execution",
        describe1: "description",
        CreationDate: "Creation Time",
        Creator: "Created by",
        traceabilityCode1: "traceabilityCode",
        OrderNumber: "Order Number",
        operation3: "Operate",
        deleteSuccess: "Remove successful",



        type: "type",
        addFinishedProduct1: "Add finished product",
        number2: "number",
        name4: "name",
        selectBatchNumber3: "Batch List",
        pleaseSelect2: "Please select",
        inputOptionalItems:"Enter optional options separated by commas",
        cancel3: "cancel",
        confirm6: "OK",
        onlyForFieldsOfTypeNumber:"(Limited to fields of type numeric input box)",
        addRowCalculation: "Add row calculation",
        pleaseSelectField: "Please select field",
        pleaseSelectAddSubtractMultiplyAndDivide: "Please select, Create, subtract, multiply and divide",
        pleaseSelectField1: "Please select field",
        addColumnCalculation: "Add column calculation",
        pleaseSelectMethod:"Please select method",
        selectTemplateType: "Select template type",
        selectProcessType: "Select process type (required)",
        blankTemplate: "blank template",
        existingProcessTemplate: "Existing process template",
        processTableName1: "Flow table name",
        Creator2: "Created by",
        process1: "process",
        noName1: "No name",
        viewStyle: "View Style",
        close: "Close",
        save1: "Save",
        pleaseSelect3:"Please select",
        list1: "List",
        finishedProductReceipt: "Finished Product Receipt",
        transportationPlan: "transportation plan",
        transportation: "transportation",
        other: "other",
        sourceSampleTransportation: "Source Sample Transportation",
        sampleReception: "Sample Reception",
        averageValue: "average",
        maximumValue:"maximum",
        minimumValue: "minimum",
        sum: "sum",
        add: "Create",
        subtract: "minus",
        multiply: "multiply",
        divide: "divide",
        number3: "number",
        roomNumber: "Room Number",
        expressNumber: "courier number",
        phoneNumber: "Phone Number",
        idNumber: "ID number",
        specialCode: "special code",
        customTable: "Custom Table",
        richText: "rich text",
        scanCodeBox: "scan box",
        pleaseEnter: "Please enter",
        textBox: "text box",
        pleaseEnter1: "Please enter",
        approvalBox: "approval box",
        finishedProductBox: "finished box",
        materialBox: "material box",
        equipmentBox: "device box",
        attachment: "attachment",
        picture: "image",
        pleaseEnter2: "Please enter",
        operationInstructionBox: "Operation Instruction Box",
        textInputBox: "Text input box",
        timeAndDateSelection: "Time and Date Selection",
        dateSelection: "Date Selection",
        numericInputBox: "digital input box",
        dropDownSelectionBox: "drop-down selection box",
        rule: "rule",
        selectEquipmentType1: "Select Device Type",
        selectMaterial5: "Select Material",
        selectFinishedProduct1: "Select finished product",
        tableHeaderName: "Header Name",
        saveSuccess1: "Save successfully",
        delete:"Remove",

    },
    BatchInstructions: {
        BatchInstructions: "批指令下达",
        BatchInstructionsCode: "批指令编码",
        Batch: "追溯码",
        Product: "产品",
        Issuer: "指令下达人",
        IssuedDate: "指令下达时间",
        Creator: "创建人",
        CreationDate: "创建日期",
        State: "状态",
        //创建人
        // Creator:"创建人",


        save: "保存",
        list: "列表",
        state: "状态",
        BatchInstructionsCode1: "批指令编码",
        Creator1: "创建人",
        CreationDate1: "创建日期",
        State1: "状态",
        Auditor: "审核人",
        CompletionTime: "完成时间",
        OrderNumber: "订单编号",
        TraceabilityCode: "追溯码",
        ProductName: "产品名称",
        PreparationAmount: "制备量",
        ProductionStartDate: "生产起始日期",
        ProductionEndDate: "生产结束日期",
        BatchInstructionsIssuer: "批指令下达人",
        InstructionsIssuedDate: "指令下达时间",
        MaterialPreparationList: "备料单",
        MaterialPreparationListState: "备料单状态",
        SampleInformation: "样本信息",
        BOMList: "BOM清单",
        GenerateOutboundOrder: "生成备料单",
        ProductionPlanArrangement: "流程计划安排",
        PleaseSelectOrder: "请选择订单",
        PleaseSelectOperator: "请选择操作人",
        PleaseSelectAuditor: "请选择审核人",
        PleaseSelectRoom: "请选择房间",
        PleaseSelectOperator1: "请选择操作人",
        PleaseSelectCategory: "请选择类别",
        confirm: "确认",
        Verification: "验证",
        UserName: "用户名",
        Password: "密码",
        Reason: "原因",
        confirm1: "确认",
        RoomNumber: "房间编号",
        RoomName: "房间名称",
        Area: "所在区域",
        Creator2: "创建人",
        TodayArrangementTimes: "今日安排次数",
        OccupancyStatus: "占用状态",
        ExpirationDate: "距效期",
        Name: "名称",
        OrderNumber1: "订单号",
        ProductName1: "产品名称",
        ProductTraceabilityCode: "产品追溯码",
        ProductBatchNumber: "追溯码",
        OperationDate: "操作日期",
        Procedure: "工序",
        StepName: "步骤名称",
        Operator: "操作人",
        Room: "房间",
        ProcessConfiguration: "流程配置",
        TimeConsuming: "用时（天）",
        RawAndAuxiliaryMaterialNumber: "原辅料编号",
        RawAndAuxiliaryMaterial: "原辅料",
        PreparationAmount1: "准备用量",
        Unit: "单位",
        OutboundBatchNumber: "出库批次",
        OutboundAmount: "出库量",
        OutboundUnit: "出库单位",
        Barcode: "条形码",
        SampleName: "样本名称",
        SamplingDate: "采样时间",
        AlreadyOutbound: "已出库",
        Prompt: "提示",
        AlreadyGeneratedMaterialRequisition: "已生成备料单",
        OutboundSuccess: "出库成功",
        AlreadyOutbound1: "已出库",
        Prompt1: "提示",
        AlreadyGeneratedMaterialRequisition1: "已生成备料单",
        Success: "成功",
        ModifySuccess: "修改成功",
        Success1: "成功",
        SaveSuccess: "保存成功",
        //"新建"
        New: "新建",
        //"完成"
        Complete: "完成",
        //操作人或房间未选择
        OperatorOrRoomNotSelected: "操作人或房间未选择",
        //未生成备料单
        MaterialRequisitionNotGenerated: "未生成备料单",
        //备料单未出库
        MaterialRequisitionNotOutbound: "备料单未出库",
        //'待出库'
        PendingOutbound: "待出库",
        //'已出库'
        AlreadyOutbound2: "已出库",
        //请先保存数据
        PleaseSaveDataFirst: "请先保存数据",
        //筛选号
        FilterNumber: "筛选号",
        //开始时间
        StartTime: "开始时间",
        //结束时间
        EndTime: "结束时间",
        //'确认成功'
        ConfirmSuccess: "确认成功",
        //'作废成功'
        CancellationSuccess: "作废成功",
        //账号或密码错误
        AccountOrPasswordError: "账号或密码错误",
        //请先保存信息
        PleaseSaveInformationFirst: "请先保存信息",
        //已生成出库单，不可更改订单！
        CannotBeChanged: "已生成出库单，不可更改订单！",
    },

    FinishMaster:{
        FinishMaster: "finished master data",

        Warehouse: "warehouse",
        BasicInformation: "Basic Information",
        Number: "number",
        Name: "Name",
        Batch: "There is a batch",
        Category:"Category",
        State: "State",
        StorageLocation: "Storage Location",
        ItemNumber:"Item Number",
        Creator: "Created by",
        WhetherToDisableTheReminder: "Failure Reminder",
        CreationDate: "Creation Date",
        EnglishName: "English Name",
        Specifications: "specifications",
        Alias: "alias",
        InventoryInformation: "Inventory Information",
        InventoryQuantity: "Inventory Quantity",
        UnitGroup: "Unit Group",
        Unit: "Unit",
        StorageConditions: "Storage Conditions",
        OutboundPrice: "outbound price",
        ReminderLeadTime: "Reminder lead time",
        SafetyStockQuantity: "Safety Stock Quantity",
        DurableDays: "Durable days",
        Remarks: "Remarks",
        OutboundUnitGroup: "outbound unit group",
        OutboundUnit: "outbound unit",
        ManufacturerInformation: "Manufacturer Information",
        Principal: "Responsible person",
        StorageDetails:"Warehousing Details",
        NoData: "No data",
        LoadingData: "Loading data",
        Effective: "effective",
        Invalid: "invalid",
        Released: "Released",
        NotReleased: "Not released",
        No: "No",
        Yes: "Yes",
        BatchNumber: "Batch Number",
        ProductionDate:"Production Date",
        ExpirationDate: "expiration date",
        StorageDate: "Warehousing Date",
        BatchStock: "This batch stock",
        MainUnit: "Main Unit",
        State1: "State",

        NoData1: "No data",
        LoadingData1: "Loading data",
        New: "New",
        Export: "export",
        PleaseEnterTheInformationYouWantToQuery:"Please enter the information of the query",
        Operation: "Operate",
        MasterDataNumber:"Master Data Number:",
        Effective1: "effective",
        Invalid1: "invalid",
        Yes1: "Yes",
        No1: "No",
        Number1: "number",
        Specifications1: "Specification",
        Creator1: "Created by",
        CreationDate1: "Creation Date",
        WhetherToDisableTheReminder1: "Failure reminder",
        InventoryQuantity1: "Inventory Quantity",
        Name1: "Name",
        ManufacturerName: "Manufacturer Name",
        StorageLocation1: "Storage Location",
        Remarks1: "Notes",


        save: "Save",
        list:"List",
        Warehouse1: "warehouse",
        BasicInformation1: "Basic Information",
        Number2: "number",
        Name2: "Name",
        Batch1: "There is a batch",
        Category1: "Category",
        State2: "State",
        StorageLocation2: "Storage Location",
        ItemNumber1: "Item Number",
        Creator2: "Created by",
        WhetherToDisableTheReminder2: "Failure Reminder",
        CreationDate2: "Date Created",
        EnglishName1: "English Name",
        Specifications2: "Specifications",
        alias1: "alias",
        InventoryInformation1: "Inventory Information",
        InventoryQuantity2: "Inventory Quantity",
        UnitGroup1: "Unit Group",
        Unit1: "Unit",
        StorageConditions1: "Storage Conditions",
        OutboundPrice1: "outbound price",
        ReminderLeadTime1: "Reminder lead time",
        SafetyStockQuantity1: "Safety Stock Quantity",
        DurableDays1: "Durable days",
        Remarks2: "Remarks",
        OutboundUnitGroup1: "outbound unit group",
        OutboundUnit1: "outbound unit",
        ManufacturerInformation1: "Manufacturer Information",
        Principal1: "Responsible person",
        PleaseSelect:"Please select",
        NoData2: "No data",
        LoadingData2: "Loading data",
        Operation1: "Operate",
        StorageDetails1: "Inbound Details",
        NoData3: "No data",
        LoadingData3: "Loading data",
        Yes2: "Yes",
        No2: "No",
        Effective2: "effective",
        Invalid2: "invalid",
        Released1: "Released",
        NotReleased1: "Not released",
        ProjectNameCannotBeEmpty: "Project name cannot be empty",
        ProjectBatchCannotBeEmpty: "Project batch cannot be empty",
        ProjectTypeCannotBeEmpty:"Project type cannot be empty",
        ProjectStatusCannotBeEmpty:"Project status cannot be empty",
        BatchNumber1: "Batch Number",
        ProductionDate1: "Date of manufacture",
        supplierName: "supplier name",
        ExpirationDate1: "expiration date",
        StorageDate1: "Inbound Date",
        BatchStock1: "This batch stock",
        MainUnit1: "Main Unit",
        State3: "State",
        Code: "encoding",
        Describe: "Description",
        ConversionFactor: "Conversion factor",
        MainUnit2: "Main Unit",
        SubordinateUnit: "SubordinateUnit",
        State4: "Status",
        Code1: "Code",
        Describe1: "Description",
        Remarks3: "Remarks",
        Code2: "encoding",
        Name3: "Name",
        Code3: "encoding",
        Name4: "Name",
        SystemCode: "System Code",
        IdentificationCode: "Identification Code",
        // 是否qc
        WhetherQC: "是否QC",
        //生产商
        Manufacturer: "生产商",
        //请选择生产商
        PleaseSelectManufacturer: "请选择生产商",
        //生产商编号
        ManufacturerNumber:"生产商编号",
        //生产商名称
        NameOfManufacturer:"生产商名称",
        //生产商联系方式
        ManufacturerContactInformation:"生产商联系方式",
    },
    StorageInProduct:{
        StorageInProduct: "Inventory intake",

        Number: "number",
        Creator: "Created by",
        CreationDate: "Creation Time",
        Describe: "Description",
        StorageDate: "Warehousing Date",
        State: "State",

        save: "Save",
        list:"List",
        State1: "State",
        edit: "Edit data",
        ProductNumber: "Finished product number",
        Name: "Name",
        ItemNumber:"Item Number",
        Specifications: "specifications",
        ProductionDate:"Production Date",
        ProductBatchNumber: "Product Batch Number",
        ExpirationDate: "expiration date",
        StorageQuantity: "Inbound quantity",
        Unit: "Unit",
        StorageLocationID: "StorageLocationID",
        StorageLocation: "Storage Location",
        Remarks: "Remarks",
        save1: "Save",
        validate: "validate",
        UserName: "username",
        Password: "password",
        Reason: "Reason",
        confirm: "Confirm",
        pleaseSelect:"Please select a category",
        confirm1: "Confirm",
        Number1: "number",
        Describe1: "Description",
        StorageDate1: "Inbound Date",
        Department: "Department",
        StorageType: "Inbound Type",
        StorageDetails:"Warehousing Details",
        NoData: "No data",
        LoadingData: "Loading data",
        PrintLabel: "Print Label",
        Operation: "Operate",
        ProductNumber1: "Finished product number",
        Name1: "Name",
        ItemNumber1: "Item Number",
        Specifications1: "Specification",
        ProductionDate1: "Date of manufacture",
        ProductBatchNumber1: "Product Lot Number",
        ExpirationDate1: "expiration date",
        StorageQuantity1: "Outbound Quantity",
        Unit1: "Unit",
        StorageLocationID1: "Storage ID",
        StorageLocation1: "Storage Location",
        Remarks1: "Notes",

        saveSuccess:"Save success",
        saveFailed:"Save failed",

        //追溯码
        TraceCode: "追溯码",
        new: "新建",
        complete: "完成",
        //用户名或密码错误
        UserNameOrPasswordError: "用户名或密码错误",
        //入库状态已完成
        StorageStatusCompleted: "入库状态已完成",
        //入库状态未完成
        StorageStatusUnfinished: "入库状态未完成",
    },

    StorageOutProduct:{
        StorageOutProduct: "Inventory outbound",

        Number: "number",
        Recipient: "Recipient",
        Creator: "Created by",
        CreationDate: "Creation Date",
        Describe: "Description",
        State: "State",

        save: "Save",
        list:"List",
        State1: "State",
        pleaseSelect:"Please select the approver",
        NoData: "No data",
        LoadingData: "Loading data",
        Operation: "Operate",
        pleaseSelect1: "Please select",
        edit: "Edit data",
        ProductNumber: "Finished product number",
        Name: "Name",
        ItemNumber:"Item Number",
        Specifications: "specifications",
        ProductBatchNumber:"Batch Number",
        Stock: "Inventory",
        BatchStock: "This batch stock",
        UnitGroup: "Unit Group",
        OutboundQuantity: "outbound quantity",
        MainUnit: "Main Unit",
        OutboundQuantity1: "Outbound Quantity",
        SubordinateUnit: "SubordinateUnit",
        StorageLocationID: "StorageLocationID",
        StorageLocation: "Storage Location",
        Remarks: "Remarks",
        ProductBatchNumber1: "Product Lot Number",
        Department: "Department",
        save1: "Save",
        validate: "validate",
        UserName: "username",
        Password: "password",
        Reason: "Reason",
        confirm: "Confirm",
        pleaseSelect2: "Please select a category",
        confirm1: "Confirm",
        Number1: "number",
        Describe1: "Description",
        Recipient1: "Recipient",
        LogisticsNumber: "Logistics Number",
        LogisticsCompany: "Logistics Company",
        StockSample: "Stock sample",
        NoData1: "No data",
        LoadingData1: "Loading data",
        Batch: "Batch",
        Operation1: "Operate",
        StorageDetails:"Warehousing Details",
        save2: "Save",
        delete:"Remove details",
        PrintLabel: "Print Label",
        Operation2: "Operate",
        yes: "Yes",
        no: "no",
        confirm2: "Are you sure you want to delete?",
        prompt: "prompt",
        Name1: "Name",
        ProductNumber1: "Finished product number",
        Name2: "Name",
        ItemNumber1: "Item Number",
        Specifications1: "Specification",
        ProductNumber2: "Finished Product Number",
        ProductBatchNumber2: "Batch Number",
        ProductionDate:"Production Date",
        ExpirationDate: "expiration date",
        StorageQuantity: "Inbound quantity",
        StorageDate: "Warehousing Date",
        BatchStock1: "This batch stock",
        ProductNumber3: "Finished Product Number",
        Name3: "Name",
        ItemNumber2: "Item Number",
        Specifications2: "Specifications",
        ProductionDate1: "Date of manufacture",
        ProductBatchNumber3: "Product Lot Number",
        ExpirationDate1: "expiration date",
        StorageQuantity1: "Inbound Quantity",
        Unit: "Unit",
        StorageLocationID1: "Storage ID",
        StorageLocation1: "Storage Location",
        Remarks1: "Notes",
        LogisticsCompanyNumber: "Logistics Company Number",
        LogisticsCompanyName: "Logistics Company Name",

        //出库状态已完成
        StorageStatusCompleted: "出库状态已完成!",
        //出库状态未完成
        StorageStatusUnfinished: "出库状态未完成!",
    },ProjectOrderPublic:{
        projectOrder:"Project Order",
    },ProjectOrderList:{
        id:"id",
        name:"name",
        projectName:"projectName",
        productName:"productName",
        contactUser:"contactUser",
        contactPhone:"phone",
        createUser :"createUser",
        createDate :"createDate",
    },ProjectOrderEdit:{
        id:"id",
        ProjectOrderDetails:"Project Order Details",
        name:"name",
        projectName:"projectName",
        productName:"productName",
        productId:"productId",
        contactUser:"contactUser",
        contactPhone:"phone",
        createUser :"createUser",
        createDate :"createDate",
        sampleNum :"sampleNum",
        price :"price",
        totalPrice :"totalPrice",
        state:"State",
        stateName:"stateName",
        chooseProjectName:"please Select ProjectName",
        chooseProductName:"please Select ProductName",
        saveInfo:"Save success",
        updateInfo:"update success",
        confirm:"Confirm",
        verification:"verification",
        reason:"reason",
    },
    ClaimSamplePublic:{
        claimSample:"Claim Sample",
    },ClaimSampleList:{
        id:"id",
        name:"name",
        note:"note",
        createUser :"createUser",
        createDate :"createDate",
    },ClaimSampleEdit:{
        id:"id",
        ProjectOrderDetails:"Project Order Details",
        name:"name",
        note:"note",
        createUser :"createUser",
        createDate :"createDate",
        sampleNum :"sampleNum",
        state:"State",
        stateName:"stateName",
        sampleCode:"sampleCode",
        barCode:"barCode",
        dataTraffic:"dataTraffic",
        productName:"productName",
        samplingDate:"samplingDate",
        stockType:"stockType",
        qpcrConcentration:"qpcrConcentration",
        indexa:"index",
        concentration:"concentration",
        volume:"volume",
        sumTotal:"sumTotal",
        projectName:"projectName",
        customer:"customer",
        isRp:"isRp",
        scopeName:"scopeName",
        orderId:"orderId",
        crmCustomer:"crmCustomer",
        UnboundSamples:"Unbound Samples",
        BoundSample:"Bound Samples",
        TotalSamples:"bindSample",
        sampleType:"sampleType",

    },
    processExcutionList:{
        addProcessExcutionList:"Add Process Excution List",
        deleteYN:"delete or not",
        tips:"tips",
        confirm:"confirm",
        cancel:"cancel",
    },
    processExecutionEdit:{
        PZLBH:"Batch instruction number",
        orderID:"order ID",
        state:"state",
        creater:"creater",
        createDate:"create date",
        reviewedBy:"reviewed by",
        reviewedDate:"reviewed date",
        room:"Operation room",
        operator:"operator",
        estimatedDate:"estimated date",
        startTime:"start time",
        endTime:"end time",
        dongcun:"Freezing box label",
        chanpin:"Product Bag Label",
        ScanCodeRecord:"Scan Code Record",
        value:"value",
        ScanTime:"Scan Time",
        PleaseSelect:"Please Select",
        ReasonForReturn:"Reason For Return",
        ScanCodeBox:"Scan Code Box",
        code:"code",
        order:"order",
        lczx:"process execution",
        document:"document",
        close:"close",
        yswdtj:"Transportation temperature conditions",
        Sampler:"Sampler",
        phone:"phone",
        SamplingAddress:"Sampling Address",
        wllxfs:"Logistics contact information",
        logisticsCompanies:"logistics companies",
        logisticsPerson:"logistics person",
        logisticsOrderId:"logistics order ID",
        transportCondition:"transport condition",
        wendujiguanbi:"Thermometer off time",
        jieshouren:"recipient",
        jieshoushijian:"Reception time",
        CZRBYZWFBJ:"The operator is inconsistent and cannot be edited",
        pleaseSave:"Please save first",
        tips:"tips",
        qxwcsybz:"Please complete all steps",
        ReceivedSuccessfully:"Received Successfully！",
        WarehousingFailed:"Warehousing Failed！",
        QTXPC:"Please fill in the batch！",
        DeliverySuccessful:"Delivery Successful！",
        OutboundFailed:"Outbound Failed！",
        MYPCWFCK:"No batch, unable to ship out！",
        ScanCodeSuccessfully:"Scan Code Successfully",
        GPCYSM:"This batch has been scanned",
        ScanCodeFailed:"Scan Code Failed",
        ZTWQRBNJRXYB:"Status not confirmed, unable to proceed to the next step",
        confirm:"confirm",
        cancel:"cancel",
        Completed:"Completed",
        FWQFMQSHZS:"The server is busy, please try again later",
        WLLJSBQCS:"Network connection failed, please try again",
        //编号
        Number: "编号",
        //运输
        transport: "运输",
    },
    processVUE:{
        room:"Operation room",
        operator:"operator",
        estimatedDate:"estimated date",
        startTime:"start time",
        endTime:"end time",
        dongcun:"Freezing box label",
        chanpin:"Product Bag Label",
        PleaseSelect:"Please Select",
        ReasonForReturn:"Reason For Return",
        ScanCodeBox:"Scan Code Box",
        ScanCodeRecord:"Scan Code Record",
        code:"code",
        close:"close",
        yswdtj:"Transportation temperature conditions",
        Sampler:"Sampler",
        phone:"phone",
        SamplingAddress:"Sampling Address",
        wllxfs:"Logistics contact information",
        logisticsCompanies:"logistics companies",
        logisticsPerson:"logistics person",
        logisticsOrderId:"logistics orderId",
        transportCondition:"transport condition",
        wendujiguanbi:"Thermometer off time",
        jieshouren:"recipient",
        jieshoushijian:"Reception time",
        state:"state",
        tips:"tips",
        qxwcsybz:"Please complete all steps",
        ConfirmedSuccessfully:"Confirmed Successfully",
        VoidedSuccessfully:"Voided Successfully",
        ReceivedSuccessfully:"Received Successfully！",
        WarehousingFailed:"Warehousing Failed！",
        QTXPC:"Please fill in the batch！",
        DeliverySuccessful:"Delivery Successful！",
        OutboundFailed:"Outbound Failed！",
        MYPCWFCK:"No batch, unable to ship out！",
        confirm:"confirm",
        cancel:"cancel",
        Completed:"Completed",
        FWQFMQSHZS:"The server is busy, please try again later",
        WLLJSBQCS:"Network connection failed, please try again",
    },
    masterdataFlowPathConfigVUE:{
        ExpectedTime:"Expected Time",
        used:"used",
        unit:"unit",
        pzljs:"Batch instruction reception",
        Release:"Release",
        id1:"step number",
        id2:"Retroactive code",
        id3:"Order number",
        id4:"Batch order number",
        id5: "样本条码号",

    },
    coiOrderEdit:{
        qxzlb:"Please select a category",
        returnReason:"return reason",
        confirm:"confirm",
        checking:"checking",
        Username:"Username",
        passward:"passward",
        reason:"reason",
        tabulation:"tabulation",
        state:"state",
        Successfully:"Successfully",
        SuccessfullyReturned:"Successfully Returned",
        ConfirmedSuccessfully:"Confirmed Successfully",
    },
    ExperimentalTypeConfigurationPublic:{
        ExperimentalTypeConfiguration:"Experimental Type Configuration",
    },
    ExperimentalTypeConfigurationList:{
        experimentalTypeName:"Experimental Type Name",
        state:"Valid or not",
        creator:"creator",
        createTime:"createTime",
        yes:"yes",
        no:"no",
        SuccessfullySaved:"Successfully Saved",
        SaveFailed:"Save Failed",
        SuccessfullyDeleted:"Successfully Deleted",
        save:"save",
        effectiveperson: "Effective person",
        effectivetime: "Effective time",
        takeEffect: "take effect",
        code: "Experiment number identification",
        istakeEffect: "Whether it takes effect",
        Confirm: "You confirm that you want",
        me:"Is it?",
        stateTakeEffect:"Whether to confirm the validity",
        SuccesstakeEffect:"Successtake Effect",
        failedtotakeeffect:"Failed to take effect",
        ExperimentalTypeNameCannotBeEmpty: "实验类型名称不能为空",
        //数据库表后缀不能为空
        DatabaseTableSuffixCannotBeEmpty: "数据库表后缀不能为空",
        //实验编号标识不能为空
        ExperimentalNumberIdentifierCannotBeEmpty: "实验编号标识不能为空",
        //请选择一条数据
        PleaseSelectARecord: "请选择一条数据",
    },


    WorkflowNodePublic:{
        WorkflowNode:"Workflow Node",
    },
    WorkflowNodeList:{
        name:"Name",
        cls:"Class path",
        oper:"Passed or Not",
        orderBlock:"Module Name",
        note:"Note",
        pleaseSelect:"Please Select",
        pass:"Pass",
        noPass:"No Pass",
    },
    WorkflowNodeEdit:{
        save:"Save",
        back:"List",
        NAME:"Name",
        pleaseSelect:"Please Select",
        pass:"Pass",
        noPass:"No Pass",
        data:"name",
        SuccessfullyAdded:"Successfully Saved",
        SaveFailed:"Save Failed",
        SuccessfullyModified:"Update Success",
        UpdateFailed:"Update Failed",
        describe:"Description",
        classPath:"Class Path",
        SelectBlock:"Selection Block",
        ApprovalOptionDefinition:"Approval Options Definition",
        PassedorNot:"Passed or Not",
        status:"State Code",
        StatusName:"Status Name",
        Note:"Note",
        founder:"Created by",
        CreationTime:"Created Time",
        SelectBlockPopup:"Selection Module",
    },

    //储存盒子
    storagePositionBox:{
        storagePositionBox:"储存盒子",
        add:"添加明细",
        del:"删除选中",
        save:"保存",
        container:"选择容器",
        sampleType:"选择样本类型",
        id:"编号",
        name:"描述",
        newLocationId:"新储位号",
        locationName:"存储位置",
        storageContainerId:"容器编号",
        storageContainer:"容器",
        state:"状态",
        typeId:"样本类型编号",
        pleaseSelect:"请选择",
        type:"样本类型",
        typeMark:"编码标记",
        containerId:"容器编号",
        containerName:"容器名称",
        containerColNum:"列数",
        containerRowNum:"行数",
        containerType:"类型",
        SavedSuccessfully:"保存成功",
        SaveFailed:"保存失败"

    },
    //盒子内迁移样本记录
    storagePositionBoxMove:{
        storagePositionBoxMove:"迁移记录",
        id:"编号",
        name:"描述",
        locationId:"储位ID",
        locationName:"储位描述",
        changeUser:"修改人",
        changeDate:"修改时间",
        state:"状态",
        note:"备注",
        storagePositionBoxId:"盒子编号",
        storagePositionBoxName:"盒子描述",
    },
    // 盒子内全部样本
    storagePositionBoxSample:{
        storagePositionBoxSample:"样本信息",
        id:"编号",
        code:"描述",
        sampleCode:"储位编号",
        sampleType:"储位描述",
        storagePositionBoxId:"盒子编号",
        storagePositionBoxName:"盒子描述",
        boxLocation:"盒子位置",
    },

    ApprovalHistory: {
        //流程实例ID
        processInstanceId: "流程实例ID",
        //发起人ID
        startUserId: "发起人ID",
        //发起人
        startUserName: "发起人",
        //相关表单ID
        businessKey: "相关表单ID",
        //表单名称
        formName: "表单名称",
        //表单对应实体的类路径
        entityPath: "表单对应实体的类路径",
        //表单提示
        formTips: "表单提示",
        //开始时间
        startTime: "开始时间",
        //结束时间
        endTime: "结束时间",
        //业务ID
        businessId: "业务ID",
        //版本
        version: "版本",
        //状态
        state: "状态",
        //是否子流程
        isSubProcess: "是否子流程",
        //主流程ID
        parentProcessInstanceId: "主流程ID",
        //任务名称
        taskName: "任务名称",
        //办理人
        assignee: "办理人",
        //办理时间
        claimTime: "办理时间",
        //办理结果
        claimResult: "办理结果",
        //办理意见
        claimOpinion: "办理意见",
        //代办信息
        todoInfo: "代办信息",
        //审批明细
        approvalDetail: "审批明细",
        //查看表单
        viewForm: "查看表单",
        //未查询到相关表单ID对应的路由信息
        noRouterInfo: "未查询到相关表单ID对应的路由信息",
        //请选择一条数据
        PleaseSelectARecord: "请选择一条数据",
    },

    workflowHistoryPublic:{
        //审批历史
        workflowHistory:"Workflow History",
    },
    // Ticket:{
    //     Ticket: "Task List",
    // },
    TicketList:{
        Id: "Number",
        Note: "Description",
        OrderType: "Task Order Type",
        CreateUser: "Creator Name",
        CreateDate: "Creation time",
        ConfirmUser: "Reviewer",
        ConfirmDate: "Audit Time",
        State: "State",
    },
    ticketEdit:{
        id: "number",
        state: "state",
        note: "description",
        orderType: "Ticket Type",
        confirmUser: "Approver",
        remark: "Note",
        experimentGroup: "experimental group",
        experimenter: "experimenter",
        qcRequest: "QC Request",
        chooseConfirmUser: "Please select the approver",
        chooseExperimentGroup: "Please select the experimental group",
        chooseExperimenter: "Please select the experimenter",
        viewAttachment: "View attachment",
        taskList: "Task List",
        testItem: "Test Item",
        batchItem: "Batch Project",
        nextFlow: "Next Flow",
        chooseTestItem: "Please select the detection item",
        chooseBatchItem: "Please select a batch item",
        chooseNextFlow: "Please select the next flow direction",
        code: "encoding",
        name: "name",
        customerUnit: "Customer Unit",
        doctorName: "Doctor's Name",
        userName: "Name",
        sampleCode: "sample number",
        barCode: "barcode",
        dataFluxGB: "data flux GB",
        checkItem: "Check Item",
        samplingTime: "sampling time",
        externalSampleCode: "External Sample Number",
        sampleType: "Sample Type",
        samplePosition: "Sample Location",
        qpcrConcentration: "QPCR concentration",
        index:"index",
        concentration: "concentration (ng/ul)",
        volume: "volume",
        total:"total",
        itemName: "Project Name",
        crmCustomer: "Customer",
        costCenter: "cost center",
        isDyeing: "whether there is a dye or not",
        qcTaskNo: "QA Task Number",
        groupNo: "group number",
        sampleNo: "sample number",
        originalSampleNo: "Original sample number",
        itemId: "Item Number ID",
        orderNo: "order number",
        samplingPosition: "sampling site",
        chooseTestItems: "Select Detection Items",
        customerName: "Customer Name",
        createUser: "Created by",
        createDate: "Created Time",
        chooseExperimentGroupFirst: "Please select the experimental group first",
        saveFail: "Save failed",
        saveSuccess: "Save successfully",
    },
    // 生物样本库相关国际化
    BioBank: {
        SampleStorage: "Sample Storage",
        PendingSample: "Sample To Be Stored",
        ListOfRefrigeratedCabinets: "List Of Refrigerated Cabinets",
        RefrigeratedCabinetDisplay: "Refrigerated Cabinet Display",
        SampleDelivery: "Sample Delivery",
        SampleCode: "Sample Code",
        Code: "Code",
        SampleType: "Sample Type",
        SamplePosition: "Sample Position",
        SampleStatus: "Sample Status",
        Concentration: "Concentration",
        Volume: "Volume",
        SumTotal: "Total",
        Unit: "Unit",
        ProductId: "Product Id",
        ProductName: "Product Name",
        CreateUser: "Creator",
        CreateDate: "Create Date",
    },
    InventoryMasterData: {
        Spec: "Spec",
        Batch: "Batch",
        BatchNo: "Batch No",
        LoseEffectivenessWarningOrNot: "Lose Effectiveness Warning Or Not",
        Stock: "Stock",
        UnitGroup: "Unit Group",
        WarningDays: "Warning Days",
        QCOrNot: "QC Or Not",
        Name: "Name",
        HasQC: "Has QC",
        NoQC: "No QC",
        StockUnit: "Stock Unit",
        MaterialPurchaseDetail: "Material Purchase Detail",
        MaterialPurchase: "Material Purchase",
    },
    StorageIn: {
        Title: "Storage In",
        // 入库单列表
        List: "Storage In List",
        PurchaseOrderNo: "Purchase Order No.",
        MaterialCode: "Material Code",
        MaterialName: "Material Name",
        Total: "Storage In Total",
    },
    StorageOut: {
        Title: "Storage Out",
        List: "Storage Out List",
        MaterialCode: "Material Code",
        MaterialName: "Material Name",
        // 出库到实验
        ToExperiment: "To Experiment",
        // 销毁
        Destroy: "Destroy",
        Type: "Storage Out Type",
        // 批量添加
        BatchAdd: "Batch Add",
        //打包出库
        PackageOut: "Package Out",
    },
    ReagentMainData: {
        Title: "Reagent Main Data",
        List: "Reagent Main Data List",
    },
    TargetValue:{
        targetValue: "target",
        save: "save",
        batchInput: "batch entry",
        selectControl: "Please select a control",
        selectProduct:"Please select a product",
        sd: "SD",
        cv: "CV",
        upperControlLimit: "Runaway Limit",
        lowerControlLimit:"lower runaway limit",
        controlName: "Control",
        productName: "product",
        enableTime: "Enable time",
        endTime: "deadline",
        createUserName: "Created by",
        createDate: "Created Time",
        controlId: "Control Number",
        productId: "Product Number",
        selectControl1: "Select Control",
        selectProduct1: "Select Product",
        selectOneData: "Please select a piece of data",
        number: "Target value, SD, CV, runaway upper limit, runaway lower limit, should fill in the number",
        numberIsValidValue: "Target value should be filled in with numbers",
        numberIsValidSD: "SD should be filled in with numbers",
        numberIsValidCV: "CV should be filled in with numbers",
        numberUpperControlLimit: "Runaway upper limit should be filled in with numbers",
        numberLowerControlLimit: "Runaway lower limit should be filled in with numbers",
        enableTimeIsNull: "Enable time cannot be empty",
        endTimeIsNull: "Deadline cannot be empty",
        pleaseSelectData: "Please select a piece of data!",
        saveInfo: "Save successfully!",
        updateInfo: "Update successfully!",
    },
    QualityMaintenance:{
        qualityMaintenancd: "Quality Control Data Maintenance",
        save: "save",
        batchInput: "batch entry",
        selectControl: "Please select a control",
        controlDate: "Quality Control Date",
        controlName: "Control",
        controlId: "Control Number",
        controlBatchNo: "Control lot number",
        productName: "product",
        targetValue: "target",
        sd: "SD",
        cv: "CV",

        controlResult: "Quality Control Result",
        controlState: "out of control",
        controlReason: "Loss of control cause",
        controlDeal: "Runaway Deal",
        dealResult: "Process Result",
        dealUser: "processor",
        dealTime: "processing time",
        auditUser: "Approver",
        auditTime: "audit time",
        auditState: "Audit status",
        createUserName: "Created by",
        createDate: "Created Time",

        controlId1: "Control Number",
        controlName1: "Control",
        productId: "Product Number",
        productName1: "product",
        selectControl1: "Select Control",
        selectProduct1: "Select Product",
        selectOneData: "Please select a piece of data",
        number: "Target value, SD, CV,qualityResult, should fill in the number",
        selectControlDate: "Please select the quality control date",

        qualityChart:"Quality Control Chart",
        queryDate:"Query Date",
        startTime:"Start Time",
        endTime:"End Time",
        qualityDataInterpretation:"Quality Control Data Interpretation",
        lostControl:"Lost Control",
        notLostControl:"Not Lost Control",
        audited:"Audited",
        notAudited:"Not Audited",
        endTimeGreaterThanStartTime:"The end time cannot be less than the start time",
        pleaseFilterTheSameControl:"Please filter the same control",
        controlResult1:"Quality Control Result",
        standardDeviation1Max: "standard deviation 1 maximum",
        standardDeviation1Min: "standard deviation 1 minimum",
        standardDeviation2Max: "standard deviation 2 maximum",
        standardDeviation2Min: "standard deviation 2 minimum",
        standardDeviation3Max: "standard deviation 3 maximum",
        standardDeviation3Min: "standard deviation 3 minimum",
        ateInquiry: "Date of inquiry",
        confirm: "Confirm",
        saveInfo: "Save successfully",
        updateInfo: "Modified successfully",
        // 靶值，SD,CV,质控结果不能为空
        controlResultIsNull: "Target values, SD, CV, and quality control results cannot be empty",

    },
    SampleOrder: {
        Title: "Sample Order",
        OrderNo: "Order No.",
        List: "Sample Order List",
    },
    // 工作流状态
    WorkflowStatus: {
        "3": "NEW",
        "1": "Complete",
        "0": "Cancel",
        "15": "To Be Modified",
        "20": "Issued",
    },
    // 性别
    Gender: {
        "1": "Male",
        "0": "Female",
        "2": "Unknown",
    },
    // 报告任务发送
    reportTaskDistributionList: {
        // id
        id: "id",
        // 原始样本编号
        sampleNo: "Sample No.",
        // 订单编号
        orderNo: "Order No.",
        // 检测项目
        productName: "Product Name",
        // 平台流入
        platformFlow:  "Platform Flow",
        // 实验流入
        experimentFlow: "Experiment Flow",
        // 报告撰写人
        reportWriter:  "Report Writer",
        // 创建人
        createUserName: "Creat User Name",
        // 创建时间
        createDate: "Create Date",
        // 状态
        state: "State",
        // 姓名
        name: "Name",
        // 请选择撰写人
        selectWriter: "Please Select Writer",
        // 请先选择数据
        pleaseSelectData: "Please Select Data！",
        // 批量录入-撰写人
        batchEntryWriter: "Batch Entry Writer",
        // 合并生成
        mergeGeneration: "Merge Generation",
        // 单个生成
        singleGeneration:  "Single Generation",
        // 未选择撰写人！
        pleaseSelectWriter: "Please Select Writer！",
        // 选择成功
        selectSuccess: "Select Success",
        // 操作失败
        operationFailed: "Operation Failed",
        // 生成成功
        generationSuccess: "Generation Success",
        //订单编号存在不同数据，无法进行合并生成，请重新选择！
        mergeOrder: "Order No. Different, Please Select Again！",
        //报告任务分发
        reportTaskDistribution: "报告任务分发",
        isRetract: "是否撤回",
        //是
        yes: "是",
        //否
        no: "否",
    },
    ExperimentConfig: {
        databaseTableSuffix: "Database Table Suffix",
    },

    ExportExperimentEdit: {
        //外送实验
        exportExperiment: "外送实验",
        //检测项目
        productName: "产品名称",
        //样本类型
        sampleType: "样本类型",
        //原始样本编号
        sampleNo: "原始样本编号",
        //下一步流向
        nextFlow: "下一步流向",
        //状态名称
        stateName: "状态名称",
        //外送单位
        exportUnit: "外送单位",
        //地址
        address: "地址",
        //是否已外送
        isExport: "是否已外送",
        //外送人
        exportUser: "外送人",
        //外送时间
        exportTime: "外送时间",
        //外送原因
        exportReason: "外送原因",
        //期望出报告时间
        expectReportTime: "期望出报告时间",
        //检测结果
        testResult: "检测结果",
        //出具报告时间
        reportTime: "出具报告时间",
        //登记报告时间
        registerReportTime: "登记报告时间",
        //创建人
        createUserName: "创建人",
        //创建时间
        createDate: "创建时间",

        //样本信息
        sampleInfo: "选择信息",
        //外送
        export: "外送",
        //提交样本
        submitSample: "提交样本",
        //请选择一条数据
        selectOneData: "请选择一条数据",

        //检测项目：
        productNameMix: "产品名称：'",
        //未选择外送单位！
        notSelectExportUnit: "'未选择外送单位！",
        //未填写外送地址
        notWriteExportAddress: "'未填写外送地址！",
        //未填写外送原因
        notWriteExportReason: "'未填写外送原因！",
        //未填写期望出报告日期
        notWriteExpectReportTime: "'未填写期望出报告时间！",
        //外送成功
        exportSuccess: "外送成功！",
        //提交成功
        submitSuccess: "提交成功！",
        //上传附件
        uploadAttachment: "上传附件",
        //查看附件
        viewAttachment: "查看附件",
        //添加成功
        addSuccess: "添加成功！",

        //保存成功
        saveSuccess: "保存成功！",

        //已提交实验
        submittedExperiment: "已提交实验",
        //已外送实验
        exportedExperiment: "已外送实验",
        //待外送实验
        pendingExportExperiment: "待外送实验",

        //请选择数据
        selectData: "请选择数据！",

        //编号
        id: "编号",
        //下一步流向名称
        nextFlowName: "下一步流向名称",
        //名称
        name: "名称",

        //附件
        attachment: "附件",
        //下载
        download: "下载",
        //删除
        delete: "删除",
        //文件名
        fileName: "文件名",
        //文件上传时间
        fileUploadTime: "文件上传时间",
        //上传人
        uploadUser: "上传人",
        //是否确认删除？
        confirmDelete: "是否确认删除？",
        //删除成功
        deleteSuccess: "删除成功！",
        //您已取消
        youHaveCancelled: "您已取消！",
    },

    //区域管理
    RegionManagement: {
        //区域管理
        title: "区域管理",

        areaNo: "区域编号",
        name: "区域名称",
        state: "区域状态",
        note: "备注",
        createDate: "创建日期",
        createUserName: "创建人",

        stateYes: "可用",
        stateNo: "不可用",
        save: "保存",
        saveSuccess: "保存成功",
        saveFail: "保存失败",

        nameNotNull: "区域名称不能为空!",
        stateNotNull: "区域状态不能为空!",
    },

    //房间清洁管理
    RoomCleanManagement: {
        title: "房间清洁管理",
        title2: "清洁消毒项目",

        id: "房间清洁编号",
        note: "备注",
        cleanType: "清洁类型",
        area: "区域",
        roomId: "房间编号",
        roomName: "房间名称",
        disinfectant: "消毒剂",
        disinfectantName: "消毒剂名称",
        batch: "批号",
        disinfectStartTime: "消毒开始时间",
        disinfectValidityTime: "消毒有效期至",
        checkUserName: "复核人员",
        checkDate: "复核日期",
        userName: "用户名",
        password: "密码",
        createUser: "清洁人",
        createDate: "清洁日期",

        save: "保存",
        back: "列表",
        chooseData: "请选择数据",
        confirm: "确认",
        reCheck: "复核",
        noMatched: "用户名或密码不正确！",
        notNull: "不允许为空！",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        reCheckSuccess: "复核成功！",
        reCheckFail: "复核失败！",
        pleaseSave: "请先保存！",

        ceiling: "天花板、地面",
        ground: "地面",
        centrifuge: "离心机",
        trolley: "小推车",
        airInlet: "回风口",
        roomDoor: "房间门",
        emergencyDoor: "安全门",
        garbageBasket: "垃圾筐",
        sealingHeatExchanger: "封管热合器",
        mesa: "台面",
        biosafetyCabinet: "生物安全柜",
        incubator: "培养箱",
        workChair: "工作椅",
        transferWindow: "传递窗",
        goodsShelves: "货架",
        valvePipeline: "阀门、管路",
        storageBox: "收纳箱",
        cleaningAppliance: "清洁器具",
        doorHandle: "门把手",
        ladder: "梯子",
        stainSteelDeskTop: "不锈钢桌面",
        sterileNozzleMachine: "无菌接管机",
    },

    //环境监测模板管理
    EnMonTempManagement: {
        title: "环境监测模板管理",

        save: "保存",
        back: "列表",
        submit: "提交",
        execute: "办理",

        id: "编号",
        createUser: "创建人",
        createDate: "创建时间",
        note: "备注",
        state: "状态",
        checkType: "监测类型",
        confirmUser: "审核人",
        region: "区域",
        regionId: "区域编码",
        userName: "用户名",
        userNickName: "姓名",

        //item
        name: "名称",
        monitoringPoint: "检测点",
        type: "种类",
        testBasisName: "检测依据",

        roomDetail: "房间明细",
        insDetail: "设备明细",
        userDetail: "人员明细",
        pleaseSelect: "请选择数据",
        notNull: "不允许为空！",
        mustBePositiveInteger: "必须为正整数！",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        batchAdd: "批量添加",
        chooseType: "选择种类",
        saveFirst: "请先保存！",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        chooseTestBasis: "选择检测依据",
        fileId: "文件编码",
        fileName: "文件名称",

        //房间
        roomNo: "房间编号",
        roomName: "房间名称",
        chooseRoom: "选择房间",
        belongArea: "所属区域",
        roomState: "房间状态",
        canNotUse: "不可以使用",
        canUse: "可以使用",
        isUsed: "占用状态",
        used: "已占用",
        noUsed: "未占用",
        centiare: "房间面积m²",
        stere: "房间体积m³",
        testNo: "监测点个数",
        //设备
        insNo: "设备编号",
        insName: "设备名称",
        chooseIns: "选择设备",
        contractnumber: "序列号",
        invoicenumber: "型号",
        producerId: "生产商ID",
        producerName: "生产商名称",
        //人员
        userNo: "人员编号",
        userTitle: "人员名称",
        chooseUser: "选择人员",

        testTypeChange: "明细表中存在数据，无法修改监测类型！",
        acceptableStandard: "可接受标准",
    },

    //洁净区悬浮粒子测试记录
    SuspendedParticle: {
        title: "洁净区悬浮粒子测试记录",
        roomTestDetail: "房间检测信息",
        insTestDetail: "设备检测信息",
        room: "房间",
        ins: "设备",

        id: "编号",
        testArea: "检测区域",
        testIns: "检测设备",
        createUserNickName: "创建人",
        createDate: "创建时间",
        testDate: "检测日期",
        getUserNickName: "采样人",
        testType: "检测类型",
        cleanAreaLevel: "洁净区级别",
        stateName: "状态",
        note: "备注",
        testInsId: "检测设备编号",
        testValidDate: "检验有效期至",
        cleanAreaState: "洁净区状态",
        getAmount: "采样量",
        testBasis: "检测依据",
        confirmUser: "审核人",
        confirmDate: "审核日期",
        conclusion: "结论",
        getRoomTwoIsOk: "采样房间面积是否符合要求",
        getByPositionPic: "依据取样位置图取样",
        fileNo: "文件编号",
        upload: "上传附件",
        view: "查看附件",
        file: "附件",
        monitoringPoint: "检测点",
        monitoringPointId: "检测点编号",
        size1: "粒径≥0.5µm",
        size2: "粒径≥5.0µm",

        save: "保存",
        list: "列表",
        submit: "提交",
        execute: "办理",
        saveFirst: "请先保存数据！",
        uploadSuccess: "上传成功",
        cantNull: "不允许为空",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        pleaseSelect: "请选择数据",
        stateYes: "可用",
        stateNo: "不可用",
        noFound: "未找到该检测依据的监测点",
        testTypeChange: "检测信息表中存在数据，无法修改检测类型！",

        //检测区域
        areaNo: "区域编号",
        areaName: "区域名称",
        //设备
        insNo: "设备编号",
        insName: "设备名称",
        contractnumber: "序列号",
        invoicenumber: "型号",
        producerId: "生产商编号",
        producerName: "生产商名称",
        //采样人
        userName: "用户名",
        userNickName: "姓名",
        //检测依据
        fileId: "文件编码",
        fileName: "文件名称",
        //附件
        uploadTime: "上传时间",
        uploadUser: "上传人",

        //房间子表
        roomName: "房间名称",
        roomCode: "房间编号",
        chooseRoom: "房间模板",
        //设备子表
        chooseIns: "设备模板",
    },

    //洁净区浮游菌测试记录
    AirborneMicrobe: {
        title: "洁净区浮游菌测试记录",

        id: "编号",
        desc: "描述",
        testArea: "检测区域",
        testIns: "检测设备",
        testInsId: "检测设备编号",
        testValidDate: "校验有效期至",
        cleanAreaState: "洁净区状态",
        cultureCondition: "培养条件℃",
        cultureMediumName: "培养基名称",
        cultureMediumSpec: "培养基规格",
        cultureMediumBatch: "培养基批号",
        cultureMediumValidDate: "培养基有效期至",
        testBasis: "检测依据",
        qc: "QC",
        qcDate: "QC审核日期",
        confirmUser: "审核人",
        confirmDate: "审核日期",
        createUser: "创建人",
        createDate: "创建时间",
        testDate: "检测日期",
        getUser: "采样人",
        testType: "检测类型",
        cleanAreaLevel: "洁净区等级",
        state: "状态",
        getRoomTwoIsOk: "采样房间面积是否符合要求",
        getByPositionPic: "依据取样位置图取样",
        fileNo: "文件编号",
        fileName: "文件名称",
        note: "备注",
        pleaseSelect: "请选择数据",
        testStart: "检测开始",
        testEnd: "检测结束",
        cultureStart: "培养开始",
        cultureEnd: "培养结束",
        chooseRoom: "房间模板",
        chooseIns: "设备模板",
        printLabel: "打印标签",
        saveFirst: "请先保存数据！",
        uploadSuccess: "上传成功",
        cantNull: "不允许为空",
        saveBtn: "保存",
        listBtn: "列表",
        submitBtn: "提交",
        handle: "办理",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        noFound: "未找到该检测依据的监测点",
        testTypeChange: "检测信息表中存在数据，无法修改检测类型！",

        //检测区域弹窗
        areaId: "区域ID",
        areaName: "名称",

        //检测设备弹窗
        insNo: "设备编号",
        insName: "设备名称",
        contractnumber: "序列号",
        invoicenumber: "型号",
        producerName: "生产商名称",

        //采样人弹窗
        userName: "用户名",
        userNickName: "姓名",

        //培养基弹窗
        reagentNo: "试剂编码",
        spec: "规格",
        manufacturerName: "生产商",
        name: "名称",
        batch: "批号",
        expireDate: "过期时间",

        //检测依据
        fileId: "文件编码",

        //附件
        upload: "上传附件",
        view: "查看附件",
        file: "附件",
        uploadTime: "" +
            "上传时间",
        uploadUser: "上传人",

        //房间检测信息子表
        roomTestDetail: "房间检测信息",
        roomName: "房间名称",
        roomCode: "房间编号",
        getAmount: "采样量",
        getAmount1: "500L",
        getAmount2: "1000L",
        airborneMicrobeConcentration: "浮游菌浓度(cfu/m³)",

        //设备检测信息子表
        insTestDetail: "设备检测信息",

        //阴性对照检测信息
        negativeControlTestDetail: "阴性对照检测信息",
        negativeControl: "阴性对照",
        monitoringPoint: "检测点",
        monitoringPointId: "检测点编号",
        qrCode: "二维码",
        testStartTime: "检测开始时间",
        testEndTime: "检测结束时间",
        cultureStartTime: "培养开始时间",
        cultureEndTime: "培养结束时间",
        colonyCount: "菌落数(cfu/皿)",
        value: "数值",
        conclusion: "结论",

        //打印标签
        ip: "IP地址",
        printCode: "打印指令",
        effective: "有效",
        invalid: "无效",
    },

    //洁净区风量测试记录
    WindValue: {
        title: "洁净区风量测试记录",
        roomTestDetail: "房间检测信息",

        id: "编号",
        createUser: "创建人",
        createDate: "创建时间",
        testDate: "检测日期",
        testArea: "检测区域",
        cleanAreaLevel: "洁净区等级",
        state: "状态",
        testUser: "检测人",
        testBasis: "检测依据",

        file: "附件",
        fileName: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",

        saveBtn: "保存",
        listBtn: "列表",
        submitBtn: "提交",
        handle: "办理",
        upload: "上传附件",
        view: "查看附件",

        submitSuccess: "提交成功",
        submitFail: "提交失败",
        saveFirst: "请先保存数据！",
        uploadSuccess: "上传成功",
        pleaseSelect: "请选择数据",
        noFound: "未找到该检测依据的监测点",
        cantNull: "不允许为空",
        saveSuccess: "保存成功",
        saveFail: "保存失败",

        roomName: "房间名称",
        roomCode: "房间编号",
        passFilterCode: "过滤器编号",
        windValue1: "风量1(m³/h)",
        windValue2: "风量2(m³/h)",
        windValue3: "风量3(m³/h)",
        realWindValue: "实测送风量",
        changeWindCount: "换气次数(次)",
        roomVolume: "房间体积(m³)",
        acceptableStandard: "可接受标准(≥)",
        result: "结果",
        result1: "合格",
        result0: "不合格",
        note: "备注",
        chooseRoom: "房间模板",
        userName: "用户名",
        userNickName: "姓名",
        fileId: "文件编码",
        areaId: "区域ID",
        areaName: "名称",
        insNo: "设备编号",
        insName: "设备名称",
        contractnumber: "序列号",
        invoicenumber: "型号",
        producerName: "生产商名称",
        conclusion: "结论",
        confirmUser: "审核人",
        confirmDate: "审核日期",
        testIns: "检测设备名称",
        testInsId: "检测设备编号",
    },

    //洁净区沉降菌测试记录
    SettlingMicrobe: {
        title: "洁净区沉降菌测试记录",

        id: "编号",
        desc: "描述",
        testArea: "检测区域",
        createUser: "创建人",
        createDate: "创建时间",
        testDate: "检测日期",
        getUser: "采样人",
        testType: "检测类型",
        cleanAreaLevel: "洁净区级别",
        cleanAreaState: "洁净区状态",
        state: "状态",
        cultureCondition: "培养条件℃",
        cultureMediumName: "培养基名称",
        cultureMediumSpec: "培养基规格",
        cultureMediumBatch: "培养基批号",
        testBasis: "检测依据",
        getStartDate: "采样开始时间",
        getEndDate: "采样结束时间",
        qc: "QC",
        qcDate: "QC审核日期",
        confirmUser: "审核人",
        confirmDate: "审核日期",
        conclusion: "结论",
        getRoomTwoIsOk: "采样房间面积是否符合要求",
        getByPositionPic: "依据取样位置图取样",
        fileNo: "文件编号",
        fileName: "文件名称",
        note: "备注",

        room: "房间",
        ins: "设备",

        saveBtn: "保存",
        listBtn: "列表",
        submitBtn: "提交",
        handle: "办理",
        pleaseSelect: "请选择数据",
        testTypeChange: "检测信息表中存在数据，无法修改检测类型！",
        saveFirst: "请先保存数据！",
        uploadSuccess: "上传成功",
        cantNull: "不允许为空",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        submitSuccess: "提交成功",
        submitFail: "提交失败",

        //检测区域弹窗
        areaId: "区域ID",
        areaName: "名称",
        //采样人||审核人弹窗
        userName: "用户名",
        userNickName: "姓名",
        //培养基名称弹窗
        reagentNo: "试剂编码",
        name: "名称",
        spec: "规格",
        manufacturerName: "生产商",
        batch: "批号",
        expireDate: "过期时间",
        //检测依据弹窗
        fileId: "文件编码",
        //附件
        file: "附件",
        upload: "上传附件",
        view: "查看附件",
        uploadTime: "上传时间",
        uploadUser: "上传人",

        roomTestDetail: "房间检测信息",
        insTestDetail: "设备检测信息",
        negativeControlTestDetail: "阴性对照检测信息",
        roomName: "房间名称",
        roomCode: "房间编号",
        insName: "设备名称",
        insNo: "设备编号",
        monitoringPoint: "检测点",
        monitoringPointId: "检测点编号",
        qrCode: "二维码",
        testStartTime: "检测开始时间",
        testEndTime: "检测结束时间",
        cultureStartTime: "培养开始时间",
        cultureEndTime: "培养结束时间",
        testResult: "检测结果(cfu/皿)",
        value: "数值",
        testStart: "检测开始",
        testEnd: "检测结束",
        cultureStart: "培养开始",
        cultureEnd: "培养结束",
        chooseRoom: "房间模板",
        printLabel: "打印标签",
        ip: "IP地址",
        printCode: "打印指令",
        effective: "有效",
        invalid: "无效",
        negativeControl: "阴性对照",
    },

    SampleOutApply: {
        //样本库出库申请
        sampleOutApplySample: "样本库出库申请",
        //出库申请
        sampleOutApply: "出库申请",
        //库存样本
        stockSample: "库存样本",
        //申请明细
        applyDetails: "申请明细",
        //申请明细：
        applyDetailsMix: "申请明细：",

        //编号
        id: "编号",
        //描述
        description: "描述",
        //出库类型
        outType: "出库类型",
        //创建人
        createUser: "创建人",
        //创建时间
        createDate: "创建时间",
        //审核人
        confirmUser: "审核人",
        //完成时间
        finishDate: "完成时间",
        //状态
        state: "状态",

        //出库类型不能为空
        outTypeNotNull: "出库类型不能为空",
        //审核人不能为空
        confirmUserNotNull: "审核人不能为空",

        //样本编号
        sampleCode: "样本编号",
        //原始样本编号
        originalSampleCode: "原始样本编号",
        //产品名称
        productName: "产品名称",
        //产品类型
        productType: "产品类型",
        //样本类型
        sampleType: "样本类型",
        //样本位置
        samplePosition: "样本位置",
        //总量
        total: "总量",
        //出库数量
        outNum: "出库数量",
        //单位
        unit: "单位",
        //失效日期
        expiryDate: "失效日期",
        //下一步流向
        nextFlow: "下一步流向",
        //下一步流向名称
        nextFlowName: "下一步流向名称",

        //请选择数据
        chooseData: "请选择数据",
        //出库类型名称
        outTypeName: "出库类型名称",

        //用户名
        userName: "用户名",
        //密码
        password: "密码",
        //姓名
        name: "姓名",
        //原因
        reason: "原因",
        //确认
        confirm: "确认",

        //添加明细
        addDetails: "添加明细",
        //请填写出库数量后保存
        saveOutNum: "请填写出库数量后保存",
        //保存
        save: "保存",
        //样本编号：
        sampleCodeMsg: "样本编号：",
        //的出库数量不能为空
        outNumNotNull: "的出库数量不能为空",
        //的出库数量不能为0
        outNumNotZero: "的出库数量不能为0",
        //的出库数量不能大于库存数量
        outNumNotBig: "的出库数量不能大于库存数量",

        //选择下一步流向
        chooseNextFlow: "下一步流向",
        //请选择样本明细
        chooseSampleDetail: "请选择样本明细",
        //下一步流向为空！
        nextFlowIsNull: "下一步流向为空！",
        //保存成功
        saveSuccess: "保存成功！",
        //保存失败
        saveFail: "保存失败！",
        //申请明细为空！
        applyDetailIsNull: "申请明细为空！",
        //验证
        validate: "验证",
        //请选择类别
        chooseType: "请选择类别",
        //状态提交成功
        stateSuccess: "状态提交成功！",
        //状态提交失败
        stateFail: "状态提交失败！",

        //提交成功
        submitSuccess: "提交成功！",
        //提交失败
        submitFail: "提交失败！",

        saveFirst: "请先保存主表信息",
    },

    //样本出库
    SampleOut: {
        //样本出库
        sampleOut: "样本出库",
        //待出库样本
        waitOutSample: "待出库样本",
        //添加明细
        addDetails: "添加明细",
        //出库明细
        outDetails: "出库明细",

        //编号
        id: "编号",
        //描述
        description: "描述",
        //类型
        type: "类型",
        //选择类型
        chooseType: "选择类型",
        //出库申请单号
        applyId: "出库申请单号",
        //领用人
        receiver: "领用人",
        //创建人
        createUser: "创建人",
        //创建时间
        createDate: "创建时间",
        //审核人
        confirmUser: "审核人",
        //完成时间
        finishDate: "完成时间",
        //状态
        state: "状态",

        //样本编号
        sampleCode: "样本编号",
        //原始样本编号
        originalSampleCode: "原始样本编号",
        //产品名称
        productName: "产品名称",
        //样本位置
        samplePosition: "样本位置",
        //样本类型
        sampleType: "样本类型",
        //总量
        total: "总量",
        //出库数量
        outNum: "出库数量",
        //单位
        unit: "单位",
        //失效日期
        expiryDate: "失效日期",
        //下一步流向
        nextFlow: "下一步流向",
        //下一步流向名称
        nextFlowName: "下一步流向名称",
        //申请人
        applyUser: "申请人",
        //备注
        remark: "备注",
        //用户名
        userName: "用户名",
        //密码
        password: "密码",
        //姓名
        name: "姓名",
        //原因
        reason: "原因",
        //确认
        confirm: "确认",

        //请选择数据！
        chooseData: "请选择数据！",
        //出库申请单号不能为空！
        applyIdNotNull: "出库申请单号不能为空！",
        //领用人不能为空！
        receiverNotNull: "领用人不能为空！",
        //审核人不能为空！
        confirmUserNotNull: "审核人不能为空！",
        //保存成功
        saveSuccess: "保存成功！",
        //修改成功
        updateSuccess: "修改成功！",

        //验证
        validate: "验证",
        //状态提交成功
        stateSuccess: "状态提交成功！",
        //状态提交失败
        stateFail: "状态提交失败！",
        //请选择类别
        chooseTypeForValidate: "请选择类别",
        //请选择样本！
        chooseSample: "请选择样本！",
    },

    SampleStock: {
        //库存样本展示
        sampleStock: "库存样本展示",

        //有效状态
        validState: "有效状态",
        //失效日期
        expiryDate: "失效日期",
        //样本编号
        sampleCode: "样本编号",
        //原始样本编号
        originalSampleCode: "原始样本编号",
        //批号
        batchNumber: "批号",
        //代次
        generation: "代次",
        //样本类型
        sampleType: "样本类型",
        //总量
        total: "总量",
        //单位
        unit: "单位",
        //产品名称
        productName: "产品名称",
        //样本位置
        samplePosition: "样本位置",
        //备注
        remark: "备注",

        //有效
        valid: "有效",
        //失效
        invalid: "失效",
    },

    BioDialogPublic: {
        id: "id",
        name: "name",
        createDate: "create date",
        departmentName: "department name",
        primaryUnit: "primary unit name",
        subUnit: "sub unit name",
        ConversionCoefficient: "Conversion Coefficient",
        type: "type",
        dutyUserName: "duty user name",
        Username: "user name",
        dic: {
            dictionaryDescription: "Select the dictionary type"
        },
        user: {
            selecttheuser: "Select the user",
        },
        userGroup: {
            selecttheusergroup: "Select the user group",
        },
        unitGroup: {
            selecttheunitgroup: "Select the unit group",
        },
        sampleType: {
            selectthesampletype: "Select the sample type",
        },
        product: {
            selecttheproduct: "Select the product",
        },
        instrument: {
            selecttheinstrument: "Select the instrument",
        },
        storage: {
            selectthestorage: "Select the storage",
        },
        project: {
            selecttheproject: "Select the project",
        },
    },
    ProductMasterDataListRight: {
        effective: "effective",
        invalid: "invalid",
        effectiveBtn: "effective",
        invalidBtn: "void",
        code: "number",
        name: "name",
        inspectionCycle: "inspection cycle",
        earlyWarning: "Warning cycle",
        day: "day",
        identificationCode: "identifier",
        consumption: "dosage",
        combinationOptions: "whether to combine options",
        state: "status",
        briefName: "abbreviated",
        experimentalProcess: "experimental process",
        productionProcessConfiguration: "Production Process Configuration",
        finishedProduct: "finished product",
        orderContent: "Order Content",
        subproduct: "child product",
        createUser: "Created by",
        createDate: "Created",
        voidTime: "voidTime",
        hideFields: "hidden fields",
        productId: "Product ID",
        productName: "Product Name",
        price: "original price",
        discount: "discount",
        discountPrice: "discounted price",
        experimentalTemplate: "experimental template",
        templateName: "template name",
        yes: "YES",
        no: "NO",
    },
    sampleTypeListRight: {
        id: "sample code",
        name: "sample type name",
        state: "status",
        first: "type",
        picCode: "icon",
        sampleNum: "sample volume",
        unit: "sampling unit",
        dataVolume: "Data Volume",
        choose: "Please select a record!" ,
        batchUnit: "bulk unit",
        upload: "upload attachment",
        view: "View attachments",
        description: "description",
        code: "sample label",
        seqencing: "sort number",
        save: "save",
        back: "list",

        nail: "nails",
        bloodCell: "blood cell",
        sperm: "sperm spots",
        immunohistochemical: "immunohistochemical film",
        oralSwab: "oral swab",
        semen: "semen",
        dna:"DNA",
        heart: "heart",
        bloodPrecipitation: "blood precipitation",
        hePathological: "HE pathological section",
        urine: "urine",
        rna:"RNA",
        paraffin: "paraffin",
        formalinSoaked: "formalin-soaked tissue",
        boneMarrow: "bone marrow",
        saliva: "saliva",
        pleuralEffusion: "pleural",
        edtaAnticoagulant: "EDTA anticoagulant",
        ffpeWhite: "FFPE White",
        ffpeRoll: "FFPE Roll",
        externalPlasma: "external plasma",
        internalSeparation: "internal separation of plasma",
        separationLeukocyte: "isolation of white blood cells",
        ascites: "ascites",
        cerebrospinalFluid: "cerebral medullary fluid",
        blood: "blood",
        freshTissue: "Fresh Tissue",
        valid: "valid",
        Invalid: "invalid",
        name1: "name",
        saveInfo: "Save successfully",
        saveInfo1: "Save failed",
        updateInfo: "Update successful",


    },

    //公用按钮
    CommonButton:{
        //保存
        save: "保存",
        //列表
        list: "列表",
        //提交
        submit: "提交",
        //状态
        state: "状态",
        //是
        yes: "是",
        //否
        no: "否",
        //未知
        unknown: "未知",
        //上传附件
        upload: "上传附件",
        //查看附件
        view: "查看附件",
        //确认
        confirm: "确认",
        //导航
        items: "导航",
        //办理
        transact:"办理",
    },
    //公用字段
    CommonField:{
        //创建人
        createUser: "创建人",
        //创建时间
        createDate: "创建时间",
        //状态名称
        stateName: "状态",
        //审核人
        confirmUser: "审核人",
        //审核时间
        confirmDate: "审核时间",
        //编号
        id: "编号",
        //类型
        dicType: "类型",
        //名称
        name: "名称",
        //备注
        note: "备注",
        //姓名
        userName: "姓名",
        //有效
        effective: "有效",
        //无效
        invalid: "无效",
        //联系电话
        telephoneNumber: "联系电话",
        //文件
        file: "文件",
        //验证
        validate: "验证",
        //用户名
        loginName: "用户名",
        //密码
        password: "密码",
        //原因
        reason: "原因",
        //文件名称
        fileName: "文件名称",
        //关联模块
        relationModule: "关联模块",
        //上传时间
        uploadDate: "上传时间",
        //上传人
        uploadUser: "上传人",

    },
    //公用提示
    CommonTip:{
        //请选择数据！
        chooseData: "请选择数据！",
        //请选择
        choose: "请选择",
        //页面内容存在改动，是否需要保存后退出？
        saveExit: "页面内容存在改动，是否需要保存后退出？",
        //状态提交失败
        submitFail: "状态提交失败！",
        //状态提交成功
        submitSuccess: "状态提交成功！",
        //保存成功
        saveSuccess: "保存成功！",
        //保存失败
        saveFail: "保存失败！",
        //删除成功
        deleteSuccess: "删除成功",
        //删除失败
        deleteFail: "删除失败",
        //添加成功
        addSuccess: "添加成功",
        //添加失败
        addFail: "添加失败",
        //格式错误
        formatError: "格式错误",
        //请选择类别
        chooseType: "请选择类别",
        //请先选择数据！
        chooseDataFirst: "请先选择数据!",
        //上传成功！
        uploadSuccess: "上传成功！",
        //上传失败！
        uploadFail: "上传失败！",
        //已取消上传！
        uploadCancel: "已取消上传！",
        //生成成功
        generateSuccess: "生成成功！",
        //生成失败
        generateFail: "生成失败！",
        //请先保存
        saveFirst: "请先保存！",
        //是否确认删除？
        deleteConfirm: "是否确认删除？",
        //提交失败
        submitFails: "提交失败",
        //提交成功
        submitSuccesss: "提交成功",
        //请选择审核人
        chooseConfirmUser: "请选择审核人",
        //请选择类型为图片的文件
        chooseImage: "请选择类型为图片的文件",
        //操作成功
        operationSuccess: "操作成功",
        //操作失败
        operationFail: "操作失败",
        //验证失败
        validateFail: "验证失败",
        //验证成功
        validateSuccess: "验证成功",
        //名称不能为空
        nameNotNull: "名称不能为空",
        //状态不能为空
        stateNotNull: "状态不能为空",
    },
    //仪器调整
    instrumentAdjustment: {
        //仪器调整
        instrumentAdjustment: "仪器调整",
        //仪器编号
        instrumentId: "仪器编号",
        //仪器名称
        instrumentName: "仪器名称",
        //调整状态
        dicNewStateId: "调整状态",
        //调整原因
        note: "调整原因",

        //仪器
        instrument: "仪器",
        //型号
        model: "型号",
        //序列号
        serialNumber: "序列号",
        //生产商
        manufacturer: "生产商",
        //仪器调整信息
        instrumentAdjustmentInformation: "仪器调整信息",
        //可用
        available: "可用",
        //不可用
        unavailable: "不可用",
        //报废
        scrapped: "报废",
        //批量添加
        batchAdd: "批量添加",
        //当前需调整仪器状态与调整状态一致，请重新选择！
        selectDicNewStateIdAgain: "当前需调整仪器状态与调整状态一致，请重新选择！",

    },
    //快递公司
    expressCompanyPublic: {
        //快递公司
        expressCompany: "快递公司",
    },


    //项目管理模块
    projectManagement:{
        projectManagement:"项目管理",
        id: "项目编号",
        name: "项目名称",
        type: "类型",
        dutyUserName: "项目负责人",
        planStartDate: "开始时间",
        planEndDate: "预计交付时间",
        factEndDate: "实际交付时间",
        sumScale: "汇款总比例",
        note: "项目描述",
        projectProgress: "完成进度",
        state: "状态",
        createUserName: "创建人",
        createDate: "创建时间",
        start: "开始",
        noStart: "未开始",
        sellUserName: "项目销售",
        money: "项目金额",
        pleaseSelectedData: "请选择数据！",
        dicTypeName: "名称",
        dialogUsername: "用户名",
        dialogName: "姓名",
        confirmUserBtn: "确认选择",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        projectOrderTitle: "项目订单",
        projectOrderId: "编号",
        projectOrderName: "项目订单名称",
        productId: "产品编号",
        productName: "产品名称",
        sampleNum: "样本数量",
        contactUser: "联系人",
        completeNum: "完成数量",
        projectOrderChart: "项目订单数量柱状图",
        outstandingQuantity: "未完成数量",
        quantityCompleted: "已完成数量",
        projectOrderChartId: "项目订单编号",
        save: "保存",
        list: "列表",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //项目编号不能为空
        projectNumber: "项目编号不能为空",
        //项目编号只能输入大写字母和数字
        projectNumber1: "项目编号只能输入大写字母和数字",
        //项目名称不能为空
        projectName: "项目名称不能为空",
        //汇款总比例只能输入正数数字
        sumScales: "汇款总比例只能输入正数数字",
        //项目金额只能输入正数数字
        projectMoney: "项目金额只能输入正数数字",
        //预计交付时间需要大于开始时间
        planStartDates: "预计交付时间需要大于开始时间",
        //实际交付时间需要大于开始时间
        factEndDates: "实际交付时间需要大于开始时间",
        //请选择类型为图片的文件
        pleaseSelectImage: "请选择类型为图片的文件",

        outState: "发送状态",
    },
    //项目订单模块
    ProjectOrder: {
        projectOrder: "项目订单",
        id: "订单编号",
        name: "订单名称",
        projectId: "项目编号",
        projectName: "项目名称",
        createUserName: "创建人",
        createDate: "创建时间",
        total: "项目总价",
        stateName: "状态",
        start: "开始",
        noStart: "未开始",
        contactUser: "联系人",
        contactPhone: "联系电话",
        sampleNum: "应收数量",
        receiveNum: "已收数量",
        completeNum: "完成数量",
        pleaseSelectedData: "请选择数据！",
        dialogName:"姓名",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        save: "保存",
        list: "列表",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        ProjectOrderDetails: "项目订单明细表",
        sampleCode:"样本编号",
        productId: "产品编号",
        productName: "产品名称",
        sampleTypeName:"样本类型",
        receiveUserName:"接收人",
        receiveDate:"接收时间",
        sampleState:"样本状态",
        //订单编号不能为空
        sampleOrderIdisnull: "订单编号不能为空",
        //订单编号只能输入大写字母和数字
        sampleOrderIdisError: "订单编号只能输入大写字母和数字",
        //应收数量或完成数量不能为空
        sampleNumisnull: "应收数量不能为空",
        sampleNumisnull2: "完成数量不能为空",
        //应收数量和完成数量只能输入正数数字
        sampleNumisError: "应收数量只能输入正数数字",
        sampleNumisError22: "完成数量只能输入正数数字",
        //应收数量应大于等于完成数量
        sampleNumisError2: "应收数量应大于等于完成数量",
        //请输入有效的联系电话！
        contactPhoneisError: "请输入有效的联系电话！",
    },
    //项目绑定模块
    ClaimSample: {
        claimSample: "项目绑定",
        log1: ":用户:*1在编号为",
        log2: "的数据中上传了附件,附件名为:",
        id: "项目绑定编号",
        name: "描述",
        note: "备注",
        createUserName: "创建人",
        createDate: "创建时间",
        stateName: "状态",
        confirmUserName: "审核人",
        confirmDate: "审核时间",
        pleaseSelectedData: "请选择数据！",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        totalSamples: "在库总样本",
        addItems: "添加明细",
        unboundSamples: "未绑定样本",
        boundSample: "已绑定样本",
        code: "样本编号",
        sampleCode: "原始样本编号",
        barCode: "条形码",
        productId: "产品编号",
        productName: "产品名称",
        sampleType: "样本类型",
        projectId: "项目编号",
        projectName: "项目名称",
        projectOrderId: "项目订单编号",
        projectOrderName: "项目订单名称",
        pleaseSaveTask: "请先保存主表信息",
        addSuccess: "添加成功",
        addFail: "添加失败",
        boundSampleItem: "绑定样本明细",
        batchProject: "批量项目",
        batchProjectOrder: "批量订单",
        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        passwordError: "密码错误",
        selectData:"请选择数据后点击按钮操作",
        selectSameProject:"请勾选项目编号相同的数据后点击按钮操作",
        selectProjectBefor:"请先选择项目后进行操作",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirmBtn: "确定",
        //请选择类型为图片的文件
        pleaseSelectImage: "请选择类型为图片的文件",
    },
    //任务单模块
    Ticket: {
        ticket: "任务单",
        id: "编号",
        name: "描述",
        note: "备注",
        orderType: "任务单类型",
        createUserName: "创建人姓名",
        createDate: "创建时间",
        confirmUserName: "审核人",
        confirmDate: "审核时间",
        stateName: "状态",
        userGroup: "实验组",
        testUser: "实验员",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        sampleInfoIn: "在库总样本",
        code: "样本编号",
        sampleCode: "原始样本编号",
        barCode: "条形码",
        productId: "产品编号",
        productName: "产品名称",
        sampleType: "样本类型",
        projectId: "项目编号",
        projectName: "项目名称",
        addItems: "添加明细",
        pleaseSaveTask: "请先保存主表信息",
        addSuccess: "添加成功",
        addFail: "添加失败",
        ticketItem: "任务明细",
        nextFlowId: "下一步流向编号",
        nextFlowName: "下一步流向名称",
        selectItem: "请先选择任务明细数据",
        pleaseSelectedData: "请选择数据！",
        dicTypeName: "类型名称",
        userGroupName: "实验组",
        testUserName: "实验员",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirmBtn: "确定",
        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        passwordError: "密码错误",
        pleaseChooseTestGroup: "请先选择实验组",
        batchInput: "批量录入",
        //请选择类型为图片的文件
        pleaseSelectImage: "请选择类型为图片的文件",
    },

    //研发项目
    RdProjectEdit: {
        title: "研发项目",

        id: "项目编号",
        name: "项目名称",
        projectLeader: "项目负责人",
        projectGroupUser: "项目组成员",
        startDate: "开始日期",
        predictDeliveryDate: "预计交付日期",
        actualDeliveryDate: "实际交付日期",
        finishPercent: "完成进度",
        stateName: "状态",
        createUserName: "创建人",
        createDate: "创建时间",
        note: "备注",

        save: "保存",
        list: "列表",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        updateSuccess: "修改成功",
        updateFail: "修改失败",

        projectNameIsNull: "项目名称不能为空",
        projectLeaderIsNull: "项目负责人不能为空",
        projectGroupUserIsNull: "项目组成员不能为空",
        startDateIsNull: "开始日期不能为空",
        predictDeliveryDateIsNull: "预计交付日期不能为空",
        actualDeliveryDateIsNull: "实际交付日期不能为空",
        stateIsNull: "状态不能为空",
        projectIdIsError: "项目编号只允许字母或数字",
        rdProjectIdRepeat: "项目编号已存在，请重新输入",

        batchAdd: "批量添加",
        start: "开始",
        complete: "完成",
        pause: "暂停",
        cancel: "作废",

        processConfig: "流程配置",
        processConfigDetail: "流程配置明细",
        processNodeDetail: "流程节点明细",
        viewExperimentDetail: "查看实验明细",
        sampleList: "样本列表",
        process: "流程节点",
        experimentNo: "实验编号",
        experimentDetail: "实验明细",
        experimentPaperNo: "实验单编号",
        experimentPaperName: "实验单名称",
        experimentType: "实验类型",
        finish: "是否完成",

        externalSampleCode: "外部样本编号",
        sampleCode: "样本编号",
        username: "姓名",
        gender: "性别",
        gender0: "女",
        gender1: "男",
        gender2: "未知",
        sampleType: "样本类型",
        samplingDate: "采样时间",
        validityDate: "有效期（天）",
        expireDate: "到期时间",
        site: "采样部位",
        sampleNum: "采样量",
        unit: "单位",
        result: "结果",
        result1: "合格",
        result2: "不合格",
        nextFlowId: "下一步流向",
        plateNo: "板号",
        position: "位置",
        note1: "备注",
        serialNo: "序号",
    },

    //培训计划
    TrainingPlan: {
        trainingPlan: "培训计划",
        id: "培训计划编号",
        trainingName: "描述",
        trainingTypeName: "培训类型",
        trainingEffectiveness: "培训时效",
        trainingRemind: "提醒天数",
        trainingDuration: "培训时长(小时)",
        trainingModusName: "培训方式",
        trainingTeacher: "培训讲师",
        note: "备注",
        createUserName: "申请人",
        createDate: "创建时间",
        confirmUserName: "批准人",
        confirmDate: "批准时间",
        stateName: "状态",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        pleaseSelectedData: "请选择数据！",
        fileId: "资料编号",
        fileName: "资料名称",
        editQuestions: "编辑考题",
        questionType: "类型",
        questionContent: "题目内容",
        answerOptions: "答案选项",
        addOption: "添加选项",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirmBtn: "确定",
        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        passwordError: "密码错误",
        dicTypeName: "名称",
        dialogName: "姓名",
        participantUserId: "用户名",
        participantUserName: "姓名",
        trainingUserGroupBtn: "培训组",
        trainingUserBtn: "培训人",
        fileid: "资料编号",
        documentName: "资料明细",
        fileNames: "资料名称",
        batchInput: "批量录入",
        knowledgeBtn: "知识中心",
        documentBtn: "文档主数据",
        viewFileBtn: "查看资料",
        questionCode: "考题编号",
        options: "选项",
        standardAnswer: "标准答案",
        bindingFile: "资料绑定",
        userGroupName: "名称",
        userGroupNote: "备注",
        trainingItem: "被培训人",
        trainingDataItem: "培训资料",
        trainingQuestionsItem: "考题",
        fileItem: "资料明细",
        singleChoice: "单选题",
        multipleChoice: "多选题",
        judgment: "判断题",
        right: "对",
        wrong: "错",
        qualified: "合格",
        disqualification: "不合格",
        na: "N/A",
        //提醒天数不能为空
        trainingRemindNotNull: "提醒天数不能为空",
        //培训时长不能为空
        trainingDurationNotNull: "培训时长不能为空",
        //提醒天数需要填写正整数
        trainingRemindTips: "提醒天数需要填写正整数",
        //培训时长需要填写正整数
        trainingDurationTips: "培训时长需要填写正数",

        confirmUserNameNotNull: "批准人不能为空",
        complete: "完成",
        new: "新建",
        assessing: "审核中",
        trainingEffectivenessNotNull: "培训时效需要填写正数",
        changeSuccess: "状态修改成功",
        changeFail: "状态修改失败",
        //请先保存
        saveFirst: "请先保存！",
        //账号错误
        accountError: "账号错误",
        //验证失败
        validateFail: "验证失败",
        fileExist: "资料已录入",
    },
    //培训记录
    TrainingRecord: {
        trainingRecord: "培训记录",
        log1: "培训记录:用户:*1在编号为",
        log2: "的数据中上传了附件,附件名为:",
        id: "培训记录编号",
        trainingPlanId: "培训计划编号",
        trainingPlanName: "培训计划名称",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        confirmUserNameNotNull: "批准人不能为空",
        trainingPlanNotNull: "培训计划编号不能为空",
        trainingDurationNotNull: "培训记录培训时长不能为空",
        trainingDurationTips: "培训记录培训时长需要填写正数",
        trainingName: "描述",
        trainingModus: "培训方式",
        trainingEffectiveness: "培训时效",
        trainingRemind: "提醒天数",
        trainingDuration: "培训时长(小时)",
        //培训记录时长(小时)
        trainingRecordDuration: "培训记录培训时长(小时)",
        trainingTeacher: "培训讲师",
        createUserName: "申请人",
        createDate: "创建时间",
        confirmUserName: "批准人",
        confirmDate: "批准时间",
        stateName: "状态",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        pleaseSelectedData: "请选择数据！",
        name: "姓名",
        participantUserId: "用户名",
        participantUserName: "姓名",
        fileid: "资料编号",
        assessResult: "考核结果",
        qualified: "合格",
        disqualification: "不合格",
        na: "N/A",
        trainingRecordQuestionsItem: "考题",
        startTest: "开始考试",
        viewQuestions: "查看题目",
        questionCode: "考题编号",
        fileId: "考题归属资料",
        questionType: "类型",
        questionContent: "题目内容",
        options: "选项",
        standardAnswer: "标准答案",
        batchInput: "批量录入",
        assessmentAnswer: "考核答案",
        achievement: "成绩",
        trainingRecordAnswerItem: "考核",
        submitAnswer: "提交答案",
        writeAnswer: "答题",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirmBtn: "确定",
        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        passwordError: "密码错误",
        singleChoice: "单选题",
        multipleChoice: "多选题",
        judgment: "判断题",
        right: "对",
        wrong: "错",
        startTestSuccess: "开始考试成功",
        startTestFail: "开始考试失败",
        pass: "通过",
        fail: "不合格,请再次答题后重新提交答案",
        firstQuestion: "已经是当前页第一题",
        lastQuestion: "已经是当前页最后一题",
        viewItemFile: "查看资料",
        trainingRecordItem: "培训明细",
        complete: "完成",
        new: "新建",
        assessing: "考核中",
        // 选择培训计划编号失败
        selectTrainingPlanIdFail: "选择培训计划编号失败",
        changeSuccess: "状态修改成功",
        changeFail: "状态修改失败",
        //请先保存
        saveFirst: "请先保存！",
        //账号错误
        accountError: "账号错误",
        //验证失败
        validateFail: "验证失败",
        //该培训计划已经完成培训不能再次进行培训
        trainingPlanComplete: "该培训计划已经完成培训不能再次进行培训",
        noUser: "该培训记录没有您的培训信息",
        assessed: "考核完成",
    },

    //知识中心
    KnowledgeCenter: {
        knowledgeCenter: "知识中心",
        log1: "知识中心:用户:*1在编号为",
        log2: "的资料中上传了附件,附件名为:",
        save: "保存",
        operationBtns: "操作",
        viewfile: "查看附件",
        delete: "删除",
        pleaseSelectedData: "请选择数据！",
        confirmBtn: "确认选择",
        bingFile: "绑定资料",
        fileId: "资料编号",
        fileName: "资料名称",
        fileItem: "资料明细",
        note: "备注",
        createUserName: "创建人",
        createDate: "创建时间",
        state: "状态",
        valid: "有效",
        invalid: "无效",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        pleaseSelectOneData: "请选择一条数据",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        pleaseSave: "请先保存",
    },

    //电子病历
    CaseHistoryEdit: {
        //电子病历
        CaseHistory: "电子病历",
        //电子病历编号
        id: "电子病历编号",
        //姓名
        name: "姓名",
        //性别
        gender: "性别",
        //申请人
        createUsers: "申请人",
        //出生日期
        dateOfBirth: "出生日期",
        //年龄
        age: "年龄",
        //婚姻
        maritalStatus: "婚姻",
        //微信号
        weChat: "微信号",
        //患者信息
        PatientInformation: "患者信息",
        race: "民族",
        idCard: "身份证",
        Native: "籍贯",
        maritalStatuss: "婚姻状况",
        address: "街道地址",
        career: "职业",
        email: "邮箱",
        hospitals: "医院信息",
        customer: "医院",
        department: "科室/部门",
        doctor: "医生",
        history: "相关病史",
        infectiousDiseases: "传染病史",
        yes: "是",
        no: "否",
        unknown: "未知",
        enter1: "请输入传染病史",
        historyOfSmoking: "吸烟史",
        enter2: "请输入吸烟史",
        environment: "环境风险",
        enter3: "请输入环境风险",
        drink: "饮酒史",
        drinktext: "请输入饮酒史",
        otherDiseases: "其他疾病",
        otherDiseasestext: "请输入其他疾病",
        text: "沟通信息",
        delete1: "删除明细",
        Id: "Id",
        CMethods: "沟通方式",
        CTheme: "沟通主题",
        CContent: "沟通内容",
        CTime: "沟通时间",
        Payment: "收款金额",
        Subsequent: "后续安排",
        Our: "我方参加人",
        Customer: "客户方参加人",
        note: "备注",
        createUser: "创建人",
        createDate: "创建时间",

        man: "男",
        woman: "女",

        Order: "订单信息",
        information: "临床样本信息",
        HPO: "HPO",

        Charge: "确认收费",
        Payment1: "是否收费",

        Payment2: "未付款",
        Payment3: "已付款",
        Payment4: "收款金额",
        PaymentTime: "收款时间",
        PaymentMethod: "收款方式",
        MonthlySettlement: "月结",
        FeeDescription: "收费说明",
        ReceiptNumber: "收据号",
        POSNumber: "POS号",
        RefundTime: "退款时间",
        InvoiceNumber: "发票号",
        InvoiceHeader: "发票抬头",
        InvoicingTime: "开票时间",
        AlipayAccount: "支付宝号",
        ReceivedAmount: "到账金额",
        state: "状态",
        success: "支付成功",
        error: "支付失败",
        financialStaff: "财务人员",
        TestingItems: "产品名称",
        salesman: "业务员",

        zipCode: "邮编",
        Sales: "销售代表",
        Number1: "电子病历编号",
        FamilyNumber: "家族编号",
        Family: "家族联系人",
        FamilyPhone: "家属联系人电话",
        FamilyAddress: "家属联系人地址",
        medicalInstitution: "医疗机构",

        SampleNumber: "样本编号",
        SampleType: "样本类型",
        Name1: "姓名/名称",
        entryName: "项目名称",
        StatusName: "状态名称",
        orderNumber: "订单号",
        MedicalNumber: "病历号(Research)",

        name2: "名称",
        person2: "负责人",
        payment3: "付款",
        cancel: "取消",
        Paid: "已付款未提交",
        Monthly: "月付",
        Delayed: "延迟收费",
        contact: "联系方式",

        SDeleted: "删除成功",
        SSaved1: "保存成功",
        SaveFailedInfo: "保存失败",
        SSaved2: "保存HPO成功",
        Tips: "提示",
        Please: "请先保存",
        Please1: "请选择调理状态",
        Please2: "存在数据重复添加",
        Please3: "请先选择一条数据",

        //请输入正确的身份证号!
        enterIdCard: "请输入正确的身份证号!",
        //格式错误!
        formatError: "格式错误!",
        //只能输入整数数字!
        enterInteger: "只能输入整数数字!",
        //邮箱格式不正确，请重新输入!
        enterEmail: "邮箱格式不正确，请重新输入!",
        //联系电话1
        telephoneNumber1: "联系电话1",
        //联系电话2
        telephoneNumber2: "联系电话2",
        //请填写小于或等于当前日期的出生日期
        telephoneNumber3: "请填写小于或等于当前日期的出生日期",
    },

    //报告生成
    Report: {
        //报告生成
        report: "报告生成",
        //报告生成
        report2: "报告生成-明细",
        //描述
        name: "描述",
        //报告时间
        reportDate: "报告时间",
        //报告模板
        reportTemplate: "报告模板",
        //报告人
        reportUser: "报告人",
        //订单不存在无法完成！
        orderNotExist: "订单不存在无法完成！",
        //明细
        reportItem: "明细",
        //样本编号
        sampleCode: "样本编号",
        //生成报告
        generateReport: "生成报告",
        //订单号
        projectOrderId: "订单号",
        //预览报告
        previewReport: "预览报告",
        //检测项目
        productName: "产品名称",
        //下载报告
        downloadReport: "下载报告",
        //上传报告
        uploadReport: "上传报告",
        //请先选择报告模板！
        selectReportTemplate: "请先选择报告模板！",
        //继续上传会覆盖当前报告，请确认！
        confirmUpload: "继续上传会覆盖当前报告，请确认！",
        //请先填写报告时间后在保存
        reportDateNotNull: "请先填写报告时间后保存！",
    },
    //报告发送
    ReportSend: {
        //报告发送
        reportSend: "报告发送",
        //病历号
        medicalRecordCode: "病历号",
        //报告筛选
        reportFilter: "报告筛选",
        //待发送
        waitSend: "待发送",
        //订单号
        projectOrderId: "订单编号",
        //已发送
        hasSend: "已发送",
        //已撤销
        hasRecall: "已撤销",
        noRecall: "待发送报告无法撤回",
        hasRecall2: "已撤回报告无法再次撤回",
        pleaseInputCorrectEmail: "请输入正确的邮箱",
        //全部
        all: "全部",
        //名称
        name: "名称",
        //条形码
        barcode: "条形码",
        sendState: "发送方式",
        sendUser: "发送人",
        sendDate: "发送时间",
        //检测项目
        productName: "产品名称",
        //查看报告
        viewReport: "查看报告",
        //该数据还没有生成报告文件，无法进行预览！
        noReport: "该数据还没有生成报告文件，无法进行预览！",
        //发送方式
        sendType: "发送类型",
        //线上发送
        onlineSend: "线上发送",
        //批量发送
        batchSend: "发送至邮箱",
        //推送至小程序
        pushSend: "推送至小程序",
        //撤销
        recall: "撤销",
        //修改邮箱
        editEmail: "修改邮箱",
        //订单编号
        projectOrderIds: "订单编号",
        //线下发送
        offlineSend: "线下发送",
        //未选择发送方式，请选择后再次进行发送！
        noSendType: "未选择发送类型，请选择后再次进行发送！",
        //是否发送
        isSend: "是否发送",
        //未填写邮箱，无法进行线上发送！
        noEmail: "未填写邮箱，无法进行线上发送！",
        //邮箱
        email: "邮箱",
        //已发送报告无法再次进行发送！
        hasSendReport: "已发送报告无法再次进行发送！",
        //报告完成时间
        reportCompleteDate: "报告完成时间",
        //发送成功！
        sendSuccess: "发送成功！",
        //发送报告时间
        reportSendDate: "发送报告时间",
        //发送失败！
        sendFail: "发送失败！",
        //快递公司
        expressCompany: "快递公司",
        //发送
        send: "发送",
        //快递单号
        expressCompanyId: "快递单号",
        //备注
        note: "备注",
        //撤回原因
        recallReason: "撤回原因",
        refundUser: "撤回人",
        refundDate: "撤回时间",
        //处理人
        dealUser: "处理人",
        //处理时间
        dealDate: "处理时间",
        viewAttachments: "查看附件",
        //在线查看
        onlineView: "在线查看",
        //请选择一条数据
        pleaseSelectOneData: "请选择一条数据",
        pleaseInputRecallReason: "请输入撤回原因",
        sampleCode:"样本编号"
    },
    COITraceability: {
        title: "Coi追溯列表",
        orderNumber: "订单编号",
        batch:"批指令编号",
        operatingRoom:"操作房间",
        operator:"操作人",
        estimatedTime:"预计用时",
        startTime:"开始时间",
        endTime:"结束时间",
        wendutiaojian:"运输温度条件",
        quyangren:"取样人",
        shoujihao:"手机号码",
        quyangdizhi:"取样地址",
        phone:"物流联系方式",
        logisticsCompanies:"物流公司",
        logisticsPerson:"快递员",
        logisticsOrderId:"快递单号",
        transportCondition:"运输方式",
        wendujiguanbi:"温度计关闭时间",
        jieshouren:"接收人",
        jieshoushjiian:"接收时间",
        codeScanningRecord:"扫码记录",
        value:"值：",
        codeScanningTime:"扫码时间：",
        returnReason: "退回原因",
        codeScanningframe: "扫码框",
        ID: "编号：",
        orderForGoods: "订单",
        processExecution: "流程执行",
        document: "文件",
        close: "关闭",
        selectMaterials: "选择物料",
        executionTable: "当前流程执行表",
        Strombestellung: "当前订单",
        list: "列表",
        returnSuccessful: "退回成功",
        sendBack: "退回",
        reasonForReturn: "请输入退回原因",
        applicationNumber: "申请单编号",
        productName: "产品名称",
        estimatedAcquisitionTime: "预计采集时间",
        samplingFrequency: "取样次数",
        founder: "创建人",
        creationTime: "创建时间",
        state: "状态",
        sampleState: "样本状态",
        frozenBoxLabel: "冻存盒标签",
        bagLabel: "产品袋标签",
        //提示
        tips: "提示",
        //请完成所有步骤
        completeAllSteps: "请完成所有步骤",
        //完成
        complete: "完成",
        //'确认成功'
        confirmSuccess: "确认成功",
        //'作废成功'
        invalidSuccess: "作废成功",
        //入库成功！
        storageSuccess: "入库成功！",
        //入库失败！
        storageFail: "入库失败！",
        //请填写批次
        pleaseBatch: "请填写批次",
        //出库成功!
        outSuccess: "出库成功!",
        //出库失败!
        outFail: "出库失败!",
        //没有批次，无法出库！
        noBatch: "没有批次，无法出库！",
        // "已完成"
        completed: "已完成",
        //"服务器繁忙，请稍后尝试"
        serverBusy: "服务器繁忙，请稍后尝试",
        //"网络连接失败，请重试"
        networkFail: "网络连接失败，请重试",
        //'请先保存',
        pleaseSave: "请先保存",
        //扫码成功
        scanSuccess: "扫码成功",
        //该批次已扫码
        batchScaned: "该批次已扫码",
        //扫码失败
        scanFail: "扫码失败",
        //请选择类别
        pleaseSelectCategory: "请选择类别",
        //确认
        confirm: "确认",
        //验证
        validate: "验证",
        //用户名
        userName: "用户名",
        //密码
        password: "密码",
        //原因
        reason: "原因",
        //查看附件
        viewAttachment: "查看附件",
        //文件名称
        fileName: "文件名称",
        //请输入用户名与密码
        pleaseEnterUserNameAndPassword: "请输入用户名与密码",
        //用户名或密码错误
        userNameOrPasswordError: "用户名或密码错误",
        //'新建'
        create: "新建",
        //''已退回''
        returned: "已退回",
        //审核中
        auditing: "审核中",
        //已作废
        invalid: "已作废",
        //'作废'
        repeal: "作废",
        //已发运
        shipped: "已发运",
        //已运输
        transported: "已运输",
        //录入完成
        inputCompleted: "录入完成",
        //成品已接收
        finishedProductReceived: "成品已接收",
        //成品收获
        finishedProductHarvest: "成品收获",
        //样本已接收
        sampleReceived: "样本已接收",
    },
    ProcessExecuyion: {
        //产物编码
        productCode: "产物编码",
        //数量
        quantity: "数量",
        //位置
        position: "位置",
        //请输入
        pleaseEnter: "请输入",
        //已生成入库单
        hasGenerated: "已生成入库单",
        //请选择
        pleaseSelect: "请选择",
        //查看附件
        viewAttachment: "查看附件",
        //选择物料
        selectMaterials: "选择物料",
        //出库数量
        outQuantity: "出库数量",
        //出库单位
        outUnit: "出库单位",
        //'状态'
        state: "状态",
        //"该批次物料不存在"
        batchNotExist: "该批次物料不存在",
        //物料类型错误
        materialTypeError: "物料类型错误",
        //扫码成功
        scanSuccess: "扫码成功",
        //该设备不存在
        deviceNotExist: "该设备不存在",
        //设备类型错误
        deviceTypeError: "设备类型错误",
        //用户名或密码错误
        userNameOrPasswordError: "用户名或密码错误",
        //批次号重复
        batchRepeat: "批次号重复",
        //已生成出库单
        hasGeneratedOut: "已生成出库单",
        //出库失败
        outFail: "出库失败",
        //样本接受
        sampleReceive: "样本接受",
        //成品收货
        finishedProductReceive: "成品收货",
        //成品收获
        finishedProductHarvest: "成品收获",
        //成品未入库
        finishedProductNotStorage: "成品未入库",
        //成品未出库
        finishedProductNotOut: "成品未出库",
        //删除成功
        deleteSuccess: "删除成功",
        //删除失败
        deleteFail: "删除失败",
    },
    intermediateProduct: {
        //中间产物
        intermediateProduct: "中间产物",
        //追溯码
        traceCode: "追溯码",
        //产物编码：
        productCode: "产物编码：",
        //数量：
        quantity: "数量：",
        //位置：
        position: "位置：",
        //请输入
        pleaseEnter: "请输入",
    },
    dataTable: {
        //请输入查询信息
        pleaseEnterSearchInfo: "请输入查询信息",

    },
    matetialinEdit: {
        //用户名或密码错误
        userNameOrPasswordError: "用户名或密码错误",
    },
    ExperimentTypeConfig: {
        databaseTableSuffix: "数据库表后缀",
        platform: "平台",
    },
    //检测中心异常
    experimentCenterAbnormal: {
        experimentCenterAbnormal : "检测中心异常",
    },
    SupplierAgreement:{
        supplierAgreement: "供应商协议",
        //产品信息
        productInfo: "产品信息",

        id: "供应商编号",
        name : "供应商名称",
        address : "地址",
        linkMan : "联系人",
        phone : "联系电话",
        email : "邮箱",
        bank : "开户行",
        account : "帐号",
        bankAddr : "开户行地址",
        validityStartDate : "协议有效期起",
        validityEndDate : "协议有效期止",
        supplierState : "状态",
        confirmUserName : "审核人",
        reviewerName: "复核人",
        confirmDate : "完成时间",
        stateName: "审核状态",
        state: "审核状态编码",
        createUserName : "创建人",
        createDate : "创建时间",

        valid: "有效",
        invalid: "无效",

        productId: "产品编号",
        productName: "产品名称",
        price: "合同单价（元）",
        note: "备注",

        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //产品信息保存失败
        productSaveFail: "产品信息保存失败",
        selectProduct: "选择产品",
        pleaseSelectedData: "请选择数据！",
        pleaseSelectOneData: "请选择一条数据",
        priceMustBeNumber: "合同单价必须为正数",
        saveFirst: "请先保存！",
        success: "上传成功",

        fileName: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",


        nameCanNotBeEmpty: "供应商名称不能为空",
        validityStartDateCanNotBeEmpty: "协议有效期起不能为空",
        validityEndDateCanNotBeEmpty: "协议有效期止不能为空",
        validityStartDateCanNotBeLaterThanValidityEndDate: "协议有效期起不能晚于协议有效期止",
        supplierStateCanNotBeEmpty: "状态不能为空",
        confirmUserCanNotBeEmpty: "审核人不能为空",
        reviewerCanNotBeEmpty: "复核人不能为空",
        productIdCanNotBeEmpty: "产品编号不能为空",
        productNameCanNotBeEmpty: "产品名称不能为空",
        priceCanNotBeEmpty: "合同单价不能为空",

        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        handle: "办理",

        //状态完成
        stateComplete: "状态完成",

        file: "查看附件",
        upload: "上传附件",
        view: "查看附件",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确定",
        type: "请选择类别",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        phoneFormatError: "请输入有效的联系电话！",
        emailFormatError: "请输入有效的邮箱！",
    },
    AgreementManager:{
        agreementManager: "协议管理",
        productInfo: "产品信息",

        id: "编号",
        name: "代理商名称",
        principal: "法人",
        phone: "公司电话",
        address: "公司地址",
        bank: "开户银行",
        bankAccount: "银行账户",
        bankAccountNo: "银行账号",
        linkMan: "联系人",
        linkManPhone: "联系人电话",
        validityStartDate: "签约有效期起",
        validityEndDate: "签约有效期止",
        hospitalName: "送检医院",
        createUserName: "创建人",
        createDate: "创建日期",
        agreementState: "状态",
        confirmUserName: "审核人",
        reviewerName: "复核人",
        confirmDate: "完成时间",
        stateName: "审核状态",
        paymentTerms: "付款条件",
        note: "备注",

        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        handle: "办理",
        valid: "有效",
        invalid: "无效",

        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //产品信息保存失败
        productSaveFail: "产品信息保存失败",
        selectProduct: "选择产品",
        pleaseSelectedData: "请选择数据！",
        pleaseSelectOneData: "请选择一条数据",
        priceMustBeNumber: "合同单价必须为正数",
        saveFirst: "请先保存！",
        success: "上传成功",

        fileName: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",
        productId: "产品编号",
        productName: "产品名称",
        price: "合同单价（元）",

        nameCanNotBeEmpty: "代理商名称不能为空",
        validityStartDateCanNotBeEmpty: "协议有效期起不能为空",
        validityEndDateCanNotBeEmpty: "协议有效期止不能为空",
        validityStartDateCanNotBeLaterThanValidityEndDate: "协议有效期起不能晚于协议有效期止",
        supplierStateCanNotBeEmpty: "状态不能为空",
        confirmUserCanNotBeEmpty: "审核人不能为空",
        reviewerCanNotBeEmpty: "复核人不能为空",
        productIdCanNotBeEmpty: "产品编号不能为空",
        productNameCanNotBeEmpty: "产品名称不能为空",
        priceCanNotBeEmpty: "合同单价不能为空",
        stateComplete: "状态完成",

        file: "查看附件",
        upload: "上传附件",
        view: "查看附件",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确定",
        type: "请选择类别",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        phoneFormatError: "请输入有效的公司电话！",
        //请输入有效的联系人电话
        linkManPhoneFormatError: "请输入有效的联系人电话！",
        //医院编号
        hospitalId: "医院编号",
        //添加医院
        addHospital: "添加医院",
        nameNotBeEmpty: "医院名称不能为空",

        hospitalname: "名称",
        street: "地址",
        postcode: "邮编",
        email: "邮箱",
        researchField: "研究领域",
        hospitalPhone: "电话",
        postCodeError: "请输入正确的邮编",
        emailError: "请输入正确的邮箱",
        phoneError: "请输入正确的电话",

    },
//供应商结算
    SupplierSettlement:{
        supplierSettlement: "供应商结算",
        //待结算明细
        waitSettlement: "待结算明细",
        //结算单列表
        settlementList: "结算单列表",
        //结算单明细
        settlementDetail: "结算单明细",
        //条形码
        barcode: "条形码",
        //订单编号
        orderNumber: "订单编号",
        hospital:"送检医院",
        //送检日期
        sendDate: "送检日期",
        //产品名称
        productName: "产品名称",
        //供应商编号
        supplierId: "供应商编号",
        //供应商名称
        supplierName: "供应商名称",
        //结算金额
        amount: "结算金额",
        //报告日期
        reportDate: "报告日期",
        //创建人
        createUserName: "创建人",
        //创建人用户名
        createUserId: "创建人用户名",
        //创建时间
        createDate: "创建时间",

        //结算单号
        settlementNumber: "结算单号",
        //例数
        exampleNumber: "例数",
        //结算金额
        settlementAmount: "结算金额",
        //结算日期
        settlementDate: "结算日期",
        //是否付款
        isPay: "是否付款",
        //付款确认人
        payConfirmUser: "付款确认人",
        //确认日期
        confirmDate: "确认日期",
        //备注
        note:"备注",

        //生成结算单
        generateSettlement: "生成结算单",

        //请至少选择一条数据
        pleaseSelectOneData: "请至少选择一条数据",
        //是否生成新的结算单
        isGenerateNewSettlement: "是否生成新的结算单",
        pleaseSelectSameSupplier: "请选择相同的供应商",
        save: "保存",
        yes: "是",
        no: "否",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //添加订单
        addOrder: "添加订单",
        //付款确认
        payConfirm: "付款确认",
        //结算单号为：
        settlementNumberIs: "结算单号为：",
        isPaySuccess: "的结算单已付款，请选择其他结算单",
        payConfirmSuccess: "付款确认成功",
        payConfirmFail: "付款确认失败",
        //已付款的结算单无法修改
        payedSettlementCanNotEdit: "已付款的结算单无法修改",
        leadDateIsNull: "的结算日期不能为空",
        generateSuccess: "生成结算单成功",
        generateFail: "生成结算单失败",
        //请选择一条结算单
        pleaseSelectOneSettlement: "请选择一条结算单",
        //请选择一条待结算明细
        pleaseSelectOneWaitSettlement: "请选择一条待结算明细",
        //已付款的结算单无法添加订单
        payedSettlementCanNotAddOrder: "已付款的结算单无法添加订单",
        addOrderSuccess: "添加订单成功",
        addOrderFail: "添加订单失败",


    },
    Invoicing:{
        invoicing: "开票管理",
        //开票明细
        invoicingDetail: "开票明细",

        id:"单据编号",
        //描述
        name: "描述",
        //开票状态
        state: "开票状态",
        //开票成功
        invoicingSuccess: "开票成功",
        //未开票
        notInvoiced: "未开票",
        //发票类型
        channelInvoiceType: "发票类型",
        //开票人
        drawer: "开票人",
        //复核人
        reviewer: "复核人",
        //收款人
        payee: "收款人",
        //联系方式
        phone: "联系方式",
        //发票抬头
        invoiceTitle: "发票抬头",
        //纳税人识别号
        registrationNum: "纳税人识别号",
        //总金额
        amount: "总金额",
        //发票内容
        invoiceContent: "发票内容",
        //地址
        addr: "地址",
        //开户行及账号
        depositBankNum: "开户行及账号",
        //开票备注
        note: "开票备注",
        //发送邮箱
        email: "发送邮箱",
        //发票流水号
        serialNum: "发票流水号",
        //创建时间
        createDate: "创建时间",
        upload: "上传附件",
        view: "查看附件",
        save: "保存",
        list: "列表",
        //全电专票
        fullElectricInvoice2: "全电专票",
        //全电普票
        fullElectricInvoice1: "全电普票",

        //订单编号
        orderNumber: "订单编号",
        //姓名
        orderName: "姓名",
        //区域
        area: "区域",
        //城市
        city: "城市",
        //销售
        sales: "销售",
        //客户姓名
        customerName: "客户姓名",
        //检测项目
        productName: "检测项目",
        //总收款金额
        totalAmount: "总收款金额",
        //选择订单
        selectOrder: "选择订单",
        //技术服务费
        technicalServiceFee: "技术服务费",
        //发票类型不能为空
        invoiceTypeCanNotBeEmpty: "发票类型不能为空",
        //开票人不能为空
        drawerCanNotBeEmpty: "开票人不能为空",
        //复核人不能为空
        reviewerCanNotBeEmpty: "复核人不能为空",
        //收款人不能为空
        payeeCanNotBeEmpty: "收款人不能为空",
        //发票抬头不能为空
        invoiceTitleCanNotBeEmpty: "发票抬头不能为空",
        //纳税人识别号不能为空
        registrationNumCanNotBeEmpty: "纳税人识别号不能为空",
        //总金额不能为空
        amountCanNotBeEmpty: "总金额不能为空",
        //发票内容不能为空
        invoiceContentCanNotBeEmpty: "发票内容不能为空",
        //地址不能为空
        addrCanNotBeEmpty: "地址不能为空",
        //保存成功
        saveSuccess: "保存成功",
        //保存失败
        saveFail: "保存失败",
        //开票明细保存失败
        invoicingDetailSaveFail: "开票明细保存失败",
        pleaseSelectedData: "请选择一条数据！",
        //添加成功
        addSuccess: "添加成功",
        //添加失败
        addFail: "添加失败",
        //查看订单
        viewOrder: "查看订单",
        pleaseSaveInvoicing: "请先保存",
        // 开票
        invoice: "开票",
        //定制功能，暂未开放
        customFunction: "定制功能，暂未开放",
        saveFirst: "请先保存！",
        success: "上传成功",
        fileName: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",
        file: "查看附件",

    },
    // 运输管理
    TransportManager:{

        // 运输计划
        transportPlan: "Transportation plan",
        // 编号
        transportPlanId: "id",
        // 运输公司
        transportCompany: "Transportation company",
        // 运输方式
        transportType: "Transportation type",
        // 创建人
        createUserName: "Creator",
        // 创建时间
        createDate: "Creation time",
        // 运输类型
        transportOrderType: "Transportation type",
        // 运输日期
        transportDate: "Transportation date",
        // 状态
        state: "State",
        // 描述
        note: "Description",
        // 物流人员
        logisticsPerson: "Logistics personnel",
        // 是否作废
        isInvalid: "Is it invalid",
        // 上传附件
        upload: "Upload attachment",
        // 查看附件
        view: "View attachment",
        // 上传文件成功
        uploadsuccess: "Upload file success",
        // 文件名称
        fileName: "File name",
        // 上传时间
        uploadTime: "Upload time",
        // 上传用户
        uploadUser: "Upload user",
        // 查看附件
        viewAttachment: "View attachment",
        // 编号不能为空，请先保存！
        transportPlanIdCanNotBeEmpty: "The number cannot be empty, please save first!",
        // 请选择数据
        pleaseSelectData: "Please select data",
        // 名称
        name: "Name",
        // 来源样本运输
        sampleTransport: "Source sample transportation",
        // 订单编号
        orderNumber: "Order number",
        //医院
        hospital: "Hospital",
        // 科室
        department: "Department",
        //送达楼层
        floor: "Floor",
        //预计到达时间
        estimatedArrivalTime: "Estimated arrival time",
        //温度要求（℃）
        temperatureRequirement: "Temperature requirement (℃)",
        //联系人
        linkMan: "Contact",
        //联系电话
        linkmanPhone: "Contact phone",
        // 是否通知
        isNotice: "Is it notified",
        // 是否确认
        isConfirm: "Is it confirmed",
        //筛选号
        filterNumber: "Filter number",
        // 产品批号
        productBatchNumber: "Product batch number",
        //采血物品
        bloodCollectionItems: "Blood collection items",
        //输血器
        transfusionDevice: "Transfusion device",
        // 轮次
        round: "Round",
        //氯化钠注射液
        sodiumChlorideInjection: "Sodium chloride injection",
        // 运输单号
        transportNumber: "Transportation number",
        //取血人
        bloodCollectionPerson: "Blood collection person",
        //预计采血时间
        estimatedBloodCollectionTime: "Estimated blood collection time",
        //运输费
        transportFee: "Transportation fee",
        //跟车人员
        followPerson: "Follow personnel",
        //待运输样本
        waitTransportSample: "Waiting for transportation sample",
        //运输明细
        transportDetail: "Transportation details",
        //产品
        product: "Product",
        productId:"product Id",
        //名字
        productName: "product Name",
        //医生
        doctor: "Doctor",
        //医生电话
        doctorPhone: "Doctor phone",
        //细胞编号
        cellNumber: "Cell number",
        //预计回输日期
        estimatedReturnDate: "Estimated return date",
        //最低温度
        minimumTemperature: "Minimum temperature",
        //最高温度
        maximumTemperature: "Maximum temperature",
        //平均温度
        averageTemperature: "Average temperature",
        //温度要求
        temperatureRequirements: "Temperature requirements",
        //保温箱编号
        incubatorNumber: "Incubator number",
        //温度计型号
        thermometerModel: "Thermometer model",
        ///袋数
        bagNumber: "Bag number",
        //实际签收人
        actualSignatory: "Actual signatory",
        //选择订单
        selectOrder: "Select order",
        //请填写必填字段
        pleaseEnterRequiredFields: "Please fill in the required fields",
        //保存成功
        saveSuccess: "Save success",
        // 明细表存在数据，无法进行操作
        itemInData:"The schedule has data and cannot be manipulated",
        // 规格
        specification:"specification",
        //批号
        Batch:"Batch",
        //生产日期
        Datemanufacture:"Date of manufacture",
        ShippingDate:"Shipping Date",
        Inventorylevels:"Inventory levels",
        //单位
        unit:"unit",
        //添加明细
        addDetail:"Add detail",
        //查看质检结果
        viewQualityInspectionResults:"View quality inspection results",
        //当前功能正在开发
        currentFunctionIsDeveloping:"Current function is developing",
        //运输扫码
        transportScanCode:"Transport scan code",
        //提交生产安排
        submitProductionArrangement:"Submit production arrangement",
        //添加成功
        addSuccess:"Add success",
        //请填写条形码
        pleaseEnterBarcode:"Please enter barcode",
        //条形码不存在
        barcodeDoesNotExist:"Barcode does not exist",
        //确认成功
        confirmSuccess:"Confirm success",
        //是
        yes:"Yes",
        //否
        no:"No",
    },
    //成品交接
    FinishedProductHandover:{
        finishedProductHandover: "成品交接",
    },
    plate:{
        confirmTitle: "Prompt",
        confirmContent:'Do you want to copy the current step?',
        confirmDeleteContent: "Do you want to delete the current step?",
    },
    reportFormsConfig:{
        id: 'id',
        name: 'name',
        note: 'note',
        stats: 'stats',
        sqlContent: 'sqlContent',
        createTime: 'createTime',
        createBy: 'createBy',
        testSql: 'testSql',
        reportFormsConfigItem: 'reportFormsConfigItem',
        fieldContent: 'fieldContent',
        typeContent: 'typeContent',
    },
    ReportForms:{
        ReportFormsItem: '报表明细',
    }
}

